import UnifiedMessagesModule from "../components/UnifiedMessagesModule";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";


// Yalnızca telefon ve tablet görünümünü sıkılaştırır.
// Masaüstü stilleri, veri akışı ve işlem fonksiyonları değiştirilmez.
function useMobileOnlyResponsiveLayout(scopeClass, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return undefined;

    const bodyClass = `${scopeClass}-active`;
    const styleId = `${scopeClass}-style`;
    document.body.classList.add(bodyClass);

    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      const scope = `body.${bodyClass}`;

      style.textContent = `
        @media (max-width: 1023px) {
          ${scope},
          ${scope} #root {
            width: 100%;
            max-width: 100%;
            overflow-x: hidden;
          }

          ${scope} main {
            width: 100%;
            min-width: 0;
            max-width: 100vw;
          }

          ${scope} table {
            display: block;
            width: 100%;
            max-width: 100%;
            overflow-x: auto;
            overscroll-behavior-inline: contain;
            -webkit-overflow-scrolling: touch;
          }

          ${scope} iframe,
          ${scope} video,
          ${scope} canvas {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            overflow-y: auto;
            overscroll-behavior: contain;
          }
        }

        @media (max-width: 767px) {
          ${scope} {
            font-size: 13px;
            -webkit-text-size-adjust: 100%;
            text-size-adjust: 100%;
          }

          ${scope} *,
          ${scope} *::before,
          ${scope} *::after {
            box-sizing: border-box;
          }

          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: clamp(1.7rem, 7.5vw, 2rem) !important;
            line-height: 1.12 !important;
            letter-spacing: -0.025em !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: clamp(1.35rem, 5.8vw, 1.6rem) !important;
            line-height: 1.18 !important;
          }

          ${scope} h3,
          ${scope} [class~="text-2xl"] {
            font-size: 1.15rem !important;
            line-height: 1.25 !important;
          }

          ${scope} [class~="text-xl"] {
            font-size: 1rem !important;
            line-height: 1.35 !important;
          }

          ${scope} p,
          ${scope} li {
            line-height: 1.55;
          }

          ${scope} [class~="p-10"],
          ${scope} [class~="p-9"],
          ${scope} [class~="p-8"],
          ${scope} [class~="p-7"],
          ${scope} [class~="p-6"],
          ${scope} [class~="p-5"] {
            padding: 1rem !important;
          }

          ${scope} [class~="px-10"],
          ${scope} [class~="px-9"],
          ${scope} [class~="px-8"],
          ${scope} [class~="px-7"],
          ${scope} [class~="px-6"],
          ${scope} [class~="px-5"] {
            padding-left: 1rem !important;
            padding-right: 1rem !important;
          }

          ${scope} [class~="py-10"],
          ${scope} [class~="py-9"],
          ${scope} [class~="py-8"],
          ${scope} [class~="py-7"],
          ${scope} [class~="py-6"] {
            padding-top: 1rem !important;
            padding-bottom: 1rem !important;
          }

          ${scope} [class~="gap-10"],
          ${scope} [class~="gap-9"],
          ${scope} [class~="gap-8"],
          ${scope} [class~="gap-7"],
          ${scope} [class~="gap-6"],
          ${scope} [class~="gap-5"] {
            gap: 0.8rem !important;
          }

          ${scope} [class~="mt-10"],
          ${scope} [class~="mt-9"],
          ${scope} [class~="mt-8"],
          ${scope} [class~="mt-7"],
          ${scope} [class~="mt-6"] {
            margin-top: 1rem !important;
          }

          ${scope} [class~="mb-10"],
          ${scope} [class~="mb-9"],
          ${scope} [class~="mb-8"],
          ${scope} [class~="mb-7"],
          ${scope} [class~="mb-6"] {
            margin-bottom: 1rem !important;
          }

          ${scope} [class*="grid-cols-2"],
          ${scope} [class*="grid-cols-3"],
          ${scope} [class*="grid-cols-4"],
          ${scope} [class*="grid-cols-5"],
          ${scope} [class*="grid-cols-6"],
          ${scope} [class*="grid-cols-["] {
            grid-template-columns: minmax(0, 1fr) !important;
          }

          ${scope} form [class~="flex"] {
            flex-wrap: wrap;
          }

          ${scope} button,
          ${scope} [role="button"] {
            max-width: 100%;
            min-height: 38px;
            white-space: normal;
            touch-action: manipulation;
          }

          ${scope} input,
          ${scope} select,
          ${scope} textarea {
            width: 100%;
            max-width: 100%;
            min-height: 42px;
            font-size: 16px !important;
          }

          ${scope} textarea {
            min-height: 96px;
          }

          ${scope} table {
            font-size: 11px;
          }

          ${scope} th,
          ${scope} td {
            padding: 0.55rem 0.65rem !important;
            white-space: nowrap;
          }

          ${scope} svg[class*="h-["],
          ${scope} canvas[class*="h-["] {
            height: 230px !important;
            max-height: 42vh;
          }

          ${scope} iframe {
            min-height: 230px !important;
            height: 48vh !important;
          }

          ${scope} video {
            max-height: 52vh;
          }

          ${scope} img {
            max-width: 100%;
          }

          ${scope} [class*="fixed"][class*="inset-0"] {
            align-items: flex-start !important;
            padding: max(0.75rem, env(safe-area-inset-top)) 0.75rem max(0.75rem, env(safe-area-inset-bottom)) !important;
          }

          ${scope} [class*="fixed"][class*="inset-0"] > [class*="max-w-"] {
            width: 100% !important;
            max-width: 100% !important;
            max-height: calc(100dvh - 1.5rem) !important;
            margin: auto !important;
            overflow-y: auto !important;
          }

          ${scope} [class*="rounded-[2"],
          ${scope} [class*="rounded-[3"] {
            border-radius: 1.1rem !important;
          }

          ${scope} [class*="tracking-[0.3"],
          ${scope} [class*="tracking-[0.4"] {
            letter-spacing: 0.16em !important;
          }

          ${scope} [class*="max-w-7xl"],
          ${scope} [class*="max-w-6xl"],
          ${scope} [class*="max-w-5xl"],
          ${scope} [class*="max-w-4xl"],
          ${scope} [class*="max-w-3xl"] {
            max-width: 100% !important;
          }
        }

        @media (max-width: 380px) {
          ${scope} h1,
          ${scope} [class~="text-5xl"],
          ${scope} [class~="text-4xl"] {
            font-size: 1.55rem !important;
          }

          ${scope} h2,
          ${scope} [class~="text-3xl"] {
            font-size: 1.25rem !important;
          }

          ${scope} button,
          ${scope} [role="button"] {
            font-size: 11px !important;
          }
        }
      `;

      document.head.appendChild(style);
    }

    return () => {
      document.body.classList.remove(bodyClass);
    };
  }, [scopeClass, enabled]);
}
const IS_LOCAL =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const API_BASE = IS_LOCAL ? "https://wolfmediaajans.com" : "";

const API_LIST = `${API_BASE}/api/scout-candidate-list.php`;
const API_SAVE = `${API_BASE}/api/scout-candidate-save.php`;
const API_STATUS_UPDATE = `${API_BASE}/api/scout-candidate-status-update.php`;
const API_MESSAGE_TEMPLATES = `${API_BASE}/api/scout-message-templates.php`;
const API_FOLLOWUP_LIST = `${API_BASE}/api/scout-followup-list.php`;
const API_FOLLOWUP_SAVE = `${API_BASE}/api/scout-followup-save.php`;
const API_MANAGER_ASSIGN = `${API_BASE}/api/scout-manager-assign.php`;

// Lokal geliştirmede canlı veriye yanlışlıkla yazmayı engeller.
// Yayına alırken localhost olmadığı için otomatik olarak false olur.
const LOCAL_DEMO_MODE = IS_LOCAL;
const FOLLOWUP_DAY_COUNT = 15;

function parseApiDate(value) {
  if (!value) return null;
  const text = String(value).trim().replace(" ", "T");
  const date = new Date(text);
  return Number.isNaN(date.getTime()) ? null : date;
}

function toStartOfDay(value) {
  const date = value instanceof Date ? new Date(value) : parseApiDate(value);
  if (!date) return null;
  date.setHours(0, 0, 0, 0);
  return date;
}

function addDays(value, days) {
  const date = value instanceof Date ? new Date(value) : parseApiDate(value);
  if (!date) return null;
  date.setDate(date.getDate() + days);
  return date;
}

function diffDays(fromDate, toDate) {
  const oneDay = 1000 * 60 * 60 * 24;
  const from = toStartOfDay(fromDate);
  const to = toStartOfDay(toDate);
  if (!from || !to) return 0;
  return Math.floor((to - from) / oneDay);
}

function getFollowUpState(candidate) {
  if (!candidate?.joined_at) {
    return {
      active: false,
      completed: false,
      remainingDays: null,
      endDate: null,
      label: "Scout Aşaması",
    };
  }

  const joined = toStartOfDay(candidate.joined_at);
  const today = toStartOfDay(new Date());
  if (!joined || !today) {
    return {
      active: false,
      completed: false,
      remainingDays: null,
      endDate: null,
      label: "Tarih Hatası",
    };
  }

  const passed = Math.max(0, diffDays(joined, today));
  const remainingDays = Math.max(0, FOLLOWUP_DAY_COUNT - passed);
  const endDate = addDays(joined, FOLLOWUP_DAY_COUNT);
  const completed = remainingDays === 0;

  return {
    active: !completed,
    completed,
    remainingDays,
    endDate,
    label: completed
      ? "Yönetici Atama Bekliyor"
      : `Yeni Yayıncı • ${remainingDays} Gün Kaldı`,
  };
}

function getLifecycleStage(candidate) {
  const followUp = getFollowUpState(candidate);

  if (candidate?.manager_username) return "yonetici_takibinde";
  if (followUp.completed) return "yonetici_atama_bekliyor";
  if (candidate?.joined_at) return "yeni_yayinci_takipte";
  return "scout_asamasi";
}

function canAssignManager(user) {
  const role = String(user?.role || "").toLowerCase().trim();
  return ["admin", "master_admin", "scout_manager"].includes(role);
}

const todayIso = new Date().toISOString().slice(0, 10);

const statusOptions = [
  { key: "kesif_havuzu", label: "Keşif Havuzu" },
  { key: "yayina_katildik", label: "Yayınına Katıldık" },
  { key: "iletisim_kuruldu", label: "İletişim Kuruldu" },
  { key: "davet_gonderildi", label: "Davet Gönderildi" },
  { key: "reddetti", label: "Reddetti" },
  { key: "ajansa_katildi", label: "Ajansa Katıldı" },
  { key: "uygun_degil", label: "Uygun Değil" },
];

const suitabilityOptions = [
  { key: "beklemede", label: "⏳ Beklemede / İncelenmedi" },
  { key: "uygun", label: "✅ Mevcut (Ajanssız)" },
  { key: "baska_ajansa_bagli", label: "⛔ Başka Bir Ajansta (YASAK)" },
  { key: "desteklenmeyen_bolge", label: "🌍 Desteklenmeyen Bölge" },
  { key: "soguma_doneminde", label: "⏳ 180 Gün Süresi Var" },
  { key: "uygun_degil", label: "❌ Uygun Değil / Kriter Dışı" },
];

const processStatusOptions = {
  evaluation_status: [
    { key: "degerlendiriliyor", label: "Değerlendiriliyor" },
    { key: "tamamlandi", label: "Tamamlandı" },
  ],
  live_review_status: [
    { key: "planlandi", label: "Planlandı" },
    { key: "incelendi", label: "İncelendi" },
  ],
  contact_status: [
    { key: "geri_donus_bekleniyor", label: "Geri Dönüş Bekleniyor" },
    { key: "kuruldu", label: "Kuruldu" },
    { key: "ulasilamadi", label: "Ulaşılamadı" },
  ],
  profile_note_status: [
    { key: "eklendi", label: "Eklendi" },
    { key: "guncellenecek", label: "Güncellenecek" },
  ],
  rejection_status: [
    { key: "reddedildi", label: "Reddedildi" },
    { key: "uygun_degil", label: "Uygun Değil" },
  ],
  agency_join_status: [
    { key: "beklemede", label: "Beklemede" },
    { key: "evet", label: "Evet" },
  ],
};

const leagueOptions = [
  "A1", "A2", "A3",
  "B1", "B2", "B3", "B4", "B5",
  "C1", "C2", "C3", "C4", "C5",
  "D1", "D2", "D3", "D4", "D5",
];

const publisherExperienceOptions = [
  { key: "baslangic_seviyesi_yayinci", label: "Başlangıç Seviyesi Yayıncı (30 Gün Altı)" },
  { key: "yeni_yayinci", label: "Yeni Yayıncı (1-3 Ay)" },
  { key: "normal_yayinci", label: "Normal Yayıncı (3 Ay - 1 Yıl)" },
  { key: "eski_yayinci", label: "Eski Yayıncı (1 Yıl ve Üzeri)" },
];

const categoryOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const messageCategoryOptions = [
  {
    key: "pre_join",
    label: "Ajansa Katılım Öncesi",
    desc: "İlk davet, takip, görüşme ve ajansa katılım öncesi kullanılacak mesajlar.",
  },
  {
    key: "publisher_questions",
    label: "Yayıncı Soru / Bilgilendirme",
    desc: "Yayıncıların sık sorduğu konulara verilecek net ve güvenli cevaplar.",
  },
  {
    key: "recovery",
    label: "Red / Kararsız Geri Kazanım",
    desc: "Reddeden, düşüneceğini söyleyen veya kararsız kalan adaylar için geri kazanım mesajları.",
  },
];

const defaultMessageTemplates = [
  {
    id: "default-pre-1",
    category: "pre_join",
    title: "İlk Davet Mesajı",
    body:
      "Merhaba {aday}, Wolf Media Ajans olarak yayınlarınızı inceledik. Yayın enerjiniz ve kitle iletişiminizin ajansımız için uygun olabileceğini düşünüyoruz. Uygun olduğunuzda kısa bir görüşme yaparak iş birliği sürecimizi sizinle paylaşmak isteriz.",
    sort_order: 10,
  },
  {
    id: "default-pre-2",
    category: "pre_join",
    title: "Takip Mesajı",
    body:
      "Merhaba {aday}, daha önce ilettiğimiz ajans görüşmesi hakkında müsait olduğunuzda kısa bir dönüş rica ederiz. Süreçle ilgili sorularınız varsa memnuniyetle yanıtlayabiliriz.",
    sort_order: 20,
  },
  {
    id: "default-pre-3",
    category: "pre_join",
    title: "Katılım Öncesi Bilgilendirme",
    body:
      "Merhaba {aday}, görüşmemiz doğrultusunda Wolf Media Ajans katılım süreciniz için gerekli adımları sizinle paylaşmak isteriz. Uygun olduğunuzda başvuru ve değerlendirme sürecinizi birlikte tamamlayabiliriz.",
    sort_order: 30,
  },
  {
    id: "default-question-1",
    category: "publisher_questions",
    title: "Ajans Süreci Hakkında Bilgilendirme",
    body:
      "Merhaba {aday}, ajans sürecimiz yayın düzeni, performans takibi, içerik yönlendirmesi ve operasyonel destek başlıkları üzerinden ilerlemektedir. Sizin yayın alışkanlığınızı değerlendirdikten sonra en uygun yönlendirmeyi paylaşacağız.",
    sort_order: 40,
  },
  {
    id: "default-question-2",
    category: "publisher_questions",
    title: "Eğitim ve Ekipman Desteği Cevabı",
    body:
      "Merhaba {aday}, yayın gelişiminiz için eğitim ihtiyacı, yayın düzeni ve ekipman desteği konularını ayrıca değerlendirebiliriz. Mevcut yayın akışınızı gördükten sonra size en uygun gelişim planını paylaşacağız.",
    sort_order: 50,
  },
  {
    id: "default-recovery-1",
    category: "recovery",
    title: "Red Sonrası Geri Kazanım Mesajı",
    body:
      "Sayın {aday}, ajansımız tarafından yapılan değerlendirme sonucu {red_tarihi} tarihinde ajansımıza katılmayı reddetmişsiniz. Yorumlarınız bizim için kıymetlidir. Varsa süreç hakkındaki şikayetlerinizi almak ve yeniden değerlendirmeniz için sizinle bir görüşme yapmak istiyoruz.",
    sort_order: 60,
  },
  {
    id: "default-recovery-2",
    category: "recovery",
    title: "Kararsız Yayıncı Takip Mesajı",
    body:
      "Merhaba {aday}, ajans süreciyle ilgili kararınızı daha sonra değerlendirmek istediğinizi iletmiştiniz. Sizin için uygun olursa süreci tekrar konuşmak ve varsa soru işaretlerinizi netleştirmek isteriz.",
    sort_order: 70,
  },
];


const emptyForm = {
  tiktok_username: "",
  candidate_league: "",
  publisher_experience: "",
  profile_url: "",
  category: "",
  first_note: "",
  risk_note: "",
  status: "kesif_havuzu",
  suitability_status: "beklemede",
  suitability_note: "",
  live_joined_note: "",
  contact_note: "",
  publisher_about_note: "",
  rejection_note: "",
  agency_join_note: "",
  evaluation_status: "",
  live_review_status: "",
  contact_status: "",
  profile_note_status: "",
  rejection_status: "",
  agency_join_status: "",
  hidden_id: "",
  phone: "",
  joined_at: "",
  manager_user_id: "",
  manager_username: "",
  manager_assigned_at: "",
};

const demoRows = [
  {
    id: 9001,
    tiktok_username: "@mirayxx",
    category: "1",
    phone: "",
    status: "kesif_havuzu",
    suitability_status: "beklemede",
    suitability_note: "",
    live_joined_note: "",
    contact_note: "",
    publisher_about_note: "Yayın enerjisi yüksek, eğitim ihtiyacı olabilir.",
    rejection_note: "",
    agency_join_note: "",
    evaluation_status: "",
    live_review_status: "",
    contact_status: "",
    profile_note_status: "eklendi",
    rejection_status: "",
    agency_join_status: "",
    hidden_id: "",
    candidate_league: "A1",
    publisher_experience: "baslangic_seviyesi_yayinci",
    profile_image_url: "",
    profile_image_source: "avatar",
    owner_username: "zafer",
    created_by_username: "zafer",
    created_at: `${todayIso} 10:00:00`,
    updated_at: `${todayIso} 10:15:00`,
    joined_at: "",
    manager_user_id: "",
    manager_username: "",
    manager_assigned_at: "",
    follow_up_logs: [],
  },
];

function daysAgoIso(days) {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date.toISOString().slice(0, 10);
}

function formatNumber(value) {
  return Number(value || 0).toLocaleString("tr-TR");
}

function getInitial(username) {
  return String(username || "?").replace("@", "").charAt(0).toUpperCase() || "?";
}

function formatPersonName(value) {
  const text = String(value || "Scout").trim();
  if (!text) return "Scout";

  return text
    .split(/\s+/)
    .map((word) => {
      const first = word.charAt(0).toLocaleUpperCase("tr-TR");
      const rest = word.slice(1).toLocaleLowerCase("tr-TR");
      return `${first}${rest}`;
    })
    .join(" ");
}

function normalizeUsernameValue(value) {
  let text = String(value || "").trim().toLowerCase();
  if (!text) return "";

  if (text.includes("tiktok.com")) {
    try {
      const url = new URL(text.startsWith("http") ? text : `https://${text}`);
      const segment = url.pathname
        .split("/")
        .map((item) => item.trim())
        .find((item) => item.startsWith("@"));
      if (segment) text = segment;
    } catch {
      // Link parse edilemezse aşağıdaki temizleme çalışır.
    }
  }

  return text.replace(/^@+/, "").replace(/[^a-z0-9._]/g, "");
}

function formatDateTr(value) {
  if (!value) return "belirtilmeyen bir tarihte";
  const text = String(value).slice(0, 10);
  const parts = text.split("-");
  if (parts.length !== 3) return text;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}

function buildRecoveryMessage(candidate) {
  const username = candidate?.tiktok_username || "yayıncı adayımız";
  const dateText = formatDateTr(candidate?.rejected_at || candidate?.updated_at || candidate?.created_at);

  return `Sayın ${username}, ajansımız tarafından yapılan değerlendirme sonucu ${dateText} tarihinde ajansımıza katılmayı reddetmişsiniz. Yorumlarınız bizim için kıymetlidir. Varsa süreç hakkında şikayetlerinizi almak ve yeniden değerlendirmeniz için sizinle bir görüşme yapmak istiyoruz.`;
}

function getDuplicateCandidateMessage(rows, form, editingCandidate) {
  if (editingCandidate?.id) return "";

  const normalized = normalizeUsernameValue(form?.tiktok_username || form?.profile_url);
  if (!normalized) return "";

  const duplicate = rows.find((item) => {
    const candidateNormalized = normalizeUsernameValue(
      item.normalized_username || item.tiktok_username || item.profile_url
    );
    return candidateNormalized === normalized;
  });

  if (!duplicate) return "";

  if (String(duplicate.is_blacklisted || "") === "1") {
    return "Bu kullanıcı kara listede görünüyor. Aynı kullanıcı adı tekrar eklenemez.";
  }

  if (duplicate.status === "reddetti" || duplicate.rejection_note) {
    return "Bu kullanıcı daha önce reddeden aday olarak Takip Geri Kazanım listesinde görünüyor. Aynı kullanıcı adı tekrar eklenemez.";
  }

  return "Bu kullanıcı adı zaten scout takip listesinde yer alıyor. Aynı kullanıcı adı tekrar eklenemez.";
}

function getStatusLabel(key) {
  return statusOptions.find((item) => item.key === key)?.label || key || "-";
}

function getSuitabilityLabel(key) {
  return suitabilityOptions.find((item) => item.key === key)?.label || key || "Beklemede";
}

function getProcessStatusLabel(field, key) {
  if (!key) return "";
  return processStatusOptions[field]?.find((item) => item.key === key)?.label || key;
}

function inferProcessStatus(candidate, field) {
  const direct = String(candidate?.[field] || "").trim();
  if (direct) return direct;

  if (field === "evaluation_status" && candidate?.suitability_note) return "tamamlandi";
  if (
    field === "live_review_status" &&
    (candidate?.live_joined_note ||
      candidate?.live_joined_at ||
      ["yayina_katildik", "iletisim_kuruldu", "davet_gonderildi", "reddetti", "ajansa_katildi"].includes(candidate?.status))
  ) return "incelendi";
  if (
    field === "contact_status" &&
    (candidate?.phone ||
      candidate?.contact_note ||
      candidate?.contact_at ||
      ["iletisim_kuruldu", "davet_gonderildi", "reddetti", "ajansa_katildi"].includes(candidate?.status))
  ) return "kuruldu";
  if (field === "profile_note_status" && candidate?.publisher_about_note) return "eklendi";
  if (field === "rejection_status") {
    if (candidate?.status === "uygun_degil") return "uygun_degil";
    if (candidate?.rejection_note || candidate?.rejected_at || candidate?.status === "reddetti") return "reddedildi";
  }
  if (
    field === "agency_join_status" &&
    (candidate?.hidden_id || candidate?.joined_at || candidate?.status === "ajansa_katildi")
  ) return "evet";

  return "";
}

function getProcessDisplayValue(candidate, noteField, statusField) {
  const customText = String(candidate?.[noteField] || "").trim();
  if (customText) return customText;
  const status = inferProcessStatus(candidate, statusField);
  return getProcessStatusLabel(statusField, status) || "-";
}

function getPublisherExperienceLabel(key) {
  return (
    publisherExperienceOptions.find((item) => item.key === key)?.label ||
    "Yayıncılık süresi yok"
  );
}

function isA1ToB3League(league) {
  return ["A1", "A2", "A3", "B1", "B2", "B3"].includes(String(league || ""));
}

function isALeague(league) {
  return String(league || "").charAt(0).toUpperCase() === "A";
}

function isPriorityCandidate(item) {
  const experience = String(item?.publisher_experience || "");
  const league = String(item?.candidate_league || "");

  if (experience === "baslangic_seviyesi_yayinci") return true;
  if (experience === "yeni_yayinci" && isA1ToB3League(league)) return true;

  if (["normal_yayinci", "eski_yayinci"].includes(experience) && isALeague(league)) {
    return true;
  }

  return false;
}

function isToday(dateValue) {
  if (!dateValue) return false;
  return String(dateValue).slice(0, 10) === todayIso;
}

function safeUser() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user) return user;
  } catch {
    //
  }

  if (IS_LOCAL) {
    return {
      id: 1,
      username: "zafer",
      fullName: "Zafer Akan",
      role: "admin",
    };
  }

  return {};
}

function isAdminLike(user) {
  const role = String(user?.role || "").toLowerCase().trim();
  return ["admin", "master_admin", "scout_manager", "manager"].includes(role);
}

function canEditCandidate(user, candidate) {
  if (isAdminLike(user)) return true;
  return (
    String(candidate?.owner_username || candidate?.created_by_username || "") ===
    String(user?.username || "")
  );
}

function normalizeFormFromCandidate(candidate) {
  if (!candidate) return { ...emptyForm };

  return {
    ...emptyForm,
    id: candidate.id,
    tiktok_username: candidate.tiktok_username || "",
    candidate_league: candidate.candidate_league || "",
    publisher_experience: candidate.publisher_experience || "",
    profile_url: candidate.profile_url || "",
    category: candidate.category || "",
    first_note: candidate.first_note || "",
    risk_note: candidate.risk_note || "",
    status: candidate.status || "kesif_havuzu",
    suitability_status: candidate.suitability_status || "beklemede",
    suitability_note: candidate.suitability_note || "",
    live_joined_note: candidate.live_joined_note || "",
    contact_note: candidate.contact_note || "",
    publisher_about_note: candidate.publisher_about_note || "",
    rejection_note: candidate.rejection_note || "",
    agency_join_note: candidate.agency_join_note || "",
    evaluation_status: candidate.evaluation_status || "",
    live_review_status: candidate.live_review_status || "",
    contact_status: candidate.contact_status || "",
    profile_note_status: candidate.profile_note_status || "",
    rejection_status: candidate.rejection_status || "",
    agency_join_status: candidate.agency_join_status || "",
    hidden_id: candidate.hidden_id || "",
    phone: candidate.phone || "",
    joined_at: candidate.joined_at || "",
    manager_user_id: candidate.manager_user_id || "",
    manager_username: candidate.manager_username || "",
    manager_assigned_at: candidate.manager_assigned_at || "",
  };
}


function getInitialScoutTheme() {
  if (typeof window === "undefined") return "light";

  const saved = localStorage.getItem("scout-center-theme");
  if (saved === "light" || saved === "dark") return saved;

  return "light";
}

const ADMIN_THEME_STYLES = `
  .wm-admin-theme {
    --admin-gold: #d6a800;
    --admin-gold-dark: #9b7600;
    --admin-gold-soft: #fff8df;
    --admin-page: #f4f6f8;
    --admin-surface: #ffffff;
    --admin-surface-soft: #f8fafc;
    --admin-text: #182230;
    --admin-text-soft: #475467;
    --admin-muted: #667085;
    --admin-border: #d9dee7;
  }

  /* Tema anahtarı */
  .wm-admin-theme-switch {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px;
    border: 1px solid rgba(255,255,255,.10);
    border-radius: 12px;
    background: rgba(255,255,255,.035);
  }

  .wm-admin-theme-button {
    min-height: 32px;
    padding: 0 11px;
    border: 1px solid transparent;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 700;
    transition: background-color .15s ease, color .15s ease, border-color .15s ease;
  }

  .wm-admin-dark .wm-admin-theme-button {
    color: rgba(255,255,255,.55);
  }

  .wm-admin-dark .wm-admin-theme-button.is-active {
    background: #eab308;
    border-color: rgba(250,204,21,.55);
    color: #080808;
  }

  /* ================================================================
     AÇIK TEMA
     Mevcut JSX, API, state ve işlem fonksiyonlarına dokunmaz.
     ================================================================ */
  .wm-admin-light {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
    color-scheme: light;
  }

  /* Koyu temanın dekoratif sabit arka planlarını açık modda gizle.
     z-50 modal overlay'leri etkilenmez. */
  .wm-admin-light > .fixed.inset-0:not(.z-50) {
    display: none !important;
  }

  .wm-admin-light main {
    background: var(--admin-page) !important;
    color: var(--admin-text) !important;
  }

  .wm-admin-light aside {
    background: #ffffff !important;
    border-color: var(--admin-border) !important;
    box-shadow: 1px 0 0 rgba(16,24,40,.03);
  }

  /* Ana yüzeyler */
  .wm-admin-light [class*="bg-white/"] {
    background-color: var(--admin-surface) !important;
  }

  .wm-admin-light [class*="bg-black/"]:not([class*="fixed"]) {
    background-color: var(--admin-surface-soft) !important;
  }

  .wm-admin-light [class*="bg-[#070707]"],
  .wm-admin-light [class*="bg-[#080808]"],
  .wm-admin-light [class*="bg-[#090909]"],
  .wm-admin-light [class*="bg-[#0a0a0a]"],
  .wm-admin-light [class*="bg-[#0b0b0b]"],
  .wm-admin-light [class*="bg-[#101010]"] {
    background-color: #ffffff !important;
  }

  /* Modal overlay koyu kalır, modal kartı açık olur */
  .wm-admin-light [class*="fixed"][class*="inset-0"][class*="bg-black"] {
    background-color: rgba(15,23,42,.48) !important;
  }

  .wm-admin-light [class*="fixed"][class*="inset-0"] > [class*="bg-[#0b0b0b]"] {
    background-color: #ffffff !important;
  }

  /* Yazılar */
  .wm-admin-light [class~="text-white"] {
    color: var(--admin-text) !important;
  }

  .wm-admin-light [class*="text-white/"] {
    color: var(--admin-muted) !important;
  }

  .wm-admin-light [class*="text-yellow-"] {
    color: var(--admin-gold-dark) !important;
  }

  .wm-admin-light [class*="fill-white"] {
    fill: #667085 !important;
  }

  .wm-admin-light [class*="fill-yellow"] {
    fill: #9b7600 !important;
  }

  /* Border'lar */
  .wm-admin-light [class*="border-white"] {
    border-color: var(--admin-border) !important;
  }

  .wm-admin-light [class*="border-yellow-"] {
    border-color: rgba(183,137,0,.34) !important;
  }

  /* Gold soft alanlar */
  .wm-admin-light [class*="bg-yellow-500/"],
  .wm-admin-light [class*="bg-yellow-400/"] {
    background-color: var(--admin-gold-soft) !important;
  }

  /* Ana gold butonlar orijinal karakterini korur */
  .wm-admin-light [class~="bg-yellow-500"] {
    background-color: #eab308 !important;
    color: #111111 !important;
    border-color: #d6a800 !important;
  }

  .wm-admin-light [class~="hover:bg-yellow-500"]:hover,
  .wm-admin-light [class~="hover:bg-yellow-400"]:hover {
    background-color: #facc15 !important;
    color: #111111 !important;
  }

  /* Semantik renkler açık zeminde okunaklı */
  .wm-admin-light [class*="text-green-"],
  .wm-admin-light [class*="text-emerald-"] {
    color: #067647 !important;
  }

  .wm-admin-light [class*="bg-green-"],
  .wm-admin-light [class*="bg-emerald-"] {
    background-color: #ecfdf3 !important;
  }

  .wm-admin-light [class*="border-green-"],
  .wm-admin-light [class*="border-emerald-"] {
    border-color: #abefc6 !important;
  }

  .wm-admin-light [class*="text-red-"] {
    color: #b42318 !important;
  }

  .wm-admin-light [class*="bg-red-"] {
    background-color: #fef3f2 !important;
  }

  .wm-admin-light [class*="border-red-"] {
    border-color: #fecdca !important;
  }

  .wm-admin-light [class*="text-fuchsia-"] {
    color: #8b3fa4 !important;
  }

  .wm-admin-light [class*="bg-fuchsia-"] {
    background-color: #fdf4ff !important;
  }

  .wm-admin-light [class*="border-fuchsia-"] {
    border-color: #f0abfc !important;
  }

  .wm-admin-light [class*="text-cyan-"] {
    color: #0e7490 !important;
  }

  .wm-admin-light [class*="bg-cyan-"] {
    background-color: #ecfeff !important;
  }

  .wm-admin-light [class*="border-cyan-"] {
    border-color: #a5f3fc !important;
  }

  /* Form alanları */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background: #ffffff !important;
    color: var(--admin-text) !important;
    border-color: #cfd6df !important;
    color-scheme: light !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #98a2b3 !important;
  }

  .wm-admin-light input:focus,
  .wm-admin-light select:focus,
  .wm-admin-light textarea:focus,
  .wm-admin-light .form-input:focus,
  .wm-admin-light .form-textarea:focus {
    border-color: #c99a12 !important;
    box-shadow: 0 0 0 3px rgba(201,154,18,.10) !important;
  }

  .wm-admin-light option {
    background: #ffffff !important;
    color: #182230 !important;
  }

  /* Kart ve tablo hiyerarşisi */
  .wm-admin-light [class*="shadow-[0_18px"],
  .wm-admin-light [class*="shadow-[0_20px"] {
    box-shadow:
      0 1px 2px rgba(16,24,40,.03),
      0 8px 24px rgba(16,24,40,.055) !important;
  }

  .wm-admin-light [class*="uppercase"][class*="bg-white/"] {
    background-color: #f7f8fa !important;
  }

  .wm-admin-light [class*="hover:bg-white"]:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light [class*="hover:bg-yellow"]:hover {
    background-color: #fff9e8 !important;
  }

  /* Accordion / aktif menü */
  .wm-admin-light aside button {
    color: #344054;
  }

  .wm-admin-light aside button:hover {
    background-color: #f8fafc !important;
  }

  .wm-admin-light aside [class*="bg-yellow-500/"] {
    background-color: #fff8df !important;
    color: #8a6800 !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Grafik ve koyu özel yüzeyleri açık moda taşı */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(circle at top right, rgba(234,179,8,.10), transparent 30%),
      linear-gradient(180deg,#ffffff 0%,#f4f6f8 100%) !important;
  }

  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.72) !important;
  }

  /* Tema anahtarı açık mod */
  .wm-admin-light .wm-admin-theme-switch {
    background: #eef1f5;
    border-color: #d9dee7;
  }

  .wm-admin-light .wm-admin-theme-button {
    color: #667085;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff;
    border-color: #d7b64a;
    color: #9b7600;
    box-shadow: 0 1px 3px rgba(16,24,40,.08);
  }

  /* Scrollbar */
  .wm-admin-light * {
    scrollbar-color: rgba(183,137,0,.50) #eef1f4;
  }

  /* ================================================================
     AÇIK TEMA V3
     Sadece görsel katman:
     - Yazılar daha net ve koyu
     - Kart/kutu yüzeyleri yumuşak geçişli gri
     - Mevcut işlev, API, state ve JSX akışı değiştirilmez
     ================================================================ */

  .wm-admin-light {
    --admin-page: #eef2f6;
    --admin-surface: #f6f8fa;
    --admin-surface-soft: #e9eef3;
    --admin-text: #101828;
    --admin-text-soft: #1d2939;
    --admin-muted: #475467;
    --admin-border: #cbd5df;
  }

  /* Genel zemin */
  .wm-admin-light,
  .wm-admin-light main {
    background:
      linear-gradient(
        180deg,
        #f4f6f8 0%,
        #eef2f5 45%,
        #e8edf2 100%
      ) !important;
  }

  /* Başlıklar ve ana metinler daha net */
  .wm-admin-light h1,
  .wm-admin-light h2,
  .wm-admin-light h3,
  .wm-admin-light h4,
  .wm-admin-light [class~="text-white"] {
    color: #101828 !important;
  }

  .wm-admin-light [class*="text-white/82"],
  .wm-admin-light [class*="text-white/80"],
  .wm-admin-light [class*="text-white/78"],
  .wm-admin-light [class*="text-white/68"],
  .wm-admin-light [class*="text-white/65"] {
    color: #1d2939 !important;
  }

  .wm-admin-light [class*="text-white/55"],
  .wm-admin-light [class*="text-white/48"],
  .wm-admin-light [class*="text-white/46"],
  .wm-admin-light [class*="text-white/45"],
  .wm-admin-light [class*="text-white/40"],
  .wm-admin-light [class*="text-white/35"],
  .wm-admin-light [class*="text-white/30"],
  .wm-admin-light [class*="text-white/25"] {
    color: #475467 !important;
  }

  /* Ana kartlar ve çerçeveli kutular:
     küçük badge/buton/uyarı renklerini bozmamak için yalnızca div yüzeyleri */
  .wm-admin-light div[class*="rounded-"][class*="border"]
    :not(button) {
  }

  .wm-admin-light div[class*="rounded-"][class*="border"]
    {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 48%,
        #e3e8ee 100%
      ) !important;
    border-color: #cbd4de !important;
    box-shadow:
      0 1px 2px rgba(16,24,40,.035),
      0 8px 24px rgba(16,24,40,.06) !important;
  }

  /* Semantik / durum kutuları kendi renklerini korusun */
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-red-"] {
    background: #fef3f2 !important;
    border-color: #fecdca !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-green-"],
  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-emerald-"] {
    background: #ecfdf3 !important;
    border-color: #abefc6 !important;
  }

  .wm-admin-light div[class*="rounded-"][class*="border"][class*="bg-yellow-"] {
    background:
      linear-gradient(
        180deg,
        #fff9e9 0%,
        #f7edc8 100%
      ) !important;
    border-color: rgba(183,137,0,.32) !important;
  }

  /* Header ve büyük ana paneller biraz daha belirgin */
  .wm-admin-light header[class*="rounded-"],
  .wm-admin-light main > div > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f8fafc 0%,
        #edf1f5 50%,
        #e1e7ed 100%
      ) !important;
    border-color: #c7d0da !important;
  }

  /* Stat kartlar */
  .wm-admin-light .grid > div[class*="rounded-"][class*="border"] {
    background:
      linear-gradient(
        180deg,
        #f7f9fb 0%,
        #edf1f5 52%,
        #e2e7ed 100%
      ) !important;
  }

  /* Form alanları daha okunaklı */
  .wm-admin-light input,
  .wm-admin-light select,
  .wm-admin-light textarea,
  .wm-admin-light .form-input,
  .wm-admin-light .form-textarea {
    background:
      linear-gradient(
        180deg,
        #ffffff 0%,
        #f4f7fa 100%
      ) !important;
    color: #101828 !important;
    border-color: #c7d0da !important;
  }

  .wm-admin-light input::placeholder,
  .wm-admin-light textarea::placeholder {
    color: #7d8999 !important;
  }

  /* Tablolar */
  .wm-admin-light thead {
    background:
      linear-gradient(
        180deg,
        #f5f7fa 0%,
        #e9eef3 100%
      ) !important;
  }

  .wm-admin-light tbody tr {
    background: rgba(247,249,251,.78) !important;
  }

  .wm-admin-light tbody tr:nth-child(even) {
    background: rgba(238,242,246,.92) !important;
  }

  .wm-admin-light tbody tr:hover {
    background: rgba(255,248,222,.70) !important;
  }

  /* Performans / grafik gibi radial-gradient kullanan büyük kutular */
  .wm-admin-light [class*="bg-[radial-gradient"] {
    background:
      radial-gradient(
        circle at top right,
        rgba(234,179,8,.10),
        transparent 26%
      ),
      linear-gradient(
        180deg,
        #edf1f5 0%,
        #e2e7ed 52%,
        #d8dee5 100%
      ) !important;
    border-color: #c5ced8 !important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.72),
      0 10px 28px rgba(16,24,40,.07) !important;
  }

  /* Grafik iç yüzeyi */
  .wm-admin-light svg > rect[fill="rgba(0,0,0,0.18)"] {
    fill: rgba(255,255,255,.78) !important;
  }

  .wm-admin-light svg [class*="fill-yellow-"] {
    fill: #8f6a00 !important;
  }

  /* Sol menü metinleri net */
  .wm-admin-light aside button,
  .wm-admin-light aside span {
    color: #253247;
  }

  /* Gold vurgular açık temada koyu ve belirgin */
  .wm-admin-light [class*="text-yellow-"] {
    color: #8f6a00 !important;
  }

  /* Butonlar arka plan gradyanlarından etkilenmesin */
  .wm-admin-light button[class*="bg-yellow-500"] {
    background: #eab308 !important;
    color: #101010 !important;
    border-color: #d6a800 !important;
    box-shadow: none !important;
  }

  .wm-admin-light button[class*="bg-white"],
  .wm-admin-light button[class*="bg-black"],
  .wm-admin-light button[class*="bg-[#"] {
    background: #f8fafc !important;
    color: #1d2939 !important;
    border-color: #cbd5df !important;
  }

  /* Tema seçici */
  .wm-admin-light .wm-admin-theme-switch {
    background:
      linear-gradient(180deg,#f3f6f9 0%,#e5eaf0 100%) !important;
    border-color: #cbd5df !important;
  }

  .wm-admin-light .wm-admin-theme-button {
    background: transparent !important;
    color: #667085 !important;
    box-shadow: none !important;
  }

  .wm-admin-light .wm-admin-theme-button.is-active {
    background: #ffffff !important;
    color: #8f6a00 !important;
    border-color: #d7b64a !important;
    box-shadow: 0 1px 3px rgba(16,24,40,.08) !important;
  }

`;

function useScoutThemeStyles(theme) {
  useEffect(() => {
    const styleId = "wm-scout-admin-theme-style";
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement("style");
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = ADMIN_THEME_STYLES + `
      /* Ek Scout Tablo & Bileşen Düzenlemeleri */
      .wm-admin-light .scout-detail-panel,
      .wm-admin-light .scout-dashboard-panel,
      .wm-admin-light .scout-stat-card {
        background: #ffffff !important;
        border-color: #cbd5e1 !important;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
        color: #000000 !important;
      }

      .wm-admin-light main {
        background-color: #f4f6f8 !important;
      }

      .wm-admin-light .scout-topbar,
      .wm-admin-light header {
        background-color: #ffffff !important;
        border-color: #e2e8f0 !important;
        color: #000000 !important;
      }

      .wm-admin-light thead th {
        background: #f1f5f9 !important;
        color: #0f172a !important;
        border-bottom: 2px solid #cbd5e1 !important;
        font-weight: 800 !important;
      }

      .wm-admin-light table tbody tr {
        background: #ffffff !important;
        border-bottom: 1px solid #e2e8f0 !important;
        color: #000000 !important;
      }

      .wm-admin-light table tbody tr:hover {
        background: #fefce8 !important;
      }

      .wm-admin-light input,
      .wm-admin-light select,
      .wm-admin-light textarea {
        background: #ffffff !important;
        color: #000000 !important;
        border-color: #cbd5e1 !important;
      }
    `;

    // Body arkaplanını temaya göre anında ayarla
    if (typeof document !== "undefined") {
      if (theme === "light") {
        document.body.style.backgroundColor = "#f4f6f8";
        document.body.style.color = "#111827";
        document.documentElement.classList.remove("dark");
      } else {
        document.body.style.backgroundColor = "#0b0b0e";
        document.body.style.color = "#ffffff";
        document.documentElement.classList.add("dark");
      }
    }
  }, [theme]);
}

function ScoutTopBar({ theme, setTheme, currentUser, onLogout }) {
  const isDark = theme === "dark";

  return (
    <header className="sticky top-0 z-30 mb-4 flex min-h-[58px] items-center justify-between border-b border-slate-200 dark:border-white/10 bg-white/95 dark:bg-black/85 px-4 py-2.5 backdrop-blur-xl transition">
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.04] shadow-sm">
          <img src="/wolf-head.png" alt="Wolf Media" className="h-6 w-6 object-contain" />
        </div>
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.22em] text-amber-600 dark:text-yellow-400">
            WOLF MEDIA SCOUT OPERASYON
          </div>
          <div className="text-sm font-black text-slate-900 dark:text-white">
            {currentUser?.fullName || currentUser?.username || "Scout Personeli"}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2.5">
        {/* 🌓 TEK DÜĞME TEMA BUTONU (GÖRSEL 2 BİREBİR) */}
        <button
          type="button"
          onClick={() => setTheme(isDark ? "light" : "dark")}
          className="inline-flex items-center gap-2 rounded-full border border-slate-300 dark:border-white/20 bg-white/95 dark:bg-[#18181c] px-4 py-2 text-xs font-black text-slate-800 dark:text-white shadow-sm hover:border-yellow-500/50 hover:bg-slate-50 dark:hover:bg-white/[0.12] transition-all active:scale-95"
          title={isDark ? "Açık temaya geç" : "Koyu temaya geç"}
        >
          <span className="text-sm">{isDark ? "☀️" : "🌙"}</span>
          <span>{isDark ? "Açık" : "Koyu"}</span>
        </button>

        {onLogout && (
          <button
            type="button"
            onClick={onLogout}
            title="Güvenli Çıkış"
            className="inline-flex items-center gap-1.5 rounded-xl border border-red-200 dark:border-red-500/20 bg-red-50 dark:bg-red-500/10 px-3 py-2 text-xs font-black text-red-900 dark:text-red-300 hover:bg-red-500 hover:text-white transition shadow-sm"
          >
            <span>🚪</span>
            <span className="hidden sm:inline">Çıkış</span>
          </button>
        )}
      </div>
    </header>
  );
}
function Avatar({ username, imageUrl, compact = false }) {
  const sizeClass = compact ? "h-8 w-8 text-xs" : "h-9 w-9 text-sm sm:h-10 sm:w-10";

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={username || "Aday"}
        className={`${sizeClass} shrink-0 rounded-full border border-yellow-500/25 object-cover`}
      />
    );
  }

  return (
    <div className={`flex ${sizeClass} shrink-0 items-center justify-center rounded-full border border-white/10 bg-gradient-to-br from-white/15 to-white/[0.03] font-black text-white/65`}>
      {getInitial(username)}
    </div>
  );
}

export default function ScoutCenterPage({ embedded = false, section = "dashboard", theme: propTheme }) {
  const [theme, setTheme] = useState(() => propTheme || getInitialScoutTheme());
  const [activeSection, setActiveSection] = useState(section || "dashboard");

  useMobileOnlyResponsiveLayout("wm-scout-center-mobile", !embedded);
  useScoutThemeStyles(theme);

  useEffect(() => {
    if (propTheme) {
      setTheme(propTheme);
    }
  }, [propTheme]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem("scout-center-theme", theme);
  }, [theme]);

  useEffect(() => {
    if (embedded && section) {
      setActiveSection(section);
    }
  }, [embedded, section]);

  const [currentUser, setCurrentUser] = useState({});
  const [rows, setRows] = useState([]);
  const [usingDemoData, setUsingDemoData] = useState(LOCAL_DEMO_MODE);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [editingCandidate, setEditingCandidate] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [quickEdit, setQuickEdit] = useState(null);
  const [showCandidateQuery, setShowCandidateQuery] = useState(false);
  const [followUpModal, setFollowUpModal] = useState(null);
  const [assignManagerModal, setAssignManagerModal] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setCurrentUser(safeUser());
  }, []);

  async function loadRows() {
    if (LOCAL_DEMO_MODE) {
      setRows(demoRows);
      setUsingDemoData(true);
      setMessage("Lokal güvenli demo modu aktif. Canlı API'ye veri yazılmaz.");
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const res = await fetch(API_LIST, { cache: "no-store" });
      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("API JSON dönmedi. Local önizlemede demo veri kullanılacak.");
      }

      if (!data.success) {
        throw new Error(data.message || "Aday listesi alınamadı.");
      }

      if (IS_LOCAL && (!data.candidates || data.candidates.length === 0)) {
        setRows(demoRows);
        setUsingDemoData(true);
        setMessage("Local önizleme modu aktif. Demo veri gösteriliyor.");
        return;
      }

      setRows(data.candidates || []);
      setUsingDemoData(false);
    } catch (err) {
      if (IS_LOCAL) {
        setRows(demoRows);
        setUsingDemoData(true);
        setMessage("Local önizleme modu aktif. Demo veri gösteriliyor.");
      } else {
        setRows([]);
        setMessage(err.message || "Liste alınırken bağlantı hatası oluştu.");
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRows();
  }, []);

  const enrichedRows = useMemo(() => {
    return rows.map((item) => ({
      ...item,
      candidate_league: item.candidate_league || item.candidateLeague || item.league || "",
      publisher_experience:
        item.publisher_experience || item.publisherExperience || item.experience || "",
      category: item.category || "",
      suitability_status: item.suitability_status || "beklemede",
      suitability_note: item.suitability_note || "",
      live_joined_note: item.live_joined_note || "",
      contact_note: item.contact_note || "",
      publisher_about_note: item.publisher_about_note || "",
      rejection_note: item.rejection_note || "",
      agency_join_note: item.agency_join_note || "",
      evaluation_status: item.evaluation_status || "",
      live_review_status: item.live_review_status || "",
      contact_status: item.contact_status || "",
      profile_note_status: item.profile_note_status || "",
      rejection_status: item.rejection_status || "",
      agency_join_status: item.agency_join_status || "",
      hidden_id: item.hidden_id || "",
      phone: item.phone || "",
      joined_at: item.joined_at || "",
      manager_user_id: item.manager_user_id || "",
      manager_username: item.manager_username || "",
      manager_assigned_at: item.manager_assigned_at || "",
      follow_up_logs: Array.isArray(item.follow_up_logs) ? item.follow_up_logs : [],
      status: item.status || "kesif_havuzu",
      lifecycle_stage: getLifecycleStage(item),
      follow_up_state: getFollowUpState(item),
    }));
  }, [rows]);

  const metrics = useMemo(() => {
    const total = enrichedRows.length;
    const todayAdded = enrichedRows.filter((item) => isToday(item.created_at)).length;
    const priorityNew = enrichedRows.filter(isPriorityCandidate).length;
    const pending = enrichedRows.filter(
      (item) =>
        item.suitability_status === "beklemede" ||
        ["kesif_havuzu", "davet_gonderildi", "iletisim_kuruldu"].includes(item.status)
    ).length;
    const joined = enrichedRows.filter((item) => item.status === "ajansa_katildi").length;

    return {
      total,
      todayAdded,
      priorityNew,
      pending,
      joined,
      joinRate: total > 0 ? Math.round((joined / total) * 100) : 0,
    };
  }, [enrichedRows]);

  const priorityNewCandidates = useMemo(() => {
    return enrichedRows
      .filter(isPriorityCandidate)
      .sort((a, b) => {
        const aIndex = leagueOptions.includes(a.candidate_league)
          ? leagueOptions.indexOf(a.candidate_league)
          : 999;
        const bIndex = leagueOptions.includes(b.candidate_league)
          ? leagueOptions.indexOf(b.candidate_league)
          : 999;
        if (aIndex !== bIndex) return aIndex - bIndex;
        return String(b.created_at || "").localeCompare(String(a.created_at || ""));
      })
      .slice(0, 8);
  }, [enrichedRows]);

  const todayAddedCandidates = useMemo(() => {
    return enrichedRows
      .filter((item) => isToday(item.created_at))
      .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))
      .slice(0, 8);
  }, [enrichedRows]);

  const pendingCandidates = useMemo(() => {
    return enrichedRows
      .filter(
        (item) =>
          item.suitability_status === "beklemede" ||
          ["kesif_havuzu", "davet_gonderildi", "iletisim_kuruldu"].includes(item.status)
      )
      .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")))
      .slice(0, 8);
  }, [enrichedRows]);

  const scoutStats = useMemo(() => buildScoutStats(enrichedRows), [enrichedRows]);

  function handleFormChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function openCandidatePanel(candidate = null) {
    if (candidate && !canEditCandidate(currentUser, candidate)) return;
    setEditingCandidate(candidate);
    setForm(normalizeFormFromCandidate(candidate));
    setShowForm(true);
  }

  function closeCandidatePanel() {
    setShowForm(false);
    setEditingCandidate(null);
    setForm({ ...emptyForm });
  }

  async function handleSave(e) {
    e.preventDefault();

    if (!form.tiktok_username.trim()) {
      setMessage("TikTok kullanıcı adı zorunludur.");
      return;
    }

    if (!form.candidate_league) {
      setMessage("Aday ligi zorunludur.");
      return;
    }

    if (!form.publisher_experience) {
      setMessage("Yayıncılık süresi zorunludur.");
      return;
    }

    const duplicateMessage = getDuplicateCandidateMessage(enrichedRows, form, editingCandidate);
    if (duplicateMessage) {
      setMessage(duplicateMessage);
      return;
    }

    const isEditing = Boolean(editingCandidate?.id);
    const nowText = new Date().toISOString().slice(0, 19).replace("T", " ");
    const username = form.tiktok_username.startsWith("@")
      ? form.tiktok_username
      : `@${form.tiktok_username}`;

    if (usingDemoData) {
      if (isEditing) {
        setRows((prev) =>
          prev.map((item) =>
            String(item.id) === String(editingCandidate.id)
              ? {
                  ...item,
                  ...form,
                  tiktok_username: username,
                  updated_at: nowText,
                  last_action_by_username: currentUser?.username || "zafer",
                  last_action_at: nowText,
                }
              : item
          )
        );
        setMessage("Demo modda aday bilgileri güncellendi.");
      } else {
        setRows((prev) => [
          {
            id: Date.now(),
            ...form,
            tiktok_username: username,
            profile_image_source: "avatar",
            owner_username: currentUser?.username || "zafer",
            created_by_username: currentUser?.username || "zafer",
            created_at: nowText,
            updated_at: nowText,
          },
          ...prev,
        ]);
        setMessage("Demo modda aday eklendi.");
      }

      closeCandidatePanel();
      return;
    }

    try {
      setSaving(true);
      setMessage("");

      const payload = {
        ...form,
        candidate_id: editingCandidate?.id || undefined,
        id: editingCandidate?.id || undefined,
        status: form.status || "kesif_havuzu",
        suitability_status: form.suitability_status || "beklemede",
        created_by_user_id: currentUser?.id || null,
        created_by_username: currentUser?.username || "",
        owner_user_id: currentUser?.id || null,
        owner_username: currentUser?.username || "",
        update_type: isEditing ? "candidate_info" : "created",
        note: isEditing ? "Aday genel bilgileri güncellendi." : "Aday keşif havuzuna eklendi.",
      };

      const res = await fetch(isEditing ? API_STATUS_UPDATE : API_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setMessage("API JSON dönmedi: " + text.slice(0, 500));
        return;
      }

      if (!data.success) {
        setMessage(data.message || "Aday kaydedilemedi.");
        return;
      }

      closeCandidatePanel();
      setMessage(isEditing ? "Aday bilgileri güncellendi." : "Aday başarıyla eklendi.");
      loadRows();
    } catch {
      setMessage("Aday kaydedilirken bağlantı hatası oluştu.");
    } finally {
      setSaving(false);
    }
  }

  async function saveQuickEdit(edit, values = {}) {
    if (!edit?.candidate?.id) return;

    const candidate = edit.candidate;
    const customText = String(values.customText || "").trim();
    const selectedStatus = String(values.selectedStatus || "").trim();
    const phone = String(values.phone || candidate.phone || "").trim();
    const hiddenId = String(values.hiddenId || "").trim();

    if (edit.type === "ajansa_katildi" && selectedStatus === "evet") {
      if (!/^\d{5,64}$/.test(hiddenId)) {
        setMessage("Ajans katılımı Evet seçildiğinde 5-64 haneli Hidden ID zorunludur.");
        return;
      }
    }

    const nowText = new Date().toISOString().slice(0, 19).replace("T", " ");

    const nextPayload = {
      candidate_id: candidate.id,
      id: candidate.id,
      status: candidate.status || "kesif_havuzu",
      suitability_status: candidate.suitability_status || "beklemede",
      suitability_note: candidate.suitability_note || "",
      live_joined_note: candidate.live_joined_note || "",
      phone: candidate.phone || "",
      contact_note: candidate.contact_note || "",
      publisher_about_note: candidate.publisher_about_note || "",
      rejection_note: candidate.rejection_note || "",
      agency_join_note: candidate.agency_join_note || "",
      evaluation_status: candidate.evaluation_status || "",
      live_review_status: candidate.live_review_status || "",
      contact_status: candidate.contact_status || "",
      profile_note_status: candidate.profile_note_status || "",
      rejection_status: candidate.rejection_status || "",
      agency_join_status: candidate.agency_join_status || "",
      hidden_id: candidate.hidden_id || "",
      joined_at: candidate.joined_at || "",
      manager_user_id: candidate.manager_user_id || "",
      manager_username: candidate.manager_username || "",
      manager_assigned_at: candidate.manager_assigned_at || "",
      created_by_user_id: currentUser?.id || null,
      created_by_username: currentUser?.username || "",
      update_type: edit.type,
      note: "Scout detay alanı güncellendi.",
    };

    if (edit.type === "suitability_note") {
      nextPayload.suitability_note = customText;
      nextPayload.evaluation_status = selectedStatus;
      nextPayload.note = "Aday değerlendirmesi güncellendi.";
    }

    if (edit.type === "yayina_katildik") {
      nextPayload.live_joined_note = customText;
      nextPayload.live_review_status = selectedStatus;
      if (selectedStatus === "incelendi") nextPayload.status = "yayina_katildik";
      nextPayload.note = "Yayın incelemesi güncellendi.";
    }

    if (edit.type === "iletisim_kuruldu") {
      nextPayload.contact_note = customText;
      nextPayload.contact_status = selectedStatus;
      nextPayload.phone = phone;
      if (selectedStatus === "kuruldu") nextPayload.status = "iletisim_kuruldu";
      nextPayload.note = "İletişim durumu güncellendi.";
    }

    if (edit.type === "publisher_about") {
      nextPayload.publisher_about_note = customText;
      nextPayload.profile_note_status = selectedStatus;
      nextPayload.note = "Aday profil notu güncellendi.";
    }

    if (edit.type === "suitability_status") {
      nextPayload.suitability_status = selectedStatus || "beklemede";
      nextPayload.verified_by = currentUser?.username || "scout";
      nextPayload.suitability_verified_by = currentUser?.username || "scout";
      nextPayload.suitability_verified_at = nowText;
      nextPayload.suitability_reason = customText;
      if (selectedStatus === "baska_ajansa_bagli" || selectedStatus === "uygun_degil") {
        nextPayload.status = "olumsuz";
        nextPayload.is_blacklisted = 1;
      }
      nextPayload.note = "Uygunluk durumu doğrulandı ve güncellendi.";
    }

    if (edit.type === "reddetti") {
      nextPayload.rejection_note = customText;
      nextPayload.rejection_status = selectedStatus;
      if (selectedStatus === "reddedildi") nextPayload.status = "reddetti";
      if (selectedStatus === "uygun_degil") nextPayload.status = "uygun_degil";
      nextPayload.note = "Olumsuzluk gerekçesi güncellendi.";
    }

    if (edit.type === "ajansa_katildi") {
      nextPayload.agency_join_note = customText;
      nextPayload.agency_join_status = selectedStatus;
      nextPayload.hidden_id = selectedStatus === "evet" ? hiddenId : "";
      if (selectedStatus === "evet") {
        nextPayload.status = "ajansa_katildi";
        nextPayload.suitability_status = "uygun";
        nextPayload.joined_at = candidate.joined_at || nowText;
      }
      nextPayload.note = "Ajans katılımı güncellendi.";
    }

    if (usingDemoData) {
      setRows((prev) =>
        prev.map((item) =>
          String(item.id) === String(candidate.id)
            ? {
                ...item,
                ...nextPayload,
                live_joined_at:
                  edit.type === "yayina_katildik" && selectedStatus === "incelendi"
                    ? nowText
                    : item.live_joined_at,
                contact_at:
                  edit.type === "iletisim_kuruldu" && selectedStatus === "kuruldu"
                    ? nowText
                    : item.contact_at,
                rejected_at:
                  edit.type === "reddetti" && selectedStatus
                    ? nowText
                    : item.rejected_at,
                joined_at:
                  edit.type === "ajansa_katildi" && selectedStatus === "evet"
                    ? nowText
                    : item.joined_at,
                updated_at: nowText,
                last_action_by_username: currentUser?.username || "zafer",
                last_action_at: nowText,
              }
            : item
        )
      );
      setQuickEdit(null);
      setMessage("Demo modda scout detay alanı güncellendi.");
      return;
    }

    try {
      const res = await fetch(API_STATUS_UPDATE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(nextPayload),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setMessage("STATUS API JSON dönmedi: " + text.slice(0, 500));
        return;
      }

      if (!data.success) {
        setMessage(data.message || "Scout detay alanı güncellenemedi.");
        return;
      }

      setQuickEdit(null);
      setMessage("Scout detay alanı güncellendi.");
      loadRows();
    } catch {
      setMessage("Scout detay alanı güncellenirken bağlantı hatası oluştu.");
    }
  }

  async function saveFollowUpLog(payload) {
    if (!payload?.candidate_id) return;

    if (usingDemoData) {
      setRows((prev) =>
        prev.map((item) =>
          String(item.id) === String(payload.candidate_id)
            ? {
                ...item,
                follow_up_logs: [
                  {
                    id: Date.now(),
                    ...payload,
                    created_by_username: currentUser?.username || "zafer",
                  },
                  ...(Array.isArray(item.follow_up_logs) ? item.follow_up_logs : []),
                ],
                updated_at: payload.created_at,
              }
            : item
        )
      );
      setFollowUpModal(null);
      setMessage("Demo modda takip görüşmesi kaydedildi.");
      return;
    }

    try {
      const res = await fetch(API_FOLLOWUP_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setMessage("Takip API JSON dönmedi: " + text.slice(0, 300));
        return;
      }

      if (!data.success) {
        setMessage(data.message || "Takip görüşmesi kaydedilemedi.");
        return;
      }

      setFollowUpModal(null);
      setMessage("Takip görüşmesi kaydedildi.");
      loadRows();
    } catch {
      setMessage("Takip görüşmesi kaydedilirken bağlantı hatası oluştu.");
    }
  }

  async function assignPublisherManager(payload) {
    if (!payload?.candidate_id || !payload?.manager_username) {
      setMessage("Yayıncı yöneticisi seçilmelidir.");
      return;
    }

    if (usingDemoData) {
      setRows((prev) =>
        prev.map((item) =>
          String(item.id) === String(payload.candidate_id)
            ? {
                ...item,
                manager_user_id: payload.manager_user_id || "",
                manager_username: payload.manager_username,
                manager_assigned_at: payload.manager_assigned_at,
                updated_at: payload.manager_assigned_at,
              }
            : item
        )
      );
      setAssignManagerModal(null);
      setMessage("Demo modda yayıncı yöneticisi atandı.");
      return;
    }

    try {
      const res = await fetch(API_MANAGER_ASSIGN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setMessage("Yönetici atama API JSON dönmedi: " + text.slice(0, 300));
        return;
      }

      if (!data.success) {
        setMessage(data.message || "Yönetici ataması yapılamadı.");
        return;
      }

      setAssignManagerModal(null);
      setMessage("Yayıncı yöneticisi atandı.");
      loadRows();
    } catch {
      setMessage("Yönetici ataması sırasında bağlantı hatası oluştu.");
    }
  }

  function openWhatsapp(candidate) {
    const phone = String(candidate.phone || "").replace(/\D/g, "");

    if (!phone) {
      setMessage("Bu aday için telefon / WhatsApp bilgisi yok.");
      return;
    }

    const text =
      "Merhaba, Wolf Media Ajans olarak TikTok yayınlarınızı inceledik. Sizinle yayıncı iş birliği sürecimiz hakkında görüşmek isteriz.";

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(text)}`,
      "_blank",
      "noopener,noreferrer"
    );
  }

  function handleLogout() {
    localStorage.removeItem("user");
    window.location.href = "/login";
  }

  return (
    <div
      className={`min-h-screen transition-colors duration-200 ${
        theme === "dark" ? "wm-admin-dark dark bg-[#0b0b0e] text-white" : "wm-admin-light bg-[#f4f6f8] text-[#111827]"
      } ${embedded ? "bg-transparent" : ""}`}
      style={{
        backgroundColor: embedded
          ? "transparent"
          : theme === "dark"
          ? "#0b0b0e"
          : "#f4f6f8",
        color: theme === "dark" ? "#ffffff" : "#111827",
        colorScheme: theme,
      }}
    >
      {theme === "dark" && !embedded && (
        <>
          <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_top,rgba(212,175,55,0.08),transparent_34%),linear-gradient(180deg,#050505_0%,#090909_45%,#000_100%)]" />
          <div className="pointer-events-none fixed inset-0 opacity-[0.03] [background-image:linear-gradient(rgba(255,255,255,.10)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.10)_1px,transparent_1px)] [background-size:42px_42px]" />
        </>
      )}

      <div className={embedded ? "relative z-10 flex" : "relative z-10 flex min-h-screen"}>
        {!embedded && (
          <ScoutSidebar
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            onLogout={handleLogout}
            currentUser={currentUser}
            usingDemoData={usingDemoData}
          />
        )}

        <main className={embedded ? "min-w-0 flex-1 px-0 pb-0" : "min-w-0 flex-1 px-3 pb-8 sm:px-4 lg:px-6 xl:px-7"}>
          {!embedded && (
            <ScoutMobileNav
              activeSection={activeSection}
              setActiveSection={setActiveSection}
              onLogout={handleLogout}
              currentUser={currentUser}
            />
          )}

          {!embedded && (
            <ScoutTopBar
              theme={theme}
              setTheme={setTheme}
              currentUser={currentUser}
            />
          )}

          {message && (
            <div className="mt-5 rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-5 py-3 text-sm font-semibold text-yellow-100">
              {message}
            </div>
          )}

          {loading && (
            <div className="mt-5 rounded-2xl border border-white/10 bg-white/[0.035] px-5 py-3 text-sm text-white/50">
              Veriler yükleniyor...
            </div>
          )}

          {activeSection === "dashboard" && (
            <DashboardView
              metrics={metrics}
              rows={enrichedRows}
              priorityNewCandidates={priorityNewCandidates}
              todayAddedCandidates={todayAddedCandidates}
              pendingCandidates={pendingCandidates}
              scoutStats={scoutStats}
              openCandidatePanel={openCandidatePanel}
              loadRows={loadRows}
              currentUser={currentUser}
              setQuickEdit={setQuickEdit}
              openCandidateQuery={() => setShowCandidateQuery(true)}
              theme={theme}
            />
          )}

          {activeSection === "pool" && (
            <CandidatePoolView
              rows={enrichedRows}
              scoutStats={scoutStats}
              openCandidatePanel={openCandidatePanel}
              openWhatsapp={openWhatsapp}
              currentUser={currentUser}
            />
          )}

          {activeSection === "scout_followup" && (
            <ScoutFollowUpView
              rows={enrichedRows}
              currentUser={currentUser}
              openCandidatePanel={openCandidatePanel}
              openFollowUpModal={setFollowUpModal}
            />
          )}

          {activeSection === "publisher_management" && (
            <PublisherManagementView
              rows={enrichedRows}
              currentUser={currentUser}
              openCandidatePanel={openCandidatePanel}
              openAssignManagerModal={setAssignManagerModal}
              openFollowUpModal={setFollowUpModal}
            />
          )}

          {activeSection === "messages" && (
            <UnifiedMessagesModule
              currentUser={currentUser}
              userRole="scout"
              theme={theme || "dark"}
            />
          )}
          {activeSection === "blacklist" && <BlacklistView rows={enrichedRows} openWhatsapp={openWhatsapp} />}
          {activeSection === "reports" && <ReportsView metrics={metrics} scoutStats={scoutStats} />}
        </main>
      </div>

      {showForm && (
        <CandidateFormModal
          form={form}
          saving={saving}
          editingCandidate={editingCandidate}
          handleChange={handleFormChange}
          handleSave={handleSave}
          close={closeCandidatePanel}
        />
      )}

      {quickEdit && (
        <QuickEditModal
          quickEdit={quickEdit}
          close={() => setQuickEdit(null)}
          save={saveQuickEdit}
        />
      )}

      {showCandidateQuery && (
        <CandidateQueryModal
          close={() => setShowCandidateQuery(false)}
          rows={rows}
        />
      )}

      {followUpModal && (
        <FollowUpModal
          candidate={followUpModal}
          close={() => setFollowUpModal(null)}
          save={saveFollowUpLog}
          currentUser={currentUser}
        />
      )}

      {assignManagerModal && (
        <AssignManagerModal
          candidate={assignManagerModal}
          close={() => setAssignManagerModal(null)}
          save={assignPublisherManager}
        />
      )}
    </div>
  );
}

function DashboardView({
  metrics,
  rows,
  priorityNewCandidates,
  todayAddedCandidates,
  pendingCandidates,
  scoutStats,
  openCandidatePanel,
  loadRows,
  currentUser,
  setQuickEdit,
  openCandidateQuery,
  theme = "light",
}) {
  const isDark = theme === "dark";

  const contactedCount = rows.filter((r) => ["iletisime_gecildi", "gorusuluyor", "teklif_yapildi"].includes(r.status)).length;
  const todayFollowUpCount = rows.filter((r) => r.next_followup_at && new Date(r.next_followup_at) <= new Date() && r.status !== "ajansa_katildi").length;
  const joinedCount = rows.filter((r) => r.status === "ajansa_katildi" || r.agency_join_status === "evet").length;

  return (
    <>
      {/* 🚀 ÜST BAŞLIK & İŞLEM BUTONLARI (YENİLE BUTONU ADAY SORGULA'NIN YANINDA) */}
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between pt-1">
        <div>
          <div className="text-[10px] font-black uppercase tracking-[0.36em] text-amber-600 dark:text-yellow-400">
            SCOUT OPERASYON MERKEZİ
          </div>
          <h2 className="mt-1 text-2xl font-black tracking-tight text-slate-950 dark:text-white lg:text-3xl">
            Scout Operasyon & Aday Yönetimi
          </h2>
          <p className="mt-1 max-w-4xl text-xs leading-5 text-slate-700 dark:text-white/70 font-medium">
            Scout ekibinin bulduğu yayıncı adaylarını yayıncılık süresi, lig önceliği ve süreç durumlarına göre takip edin.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={openCandidateQuery}
            className="rounded-xl border border-slate-300 dark:border-white/10 bg-white dark:bg-white/[0.035] px-3.5 py-2 text-xs font-black text-slate-900 dark:text-white hover:border-yellow-500 hover:text-amber-700 transition shadow-sm"
          >
            🔍 Aday Sorgula
          </button>
          
          <button
            type="button"
            onClick={loadRows}
            title="Tabloyu Yenile"
            className="rounded-xl border border-slate-300 dark:border-white/10 bg-white dark:bg-white/[0.035] px-3.5 py-2 text-xs font-black text-slate-900 dark:text-white hover:border-yellow-500 hover:text-amber-700 transition shadow-sm inline-flex items-center gap-1"
          >
            <span>🔄</span>
            <span>Yenile</span>
          </button>

          <button
            type="button"
            onClick={() => {
              const el = document.getElementById("scout-fast-username-input");
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
                el.focus();
              }
            }}
            className="rounded-xl border border-yellow-500 bg-yellow-500 px-3.5 py-2 text-xs font-black text-black hover:bg-yellow-400 transition shadow-sm"
          >
            ➕ Yeni Aday Ekle
          </button>

          <a
            href="https://live-backstage.tiktok.com/"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 rounded-xl border border-yellow-500/40 bg-yellow-500/20 px-3.5 py-2 text-xs font-black text-amber-800 dark:text-yellow-300 hover:bg-yellow-500 hover:text-black transition shadow-sm"
          >
            🎯 Backstage'i Aç
          </a>
        </div>
      </div>



      <LiveCandidateStrip
        rows={rows}
        openCandidatePanel={openCandidatePanel}
        currentUser={currentUser}
        setQuickEdit={setQuickEdit}
        loadRows={loadRows}
        theme={theme}
      />

      <section className="grid gap-4 xl:grid-cols-2 mt-4">
        <PriorityTable
          title="Öncelikli Yeni Adaylar"
          desc="Başlangıç seviyesi adaylar, A1-B3 arası yeni yayıncılar ve A ligi normal/eski yayıncılar öncelikli listelenir."
          rows={priorityNewCandidates}
          openCandidatePanel={openCandidatePanel}
        />
        <ScoutGraphPanel scoutStats={scoutStats} />
      </section>

      <section className="mt-4 grid gap-4 xl:grid-cols-2">
        <SmallTable
          title="Bugün Eklenen Adaylar"
          desc="Bugün scout ekibinin eklediği adaylar."
          rows={todayAddedCandidates}
          columns={["Aday", "Lig", "Ekleyen", "Durum"]}
          renderRow={(item) => (
            <>
              <td className="px-3.5 py-2.5">
                <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} />
              </td>
              <td className="px-3.5 py-2.5"><LeagueBadge league={item.candidate_league} /></td>
              <td className="px-3.5 py-2.5 text-xs text-slate-900 dark:text-white font-bold">{item.owner_username || "-"}</td>
              <td className="px-3.5 py-2.5"><StatusBadge status={item.status} /></td>
            </>
          )}
        />

        <SmallTable
          title="Beklemede Olanlar"
          desc="Uygunluk veya takip aksiyonu bekleyen adaylar."
          rows={pendingCandidates}
          columns={["Aday", "Lig", "Bekleme", "Son Not"]}
          renderRow={(item) => (
            <>
              <td className="px-3.5 py-2.5">
                <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} />
              </td>
              <td className="px-3.5 py-2.5"><LeagueBadge league={item.candidate_league} /></td>
              <td className="px-3.5 py-2.5 text-xs text-slate-900 dark:text-white font-bold">
                {item.suitability_status === "beklemede" ? "Uygunluk Bekliyor" : getStatusLabel(item.status)}
              </td>
              <td className="px-3.5 py-2.5 text-xs text-slate-800 dark:text-white/80 font-medium">
                {item.publisher_about_note || item.suitability_note || item.contact_note || "-"}
              </td>
            </>
          )}
        />
      </section>
    </>
  );
}

function getQuickEditConfig(item, type) {
  const common = { candidate: item, type };

  if (type === "suitability_note") {
    return {
      ...common,
      title: "Aday Değerlendirmesi",
      noteLabel: "Özel Açıklama (öncelikli)",
      customText: item.suitability_note || "",
      statusField: "evaluation_status",
      selectedStatus: inferProcessStatus(item, "evaluation_status"),
    };
  }

  if (type === "yayina_katildik") {
    return {
      ...common,
      title: "Yayın İncelemesi",
      noteLabel: "Özel Açıklama (öncelikli)",
      customText: item.live_joined_note || "",
      statusField: "live_review_status",
      selectedStatus: inferProcessStatus(item, "live_review_status"),
    };
  }

  if (type === "iletisim_kuruldu") {
    return {
      ...common,
      title: "İletişim Durumu",
      noteLabel: "Özel Açıklama (öncelikli)",
      customText: item.contact_note || "",
      statusField: "contact_status",
      selectedStatus: inferProcessStatus(item, "contact_status"),
      phone: item.phone || "",
    };
  }

  if (type === "publisher_about") {
    return {
      ...common,
      title: "Aday Profil Notu",
      noteLabel: "Özel Açıklama (öncelikli)",
      customText: item.publisher_about_note || "",
      statusField: "profile_note_status",
      selectedStatus: inferProcessStatus(item, "profile_note_status"),
    };
  }

  if (type === "suitability_status") {
    return {
      ...common,
      title: "Uygunluk Durumu",
      statusField: "suitability_status",
      selectedStatus: item.suitability_status || "beklemede",
    };
  }

  if (type === "reddetti") {
    return {
      ...common,
      title: "Olumsuzluk Gerekçesi",
      noteLabel: "Özel Açıklama (öncelikli)",
      customText: item.rejection_note || "",
      statusField: "rejection_status",
      selectedStatus: inferProcessStatus(item, "rejection_status"),
    };
  }

  return {
    ...common,
    title: "Ajans Katılımı",
    noteLabel: "Özel Açıklama (öncelikli)",
    customText: item.agency_join_note || "",
    statusField: "agency_join_status",
    selectedStatus: inferProcessStatus(item, "agency_join_status"),
    hiddenId: item.hidden_id || "",
  };
}

function LiveCandidateStrip({ rows, openCandidatePanel, currentUser, setQuickEdit, loadRows, theme = "light" }) {
  const isDark = theme === "dark";

  // 🚀 Dynamics 365 / ERP Hızlı Giriş Satırı Durumları
  const [quickSuitability, setQuickSuitability] = useState("beklemede");
  const [quickInviteType, setQuickInviteType] = useState("normal");
  const [isExtensionReady, setIsExtensionReady] = useState(false);
  const [quickBackstageFeedback, setQuickBackstageFeedback] = useState(null);
  const [quickUser, setQuickUser] = useState("");
  const [quickFetching, setQuickFetching] = useState(false);
  const [quickProfile, setQuickProfile] = useState(null);
  const [duplicateModalData, setDuplicateModalData] = useState(null);
  const [quickLeague, setQuickLeague] = useState("A3");
  const [quickExperience, setQuickExperience] = useState("yeni_yayinci");
  const [quickNote, setQuickNote] = useState("");
  const [quickPhone, setQuickPhone] = useState("");
  const [quickInstagram, setQuickInstagram] = useState("");
  const [quickDecision, setQuickDecision] = useState("beklemede");
  
  const getTomorrowIso = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(14, 0, 0, 0);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const [quickFollowUpDate, setQuickFollowUpDate] = useState(getTomorrowIso);
  const [quickFollowUpNote, setQuickFollowUpNote] = useState("");
  const [quickRejectionReason, setQuickRejectionReason] = useState("Daha sonra değerlendirecek");
  const [quickHiddenId, setQuickHiddenId] = useState("");

  const [quickSaving, setQuickSaving] = useState(false);
  const [quickError, setQuickError] = useState("");
  const [quickSuccess, setQuickSuccess] = useState(false);
  const [savedRowId, setSavedRowId] = useState(null);
  const quickInputRef = React.useRef(null);

  // Anında Doğrudan Kaydetme Fonksiyonu (Direct Inline Save)
  async function handleDirectUpdate(candidateId, updateFields) {
    setSavedRowId(candidateId);
    try {
      const res = await fetch("/api/scout-candidate-status-update.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: candidateId,
          ...updateFields,
          verified_by: currentUser?.username || "scout"
        })
      });
      const data = await res.json();
      if (data.success) {
        if (typeof loadRows === "function") {
          loadRows();
        }
      }
    } catch (err) {
      console.error("Doğrudan kaydetme hatası:", err);
    } finally {
      setTimeout(() => setSavedRowId(null), 2500);
    }
  }

    // 🔌 WOLF BACKSTAGE EKLENTİ ENTEGRASYONU (CANLI CEVAP DİNLEYİCİ)
  useEffect(() => {
    function handleExtensionMessage(event) {
      if (event.data && event.data.type === "WOLF_BACKSTAGE_EXTENSION_READY") {
        setIsExtensionReady(true);
      }
      if (event.data && event.data.type === "WOLF_RESPONSE_BACKSTAGE_CHECK") {
        setIsExtensionReady(true);
        const { username, result } = event.data;
        if (result) {
          if (result.success) {
            if (result.suitability_status) {
              setQuickSuitability(result.suitability_status);
            }
            if (result.invitation_type) {
              setQuickInviteType(result.invitation_type);
            }
            setQuickBackstageFeedback({
              type: result.suitability_status === "baska_ajansa_bagli" ? "danger" : "success",
              text: result.raw_status ? `Backstage: ${result.raw_status}` : "Backstage doğrulandı."
            });
          } else if (result.needsBackstageTab) {
            setQuickBackstageFeedback({
              type: "warning",
              text: "Canlı teyit için bir sekmede Backstage açık olmalıdır."
            });
          }
        }
      }
    }

    window.addEventListener("message", handleExtensionMessage);
    return () => window.removeEventListener("message", handleExtensionMessage);
  }, []);

  async function handleFetchTikTokProfile(overrideUser) {
    const rawUser = overrideUser || quickUser;
    const cleanUser = rawUser.trim().replace(/^@/, "").toLowerCase();
    if (!cleanUser) {
      setQuickError("Önce TikTok kullanıcı adını yazınız.");
      if (quickInputRef.current) quickInputRef.current.focus();
      return;
    }

    // 🚀 MEVCUT KAYIT KONTROLÜ (DUPLICATE DETECTION)
    const existingCandidate = (rows || []).find((r) => {
      const u1 = String(r.tiktok_username || "").trim().toLowerCase().replace(/^@/, "");
      const u2 = String(r.normalized_username || "").trim().toLowerCase();
      return u1 === cleanUser || u2 === cleanUser;
    });

    if (existingCandidate) {
      setDuplicateModalData(existingCandidate);
    }

    setQuickFetching(true);
    setQuickError("");

    // Eklentiye arka planda Backstage sorgusu tetikle
    try {
      window.postMessage({ type: "WOLF_REQUEST_BACKSTAGE_CHECK", username: cleanUser }, "*");
    } catch {}

    try {
      const res = await fetch(`/api/tiktok-profile-fetch.php?username=${encodeURIComponent(cleanUser)}`);
      const json = await res.json();
      if (json && json.data) {
        const d = json.data;
        setQuickProfile(d);
        
        // Profil ve takipçi bilgisi yüklendi. Lig ve Davet türü tahmini yapılmaz; doğrudan Backstage'den gelen veri alınır.

        if (d.fullName && d.fullName !== cleanUser) {
          // Display Name automatically filled
        }
      } else {
        setQuickProfile({
          username: cleanUser,
          fullName: cleanUser,
          avatar: "",
          followerCount: 0
        });
      }
    } catch (err) {
      setQuickProfile({
        username: cleanUser,
        fullName: cleanUser,
        avatar: "",
        followerCount: 0
      });
    } finally {
      setQuickFetching(false);
    }
  }

  function handleOpenBackstage(usernameToCopy) {
    const target = usernameToCopy || quickUser.trim().replace(/^@/, "");
    if (target && navigator.clipboard) {
      navigator.clipboard.writeText(target).catch(() => {});
      setQuickSuccess(true);
      setTimeout(() => setQuickSuccess(false), 4000);
    }
    window.open("https://live-backstage.tiktok.com/portal/overview", "_blank");
  }

  async function handleQuickSubmit() {
    const cleanUser = quickUser.trim().replace(/^@/, "");
    if (!cleanUser) {
      setQuickError("TikTok kullanıcı adı zorunludur.");
      if (quickInputRef.current) quickInputRef.current.focus();
      return;
    }

    setQuickSaving(true);
    setQuickError("");

    const contactNotes = [];
    if (quickInstagram.trim()) contactNotes.push(`IG: @${quickInstagram.trim().replace(/^@/, '')}`);
    if (quickDecision === "beklemede" && quickFollowUpNote.trim()) contactNotes.push(`Not: ${quickFollowUpNote.trim()}`);

    const payload = {
      tiktok_username: "@" + cleanUser,
      display_name: quickProfile?.fullName || cleanUser,
      profile_image_url: quickProfile?.avatar || "",
      follower_count: String(quickProfile?.followerCount || 0),
      candidate_league: quickLeague,
      publisher_experience: quickExperience,
      phone: quickPhone.trim(),
      contact_note: contactNotes.join(" • "),
      first_note: quickNote.trim(),
      suitability_note: quickNote.trim(),
      owner_username: currentUser?.username || "scout",
      created_by_username: currentUser?.username || "scout",
    };

    if (quickDecision === "kabul") {
      payload.status = "ajansa_katildi";
      payload.agency_join_status = "evet";
      payload.suitability_status = "uygun";
      payload.hidden_id = quickHiddenId.trim();
    } else if (quickDecision === "red") {
      payload.status = "reddetti";
      payload.rejection_status = "reddedildi";
      payload.rejection_note = quickRejectionReason.trim();
      payload.suitability_status = quickSuitability;
      payload.invitation_type = quickInviteType;
    } else {
      payload.status = "gorusuluyor";
      payload.contact_status = "kuruldu";
      payload.suitability_status = quickSuitability;
      if (quickFollowUpDate) {
        payload.next_followup_at = quickFollowUpDate.replace("T", " ") + ":00";
      }
    }

    try {
      const res = await fetch(API_SAVE, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (!data.success) {
        setQuickError(data.message || "Kaydedilemedi.");
        setQuickSaving(false);
        return;
      }

      if (typeof loadRows === "function") {
        loadRows();
      }

      setQuickUser("");
      setQuickProfile(null);
      setQuickPhone("");
      setQuickInstagram("");
      setQuickNote("");
      setQuickHiddenId("");
      setQuickDecision("beklemede");
      setQuickSuitability("beklemede");
      setQuickInviteType("normal");
      setQuickSuccess(true);
      setTimeout(() => setQuickSuccess(false), 3000);
      setQuickSaving(false);

      if (quickInputRef.current) {
        quickInputRef.current.focus();
      }
    } catch (err) {
      setQuickError("Bağlantı hatası oluştu.");
      setQuickSaving(false);
    }
  }

  function handleQuickKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleQuickSubmit();
    }
  }

  const sortedRows = useMemo(() => {
    return [...rows].sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));
  }, [rows]);

  return (
    <section className="scout-detail-panel mb-4 rounded-xl border border-slate-300 dark:border-white/10 bg-white dark:bg-[#0f0f12] shadow-sm overflow-hidden">
      {quickSuccess && (
        <div className="bg-emerald-500/20 text-emerald-800 dark:text-emerald-300 text-xs font-black px-4 py-2 border-b border-emerald-500/30 flex items-center gap-2">
          <span>✅</span>
          <span>Aday başarıyla sisteme eklendi!</span>
        </div>
      )}
      {quickError && (
        <div className="bg-red-500/20 text-red-800 dark:text-red-300 text-xs font-black px-4 py-2 border-b border-red-500/30 flex items-center gap-2">
          <span>⚠️</span>
          <span>{quickError}</span>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full min-w-[1580px] text-left text-xs border-collapse">
          <thead>
            <tr className={`border-b text-[11px] font-black uppercase tracking-wider ${
              isDark ? "border-white/15 text-white bg-[#141418]" : "border-slate-300 text-slate-900 bg-slate-100"
            }`}>
              <th className="sticky top-0 z-20 min-w-[240px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">1. TikTok Yayıncı Adayı</th>
              <th className="sticky top-0 z-20 min-w-[200px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">2. Uygunluk & Backstage</th>
              <th className="sticky top-0 z-20 min-w-[150px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">3. Lig & Deneyim</th>
              <th className="sticky top-0 z-20 min-w-[230px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">4. Scout Değerlendirmesi</th>
              <th className="sticky top-0 z-20 min-w-[190px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">5. İletişim (WhatsApp & IG)</th>
              <th className="sticky top-0 z-20 min-w-[160px] px-3 py-2.5 text-center border-r border-slate-200 dark:border-white/10">6. Görüşme Kararı</th>
              <th className="sticky top-0 z-20 min-w-[230px] px-3 py-2.5 border-r border-slate-200 dark:border-white/10">7. Randevu / Red Nedeni / Not</th>
              <th className="sticky top-0 z-20 min-w-[90px] px-3 py-2.5 text-center">8. İşlem</th>
            </tr>
          </thead>

          <tbody>
            {/* 🚀 ERP DYNAMICS 365 HIZLI GİRİŞ SATIRI */}
            <tr className={`border-b-2 sticky top-0 z-10 ${
              isDark 
                ? "border-amber-500/50 bg-[#17171c] shadow-lg" 
                : "border-amber-400 bg-amber-50/90 shadow-md"
            }`}>
              {/* 1. SÜTUN: TIKTOK KULLANICI ADI & PROFESYONEL SORGULA BUTONU */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                <div className="flex flex-col gap-1.5 min-w-[220px]">
                  <div className={`relative flex items-center rounded-xl border h-[38px] pl-2.5 pr-1 transition-all shadow-sm ${
                    isDark
                      ? "border-amber-500/40 bg-black/80 focus-within:border-yellow-400 focus-within:ring-2 focus-within:ring-yellow-500/20"
                      : "border-amber-400/80 bg-white focus-within:border-amber-500 focus-within:ring-2 focus-within:ring-amber-500/20 shadow-xs"
                  }`}>
                    <span className="flex items-center gap-1 font-black text-xs text-amber-500 mr-1 select-none">
                      <svg className="w-3.5 h-3.5 text-amber-400" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.88 2.89 2.89 0 0 1-2.89-2.88 2.89 2.89 0 0 1 2.89-2.88c.3 0 .58.05.85.14V9.39a6.38 6.38 0 0 0-.85-.06 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.33 6.34 6.34 0 0 0 6.34-6.33V9.05c1.24.89 2.76 1.42 4.41 1.44V7.04a4.8 4.8 0 0 1-.7-.35z"/>
                      </svg>
                      <span>@</span>
                    </span>
                    <input
                      id="scout-fast-username-input"
                      ref={quickInputRef}
                      value={quickUser}
                      onChange={(e) => {
                        setQuickUser(e.target.value);
                        setQuickError("");
                      }}
                      onKeyDown={handleQuickKeyDown}
                      placeholder="kullanici_adi"
                      className={`w-full bg-transparent py-1 text-xs font-black outline-none tracking-tight ${
                        isDark ? "text-white placeholder:text-white/35" : "text-black placeholder:text-slate-400"
                      }`}
                    />
                    <button
                      type="button"
                      disabled={quickFetching || !quickUser.trim()}
                      onClick={() => handleFetchTikTokProfile()}
                      title="TikTok profilini, fotoğrafını ve canlı takipçi sayısını otomatik sorgula (Enter)"
                      className="ml-1 shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-500 px-3 py-1.5 text-[11px] font-black text-black shadow-md hover:brightness-110 active:scale-95 disabled:opacity-40 disabled:pointer-events-none transition-all duration-200"
                    >
                      {quickFetching ? (
                        <>
                          <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-black border-t-transparent" />
                          <span className="font-extrabold">Çekiliyor...</span>
                        </>
                      ) : (
                        <>
                          <svg className="w-3 h-3 text-black" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="11" cy="11" r="8"/>
                            <path d="m21 21-4.3-4.3"/>
                          </svg>
                          <span>Sorgula</span>
                        </>
                      )}
                    </button>
                  </div>

                  {quickProfile && (
                    <div className="group relative flex items-center justify-between gap-2.5 rounded-xl border border-amber-500/40 bg-gradient-to-r from-amber-500/15 via-black/80 to-black/90 p-2 shadow-md backdrop-blur-md animate-in fade-in zoom-in-95">
                      <div className="flex items-center gap-2 min-w-0 flex-1">
                        <div className="relative h-8 w-8 shrink-0 overflow-hidden rounded-full border-2 border-amber-400 shadow-sm bg-slate-900">
                          {quickProfile.avatar ? (
                            <img
                              src={quickProfile.avatar}
                              alt="Avatar"
                              referrerPolicy="no-referrer"
                              crossOrigin="anonymous"
                              className="h-full w-full object-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/wolf-head.png";
                              }}
                            />
                          ) : (
                            <span className="flex h-full w-full items-center justify-center bg-amber-500/20 text-xs font-black text-amber-300">
                              {(quickProfile.fullName || quickUser)[0]?.toUpperCase()}
                            </span>
                          )}
                          <span className="absolute bottom-0 right-0 h-2 w-2 rounded-full bg-emerald-500 ring-1 ring-black" />
                        </div>

                        <div className="min-w-0 flex-1 leading-tight">
                          <div className="font-black text-xs text-white truncate flex items-center gap-1">
                            <span>{quickProfile.fullName || quickUser}</span>
                            <span className="text-emerald-400 text-[10px]" title="Doğrulandı">✓</span>
                          </div>
                          <div className="flex items-center gap-1.5 mt-0.5">
                            <span className="inline-flex items-center gap-1 rounded bg-amber-500/20 px-1.5 py-0.2 text-[9.5px] font-black text-yellow-300">
                              🔥 {quickProfile.followerCount ? Number(quickProfile.followerCount).toLocaleString('tr-TR') : "0"} Takipçi
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center gap-1 shrink-0">
                        <a
                          href={quickProfile.tiktokUrl || `https://www.tiktok.com/@${quickUser.replace(/^@/, '')}`}
                          target="_blank"
                          rel="noreferrer"
                          title="TikTok Profilini Yeni Sekmede Aç"
                          className="flex h-6 w-6 items-center justify-center rounded-lg border border-white/20 bg-white/10 text-white/80 hover:border-yellow-400 hover:text-yellow-300 transition text-xs"
                        >
                          ↗
                        </a>
                        <button
                          type="button"
                          onClick={() => setQuickProfile(null)}
                          title="Kartı Kapat"
                          className="flex h-6 w-6 items-center justify-center rounded-lg border border-red-500/20 bg-red-500/10 text-red-300 hover:bg-red-500 hover:text-white transition text-xs"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </td>

              {/* 2. SÜTUN: UYGUNLUK & BACKSTAGE KUTUSU (ALT-ÜST ÇİFT BİLGİ: DURUM + DAVET TÜRÜ) */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                <div className="flex items-center gap-1.5 min-w-[210px]">
                  <div className="flex flex-col gap-1 flex-1">
                    {/* ÜST KUTU: TİKTOK BACKSTAGE DURUMU */}
                    <select
                      value={quickSuitability}
                      onChange={(e) => setQuickSuitability(e.target.value)}
                      title="TikTok Backstage Durumu"
                      className={`w-full h-[26px] rounded-lg border px-2 text-xs font-black outline-none shadow-xs transition ${
                        quickSuitability === "uygun"
                          ? "border-emerald-500 bg-emerald-100 text-emerald-950 dark:bg-emerald-500/20 dark:text-emerald-200"
                          : quickSuitability === "baska_ajansa_bagli"
                          ? "border-red-500 bg-red-100 text-red-950 dark:bg-red-500/20 dark:text-red-200"
                          : quickSuitability === "desteklenmeyen_bolge"
                          ? "border-amber-600 bg-amber-100 text-amber-950 dark:bg-amber-500/20 dark:text-amber-200"
                          : quickSuitability === "uygun_degil"
                          ? "border-rose-500 bg-rose-100 text-rose-950 dark:bg-rose-500/20 dark:text-rose-200"
                          : isDark
                          ? "border-white/20 bg-[#1c1c20] text-white"
                          : "border-slate-300 bg-white text-black"
                      }`}
                    >
                      <option value="beklemede">⏳ Beklemede</option>
                      <option value="uygun">✅ Mevcut (Ajanssız)</option>
                      <option value="baska_ajansa_bagli">⛔ Başka Bir Ajansta</option>
                      <option value="desteklenmeyen_bolge">🌍 Desteklenmeyen Bölge</option>
                      <option value="uygun_degil">❌ Uygun Değil / Kriter Dışı</option>
                    </select>

                    {/* ALT KUTU: TİKTOK BACKSTAGE DAVET TÜRÜ */}
                    <select
                      value={quickInviteType}
                      onChange={(e) => setQuickInviteType(e.target.value)}
                      title="TikTok Backstage Davet Türü"
                      className="w-full h-[22px] rounded-md border border-amber-400/80 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-black text-black dark:text-yellow-300 outline-none shadow-xs"
                    >
                      <option value="normal">■ Normal Davet</option>
                      <option value="premium">■ Premium Davet</option>
                      <option value="yok">— Davet Gönderilmedi</option>
                    </select>
                  </div>

                  {/* SAĞ BUTON: İSTEĞE BAĞLI PORTALI AÇMA KISAYOLU */}
                  <button
                    type="button"
                    onClick={() => handleOpenBackstage(quickUser)}
                    title="İsteğe Bağlı: Kullanıcıyı kopyalayıp Backstage portalını yeni sekmede manuel açar"
                    className="h-[52px] px-2 flex flex-col items-center justify-center gap-0.5 rounded-xl border border-white/10 bg-white/[0.04] text-[10px] font-bold text-white/50 hover:border-yellow-400/50 hover:text-yellow-300 transition-all duration-200 shadow-xs active:scale-95 shrink-0"
                  >
                    <span className="text-xs">↗</span>
                    <span className="text-[9px]">Portala Git</span>
                  </button>
                </div>
              </td>

              {/* 3. SÜTUN: LİG & YAYINCILIK SÜRESİ KUTUSU */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                <div className="flex flex-col gap-1">
                  <select
                    value={quickLeague}
                    onChange={(e) => setQuickLeague(e.target.value)}
                    className="w-full h-[26px] rounded-lg border border-amber-400 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-black dark:text-white outline-none shadow-xs"
                  >
                    {leagueOptions.map((l) => (
                      <option key={l} value={l}>{l} Ligi</option>
                    ))}
                  </select>

                  <select
                    value={quickExperience}
                    onChange={(e) => setQuickExperience(e.target.value)}
                    className="w-full h-[22px] rounded-md border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-bold text-black dark:text-white outline-none shadow-xs"
                  >
                    {publisherExperienceOptions.map((exp) => (
                      <option key={exp.key} value={exp.key}>{exp.label}</option>
                    ))}
                  </select>
                </div>
              </td>

              {/* 4. SÜTUN: SCOUT DEĞERLENDİRMESİ KUTUSU */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                <textarea
                  rows={2}
                  value={quickNote}
                  onChange={(e) => setQuickNote(e.target.value)}
                  placeholder="Yayın kalitesi, enerjisi, yeteneği hakkında ilk izlenim notu..."
                  className="w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] p-1.5 text-xs font-medium text-black dark:text-white focus:border-amber-500 placeholder:text-slate-400 dark:placeholder:text-white/30 resize-none outline-none shadow-xs"
                />
              </td>

              {/* 5. SÜTUN: İLETİŞİM KUTUSU */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                <div className="flex flex-col gap-1">
                  <div className="flex items-center">
                    <span className="text-[10px] font-bold text-slate-700 dark:text-white/70 mr-1 w-6">Tel:</span>
                    <input
                      value={quickPhone}
                      onChange={(e) => setQuickPhone(e.target.value)}
                      onKeyDown={handleQuickKeyDown}
                      placeholder="05..."
                      className="w-full h-[26px] rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-2 text-xs font-bold text-black dark:text-white outline-none shadow-xs"
                    />
                  </div>
                  <div className="flex items-center">
                    <span className="text-[10px] font-bold text-slate-700 dark:text-white/70 mr-1 w-6">IG:</span>
                    <input
                      value={quickInstagram}
                      onChange={(e) => setQuickInstagram(e.target.value)}
                      onKeyDown={handleQuickKeyDown}
                      placeholder="@instagram"
                      className="w-full h-[22px] rounded-md border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-bold text-black dark:text-white outline-none shadow-xs"
                    />
                  </div>
                </div>
              </td>

              {/* 6. SÜTUN: İKONİK GÖRÜŞME KARARI SEGMENTİ (ONAY TİKİ, SAAT, X) */}
              <td className="px-2 py-2 align-middle text-center border-r border-slate-200 dark:border-white/10 w-[125px] min-w-[125px]">
                <div className="inline-flex w-[115px] items-center p-0.5 rounded-xl bg-slate-100 dark:bg-[#121216] border border-slate-300 dark:border-white/10 shadow-inner gap-1 mx-auto justify-center">
                  {/* ONAY TİKİ (KABUL) */}
                  <button
                    type="button"
                    onClick={() => setQuickDecision("kabul")}
                    title="Kabul / Ajansa Katılım Olarak İşaretle"
                    className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
                      quickDecision === "kabul"
                        ? "bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-md shadow-blue-500/30 scale-105"
                        : "text-slate-400 dark:text-blue-400/60 hover:bg-blue-500/15 hover:text-blue-300 hover:scale-105"
                    }`}
                  >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                  </button>

                  {/* SAAT GÖRSELİ (RANDEVU / TAKİP) */}
                  <button
                    type="button"
                    onClick={() => setQuickDecision("beklemede")}
                    title="Randevu / Takipte Olarak İşaretle"
                    className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
                      quickDecision === "beklemede"
                        ? "bg-gradient-to-r from-amber-500 to-yellow-400 text-black shadow-md shadow-amber-500/30 scale-105"
                        : "text-slate-400 dark:text-amber-400/60 hover:bg-amber-500/15 hover:text-amber-300 hover:scale-105"
                    }`}
                  >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12 6 12 12 16 14"/>
                    </svg>
                  </button>

                  {/* X ÇARPI (RED) */}
                  <button
                    type="button"
                    onClick={() => setQuickDecision("red")}
                    title="Reddedildi Olarak İşaretle"
                    className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
                      quickDecision === "red"
                        ? "bg-gradient-to-r from-rose-600 to-red-600 text-white shadow-md shadow-rose-500/30 scale-105"
                        : "text-slate-400 dark:text-rose-400/60 hover:bg-rose-500/15 hover:text-rose-300 hover:scale-105"
                    }`}
                  >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"/>
                      <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  </button>
                </div>
              </td>

              {/* 7. SÜTUN: KARAR DETAYI / RANDEVU / RED KUTUSU */}
              <td className="px-2.5 py-2 align-middle border-r border-slate-200 dark:border-white/10">
                {quickDecision === "beklemede" && (
                  <div className="flex flex-col gap-1">
                    <input
                      type="datetime-local"
                      value={quickFollowUpDate}
                      onChange={(e) => setQuickFollowUpDate(e.target.value)}
                      className="w-full h-[26px] rounded-lg border border-amber-400 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-black dark:text-white outline-none shadow-xs"
                    />
                    <input
                      value={quickFollowUpNote}
                      onChange={(e) => setQuickFollowUpNote(e.target.value)}
                      placeholder="Randevu notu / konu..."
                      className="w-full h-[22px] rounded-md border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-medium text-black dark:text-white outline-none shadow-xs"
                    />
                  </div>
                )}

                {quickDecision === "red" && (
                  <div className="flex flex-col gap-1">
                    <select
                      value={quickRejectionReason}
                      onChange={(e) => setQuickRejectionReason(e.target.value)}
                      className="w-full h-[26px] rounded-lg border border-red-300 dark:border-red-500/30 bg-white dark:bg-[#1c1c20] px-2 text-xs font-bold text-red-950 dark:text-red-200 outline-none shadow-xs"
                    >
                      <option value="Başka ajansla sözleşmeli">Başka ajansla sözleşmeli</option>
                      <option value="Şartları / Komisyonu beğenmedi">Şartları / Komisyonu beğenmedi</option>
                      <option value="Yayıncılığı bırakacak">Yayıncılığı bırakacak</option>
                      <option value="Ulaşılamadı / Yanıt vermedi">Ulaşılamadı / Yanıt vermedi</option>
                      <option value="Ajans teklifini reddetti">Ajans teklifini reddetti</option>
                      <option value="Diğer">Diğer</option>
                    </select>
                    <input
                      value={quickRejectionReason}
                      onChange={(e) => setQuickRejectionReason(e.target.value)}
                      placeholder="Özel red gerekçesi..."
                      className="w-full h-[22px] rounded-md border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-medium text-black dark:text-white outline-none shadow-xs"
                    />
                  </div>
                )}

                {quickDecision === "kabul" && (
                  <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-1">
                      <span className="text-[10px] font-black text-emerald-900 dark:text-emerald-300">🔑 Hidden ID (Ajanstaki ID):</span>
                    </div>
                    <input
                      value={quickHiddenId}
                      onChange={(e) => setQuickHiddenId(e.target.value)}
                      placeholder="Hidden ID numarasını buraya yazın..."
                      className="w-full h-[28px] rounded-lg border border-emerald-500 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-emerald-950 dark:text-emerald-200 outline-none shadow-xs placeholder:text-slate-400"
                    />
                  </div>
                )}
              </td>

              {/* 8. SÜTUN: KAYDET (ENTER) */}
              <td className="px-2.5 py-2 align-middle text-center">
                <button
                  type="button"
                  disabled={quickSaving || !quickUser.trim()}
                  onClick={handleQuickSubmit}
                  title="Adayı Kaydet (Kısayol: Enter)"
                  className="w-full h-[34px] inline-flex items-center justify-center gap-1 rounded-lg bg-yellow-500 px-2 text-xs font-black text-black shadow-md hover:bg-yellow-400 disabled:opacity-35 transition"
                >
                  <span>{quickSaving ? "⏳" : "➕ Ekle"}</span>
                </button>
              </td>
            </tr>

            {/* 📋 MEVCUT ADAYLAR (DOĞRUDAN DÜZENLENEBİLİR & OTOMATİK KAYDEDİLEN SATIRLAR) */}
            {sortedRows.length === 0 ? (
              <tr>
                <td colSpan="8" className="px-3 py-8 text-center text-slate-800 dark:text-white/70 font-bold">
                  Henüz kayıtlı aday bulunamadı. Yukarıdaki satırdan hemen yeni aday ekleyebilirsiniz!
                </td>
              </tr>
            ) : (
              sortedRows.map((item) => (
                <DirectEditableCandidateRow
                  key={item.id}
                  item={item}
                  currentUser={currentUser}
                  onDirectUpdate={handleDirectUpdate}
                  onOpenBackstage={handleOpenBackstage}
                  onOpenDetail={() => openCandidatePanel(item)}
                  isSaved={savedRowId === item.id}
                  isDark={isDark}
                />
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ⚠️ DAHA ÖNCE KAYDEDİLMİŞ ADAY BİLGİ POPUP MODALI */}
      {duplicateModalData && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-md p-4 animate-in fade-in duration-200">
          <div className="relative w-full max-w-xl rounded-3xl border border-amber-500/40 bg-[#121216] p-6 text-white shadow-2xl shadow-amber-500/10">
            
            {/* Üst Başlık & Kapat Butonu */}
            <div className="flex items-start justify-between border-b border-white/10 pb-4">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-amber-500/40 bg-amber-500/20 text-2xl shadow-inner">
                  ⚠️
                </div>
                <div>
                  <h3 className="text-lg font-black text-amber-400">Bu Yayıncı Zaten Sistemde Kayıtlı!</h3>
                  <p className="text-xs font-semibold text-white/60">
                    Bu aday daha önce scout ekibiniz tarafından sisteme kaydedilmiş.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setDuplicateModalData(null)}
                className="rounded-xl border border-white/10 bg-white/5 p-2 text-white/60 hover:bg-white/10 hover:text-white transition"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Aday Profil Kartı Özeti */}
            <div className="my-4 flex items-center gap-3.5 rounded-2xl border border-white/10 bg-white/[0.03] p-3.5">
              <img
                src={duplicateModalData.profile_image_url || "https://placehold.co/100x100?text=TikTok"}
                alt={duplicateModalData.display_name || duplicateModalData.tiktok_username}
                className="h-14 w-14 rounded-2xl border border-amber-500/40 object-cover"
                onError={(e) => { e.target.src = "https://placehold.co/100x100?text=TikTok"; }}
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-base font-black text-white truncate">
                    {duplicateModalData.display_name || duplicateModalData.tiktok_username}
                  </span>
                  <span className="rounded-md border border-white/10 bg-white/10 px-1.5 py-0.5 text-[10px] font-mono text-white/80">
                    @{duplicateModalData.tiktok_username}
                  </span>
                </div>
                <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-white/60">
                  <span>🔥 {duplicateModalData.follower_count ? Number(duplicateModalData.follower_count).toLocaleString('tr-TR') : "0"} Takipçi</span>
                  <span>•</span>
                  <span>🏆 Lig: {duplicateModalData.candidate_league || "A3"}</span>
                  {duplicateModalData.owner_username && (
                    <>
                      <span>•</span>
                      <span className="text-amber-300 font-bold">👤 Ekleyen: @{duplicateModalData.owner_username}</span>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* İSTENEN 4., 6. VE 7. BAŞLIKLAR KUTUSU */}
            <div className="grid gap-3 my-4">
              
              {/* 4. BAŞLIK: SCOUT DEĞERLENDİRMESİ */}
              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3.5">
                <div className="flex items-center gap-2 text-xs font-black text-amber-300 mb-1.5">
                  <span>📝</span>
                  <span>4. SCOUT DEĞERLENDİRMESİ (İzlenim & Kalite Notu)</span>
                </div>
                <div className="rounded-xl border border-white/5 bg-black/40 p-2.5 text-xs text-white/90 font-medium leading-relaxed">
                  {duplicateModalData.first_note || duplicateModalData.notes || duplicateModalData.risk_note || (
                    <span className="text-white/40 italic">Henüz bir değerlendirme notu yazılmamış.</span>
                  )}
                </div>
              </div>

              {/* 6. BAŞLIK: GÖRÜŞME KARARI */}
              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3.5">
                <div className="flex items-center gap-2 text-xs font-black text-blue-300 mb-1.5">
                  <span>🎯</span>
                  <span>6. GÖRÜŞME KARARI</span>
                </div>
                <div className="flex items-center gap-2">
                  {duplicateModalData.status === "ajansa_katildi" ? (
                    <span className="inline-flex items-center gap-1.5 rounded-xl border border-blue-500/40 bg-blue-500/20 px-3 py-1.5 text-xs font-black text-blue-300">
                      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                      ✓ KABUL EDİLDİ / AJANSA KATILDI
                    </span>
                  ) : duplicateModalData.status === "gorusuluyor" ? (
                    <span className="inline-flex items-center gap-1.5 rounded-xl border border-amber-500/40 bg-amber-500/20 px-3 py-1.5 text-xs font-black text-amber-300">
                      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                      🕒 RANDEVU / GÖRÜŞÜLÜYOR
                    </span>
                  ) : duplicateModalData.status === "reddetti" ? (
                    <span className="inline-flex items-center gap-1.5 rounded-xl border border-rose-500/40 bg-rose-500/20 px-3 py-1.5 text-xs font-black text-rose-300">
                      <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      ✕ REDDEDİLDİ / İPTAL
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 rounded-xl border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-black text-white/80">
                      ⏳ BEKLEMEDE / İNCELENİYOR
                    </span>
                  )}
                </div>
              </div>

              {/* 7. BAŞLIK: RANDEVU / RED NEDENİ / NOT */}
              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-3.5">
                <div className="flex items-center gap-2 text-xs font-black text-purple-300 mb-1.5">
                  <span>📅</span>
                  <span>7. RANDEVU / RED NEDENİ / NOT</span>
                </div>
                <div className="grid gap-1.5 rounded-xl border border-white/5 bg-black/40 p-2.5 text-xs">
                  {duplicateModalData.next_followup_at && (
                    <div className="flex items-center gap-2 font-mono text-amber-300 font-bold">
                      <span>🗓️ Randevu Tarihi:</span>
                      <span>{duplicateModalData.next_followup_at.replace("T", " ").slice(0, 16)}</span>
                    </div>
                  )}
                  {duplicateModalData.status_note && (
                    <div className="text-white/90">
                      <span className="font-bold text-white/60">Not / Gerekçe: </span>
                      <span>{duplicateModalData.status_note}</span>
                    </div>
                  )}
                  {duplicateModalData.hidden_id && (
                    <div className="text-emerald-300 font-mono text-[11px]">
                      <span>📌 Hidden ID: </span>
                      <span>{duplicateModalData.hidden_id}</span>
                    </div>
                  )}
                  {!duplicateModalData.next_followup_at && !duplicateModalData.status_note && !duplicateModalData.hidden_id && (
                    <span className="text-white/40 italic">Bu alan için girilmiş ek not bulunmuyor.</span>
                  )}
                </div>
              </div>

            </div>

            {/* Aksiyon Butonları */}
            <div className="mt-5 flex items-center justify-end gap-2.5 border-t border-white/10 pt-4">
              <button
                type="button"
                onClick={() => setDuplicateModalData(null)}
                className="rounded-xl border border-white/10 bg-white/5 px-4 py-2.5 text-xs font-bold text-white hover:bg-white/10 transition"
              >
                Kapat
              </button>
              <button
                type="button"
                onClick={() => {
                  const item = duplicateModalData;
                  setDuplicateModalData(null);
                  if (openCandidatePanel) openCandidatePanel(item);
                }}
                className="rounded-xl border border-amber-500 bg-amber-500 px-4 py-2.5 text-xs font-black text-black hover:bg-amber-400 transition shadow-md shadow-amber-500/20"
              >
                🔍 Aday Detayını Aç
              </button>
            </div>

          </div>
        </div>
      )}
    </section>
  );
}

// 🚀 DOĞRUDAN DÜZENLENEBİLİR & ANINDA KAYDEDİLEN ADAY SATIRI BİLEŞENİ
function DirectEditableCandidateRow({ item, currentUser, onDirectUpdate, onOpenBackstage, onOpenDetail, isSaved, isDark }) {
  const cleanUser = String(item.tiktok_username || "").replace(/^@/, "").trim();

  // Yerel Satır State'leri (Doğrudan Yazma ve Kaydetme İçin)
  const [suitability, setSuitability] = useState(item.suitability_status || "beklemede");
  const [inviteType, setInviteType] = useState(item.invitation_type || "normal");
  const [league, setLeague] = useState(item.candidate_league || "A3");
  const [experience, setExperience] = useState(item.publisher_experience || "yeni_yayinci");
  const [note, setNote] = useState(item.suitability_note || item.first_note || "");
  const [phone, setPhone] = useState(item.phone || "");
  const [status, setStatus] = useState(item.status || "gorusuluyor");
  const [hiddenId, setHiddenId] = useState(item.hidden_id || "");
  const [followUpDate, setFollowUpDate] = useState(
    item.next_followup_at ? item.next_followup_at.slice(0, 16).replace(" ", "T") : ""
  );
  const [rejectionNote, setRejectionNote] = useState(item.rejection_note || "");

  // Props güncellendiğinde senkronize et
  useEffect(() => {
    setSuitability(item.suitability_status || "beklemede");
    setInviteType(item.invitation_type || "normal");
    setLeague(item.candidate_league || "A3");
    setExperience(item.publisher_experience || "yeni_yayinci");
    setNote(item.suitability_note || item.first_note || "");
    setPhone(item.phone || "");
    setStatus(item.status || "gorusuluyor");
    setHiddenId(item.hidden_id || "");
    setFollowUpDate(item.next_followup_at ? item.next_followup_at.slice(0, 16).replace(" ", "T") : "");
    setRejectionNote(item.rejection_note || "");
  }, [item]);

  const isJoined = status === "ajansa_katildi";
  const isRejected = status === "reddetti";

  return (
    <tr className={`border-b transition ${
      isSaved 
        ? "bg-emerald-50 dark:bg-emerald-950/30 border-emerald-300" 
        : "border-slate-200 dark:border-white/[0.08] bg-white dark:bg-[#0f0f12] hover:bg-slate-50 dark:hover:bg-[#18181f]"
    }`}>
      {/* 1. SÜTUN: TIKTOK YAYINCI ADAYI */}
      <td className="px-3 py-2.5 align-middle border-r border-slate-200 dark:border-white/10">
        <div className="flex items-center gap-2.5">
          {item.profile_image_url ? (
            <img src={item.profile_image_url} alt="" className="h-9 w-9 rounded-full object-cover border border-slate-300 dark:border-white/20 shrink-0" />
          ) : (
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-200 dark:bg-zinc-800 text-xs font-black text-slate-900 dark:text-amber-400 border border-slate-300 dark:border-white/20 shrink-0">
              {cleanUser.slice(0, 2).toUpperCase()}
            </span>
          )}
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-1.5">
              <span className="font-extrabold text-xs text-black dark:text-white truncate">
                {item.display_name || cleanUser}
              </span>
              <a
                href={item.profile_url || `https://www.tiktok.com/@${cleanUser}`}
                target="_blank"
                rel="noreferrer"
                title="TikTok Profilini Aç"
                className="text-amber-600 dark:text-yellow-400 hover:underline text-[11px]"
              >
                🎵
              </a>
            </div>
            <div className="text-[11px] font-bold text-slate-600 dark:text-white/60 truncate">
              @{cleanUser} {item.follower_count ? `• ${item.follower_count} Takipçi` : ""}
            </div>
          </div>
        </div>
      </td>

      {/* 2. SÜTUN: UYGUNLUK & BACKSTAGE (DOĞRUDAN DEĞİŞTİR & KAYDET) */}
      <td className="px-2.5 py-2.5 align-middle border-r border-slate-200 dark:border-white/10">
        <div className="flex items-center gap-1.5">
          <select
            value={suitability}
            onChange={(e) => {
              const val = e.target.value;
              setSuitability(val);
              onDirectUpdate(item.id, { suitability_status: val });
            }}
            className={`flex-1 h-[34px] rounded-lg border px-2 text-xs font-bold outline-none shadow-xs transition ${
              suitability === "uygun"
                ? "border-emerald-500 bg-emerald-100 text-emerald-950 dark:bg-emerald-500/20 dark:text-emerald-200 font-black"
                : suitability === "baska_ajansa_bagli"
                ? "border-red-500 bg-red-100 text-red-950 dark:bg-red-500/20 dark:text-red-200 font-black"
                : isDark
                ? "border-white/20 bg-[#1c1c20] text-white"
                : "border-slate-300 bg-white text-black"
            }`}
          >
            <option value="beklemede">⏳ Beklemede</option>
            <option value="uygun">✅ Uygun (Ajanssız)</option>
            <option value="baska_ajansa_bagli">⛔ Başka Ajansa Bağlı</option>
            <option value="uygun_degil">❌ Kriter Dışı / Uygun Değil</option>
          </select>
          <button
            type="button"
            onClick={() => onOpenBackstage(cleanUser)}
            title={`@${cleanUser} Kullanıcı Adını Kopyala & TikTok Backstage'i Aç`}
            className="h-[34px] px-2.5 inline-flex items-center gap-1.5 rounded-lg border border-yellow-500/50 bg-gradient-to-r from-yellow-500/15 via-amber-500/20 to-yellow-500/15 text-[11px] font-black text-amber-900 dark:text-yellow-300 hover:border-yellow-400 hover:bg-gradient-to-r hover:from-amber-500 hover:via-yellow-400 hover:to-amber-500 hover:text-black transition-all duration-200 shadow-xs active:scale-95 shrink-0"
          >
            <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/>
            </svg>
            <span>Backstage</span>
          </button>
        </div>
      </td>

      {/* 3. SÜTUN: LİG & DENEYİM (DOĞRUDAN SEÇ & KAYDET) */}
      <td className="px-2.5 py-2.5 align-middle border-r border-slate-200 dark:border-white/10">
        <div className="flex flex-col gap-1">
          <select
            value={league}
            onChange={(e) => {
              const val = e.target.value;
              setLeague(val);
              onDirectUpdate(item.id, { candidate_league: val });
            }}
            className="w-full h-[26px] rounded-lg border border-amber-400 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-black dark:text-white outline-none shadow-xs"
          >
            {leagueOptions.map((l) => (
              <option key={l} value={l}>{l} Ligi</option>
            ))}
          </select>

          <select
            value={experience}
            onChange={(e) => {
              const val = e.target.value;
              setExperience(val);
              onDirectUpdate(item.id, { publisher_experience: val });
            }}
            className="w-full h-[22px] rounded-md border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-1.5 text-[10px] font-bold text-black dark:text-white outline-none shadow-xs"
          >
            {publisherExperienceOptions.map((exp) => (
              <option key={exp.key} value={exp.key}>{exp.label}</option>
            ))}
          </select>
        </div>
      </td>

      {/* 4. SÜTUN: SCOUT DEĞERLENDİRMESİ (DOĞRUDAN YAZ & ONBLUR İLE KAYDET) */}
      <td className="px-2.5 py-2.5 align-middle border-r border-slate-200 dark:border-white/10 max-w-[240px]">
        <textarea
          rows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onBlur={() => {
            if (note !== (item.suitability_note || item.first_note || "")) {
              onDirectUpdate(item.id, { suitability_note: note, first_note: note });
            }
          }}
          placeholder="Yayıncı izlenim notu yazın..."
          className="w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] p-1.5 text-xs font-medium text-black dark:text-white focus:border-amber-500 placeholder:text-slate-400 dark:placeholder:text-white/30 resize-none outline-none shadow-xs"
        />
      </td>

      {/* 5. SÜTUN: İLETİŞİM (DOĞRUDAN TELEFON / WHATSAPP GİR & KAYDET) */}
      <td className="px-2.5 py-2.5 align-middle border-r border-slate-200 dark:border-white/10">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-1">
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onBlur={() => {
                if (phone !== (item.phone || "")) {
                  onDirectUpdate(item.id, { phone: phone.trim() });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
              placeholder="05..."
              className="w-full h-[26px] rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#1c1c20] px-2 text-xs font-bold text-black dark:text-white outline-none shadow-xs"
            />
            {phone && (
              <a
                href={`https://wa.me/${String(phone).replace(/\D/g, "")}?text=${encodeURIComponent("Merhaba, Wolf Media Ajans olarak TikTok yayınlarınızı inceledik. Sizinle yayıncı iş birliği sürecimiz hakkında görüşmek isteriz.")}`}
                target="_blank"
                rel="noreferrer"
                title={`WhatsApp'tan Yaz: ${phone}`}
                className="h-[26px] px-2 flex items-center justify-center rounded-lg border border-green-600 bg-green-100 dark:bg-green-500/20 text-xs font-black text-green-950 dark:text-green-300 hover:bg-green-600 hover:text-white transition shadow-xs shrink-0"
              >
                💬
              </a>
            )}
          </div>
          {item.contact_note && item.contact_note.includes("IG:") && (
            <div className="text-[9px] font-bold text-purple-700 dark:text-purple-300 truncate leading-tight">
              {item.contact_note.split(" • ")[0]}
            </div>
          )}
        </div>
      </td>

      {/* 6. SÜTUN: İKONİK GÖRÜŞME KARARI SEGMENTİ (ONAY TİKİ, SAAT, X - TEK TIKLA DEĞİŞTİR & KAYDET) */}
      <td className="px-2 py-2.5 align-middle text-center border-r border-slate-200 dark:border-white/10 w-[125px] min-w-[125px]">
        <div className="inline-flex w-[115px] items-center p-0.5 rounded-xl bg-slate-100 dark:bg-[#121216] border border-slate-300 dark:border-white/10 shadow-inner gap-1 mx-auto justify-center">
          {/* ONAY TİKİ (KABUL / AJANSA KATILDI) */}
          <button
            type="button"
            onClick={() => {
              setStatus("ajansa_katildi");
              onDirectUpdate(item.id, { status: "ajansa_katildi", suitability_status: "uygun" });
            }}
            title="Kabul / Ajansa Katılım Olarak Onayla"
            className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
              isJoined
                ? "bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-md shadow-blue-500/30 scale-105"
                : "text-slate-400 dark:text-blue-400/60 hover:bg-blue-500/15 hover:text-blue-300 hover:scale-105"
            }`}
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </button>

          {/* SAAT GÖRSELİ (RANDEVU / TAKİPTE) */}
          <button
            type="button"
            onClick={() => {
              setStatus("gorusuluyor");
              onDirectUpdate(item.id, { status: "gorusuluyor" });
            }}
            title="Randevu / Takipte Olarak İşaretle"
            className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
              !isJoined && !isRejected
                ? "bg-gradient-to-r from-amber-500 to-yellow-400 text-black shadow-md shadow-amber-500/30 scale-105"
                : "text-slate-400 dark:text-amber-400/60 hover:bg-amber-500/15 hover:text-amber-300 hover:scale-105"
            }`}
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
          </button>

          {/* X ÇARPI (REDDEDİLDİ) */}
          <button
            type="button"
            onClick={() => {
              setStatus("reddetti");
              onDirectUpdate(item.id, { status: "reddetti" });
            }}
            title="Reddedildi Olarak İşaretle"
            className={`flex-1 h-[30px] flex items-center justify-center rounded-lg transition-all duration-200 ${
              isRejected
                ? "bg-gradient-to-r from-rose-600 to-red-600 text-white shadow-md shadow-rose-500/30 scale-105"
                : "text-slate-400 dark:text-rose-400/60 hover:bg-rose-500/15 hover:text-rose-300 hover:scale-105"
            }`}
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </td>

      {/* 7. SÜTUN: RANDEVU / RED NEDENİ / HIDDEN ID (DOĞRUDAN YAZ & KAYDET) */}
      <td className="px-2.5 py-2.5 align-middle border-r border-slate-200 dark:border-white/10">
        {isJoined ? (
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1">
              <span className="text-[10px] font-black text-emerald-900 dark:text-emerald-300">🔑 Hidden ID:</span>
            </div>
            <input
              value={hiddenId}
              onChange={(e) => setHiddenId(e.target.value)}
              onBlur={() => {
                if (hiddenId !== (item.hidden_id || "")) {
                  onDirectUpdate(item.id, { hidden_id: hiddenId.trim() });
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.target.blur();
                }
              }}
              placeholder="Hidden ID numarasını buraya yazın..."
              className="w-full h-[28px] rounded-lg border border-emerald-500 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-emerald-950 dark:text-emerald-200 outline-none shadow-xs"
            />
          </div>
        ) : isRejected ? (
          <div className="flex flex-col gap-1">
            <input
              value={rejectionNote}
              onChange={(e) => setRejectionNote(e.target.value)}
              onBlur={() => {
                if (rejectionNote !== (item.rejection_note || "")) {
                  onDirectUpdate(item.id, { rejection_note: rejectionNote.trim() });
                }
              }}
              placeholder="Red gerekçesi yazın..."
              className="w-full h-[28px] rounded-lg border border-red-300 dark:border-red-500/30 bg-white dark:bg-[#1c1c20] px-2 text-xs font-bold text-red-950 dark:text-red-200 outline-none shadow-xs"
            />
          </div>
        ) : (
          <div className="flex flex-col gap-1">
            <input
              type="datetime-local"
              value={followUpDate}
              onChange={(e) => {
                const val = e.target.value;
                setFollowUpDate(val);
                onDirectUpdate(item.id, { next_followup_at: val });
              }}
              className="w-full h-[26px] rounded-lg border border-amber-400 bg-white dark:bg-[#1c1c20] px-2 text-xs font-black text-black dark:text-white outline-none shadow-xs"
            />
            {item.contact_note && (
              <div className="text-[9px] text-slate-600 dark:text-white/60 truncate leading-tight">
                {item.contact_note}
              </div>
            )}
          </div>
        )}
      </td>

      {/* 8. SÜTUN: İŞLEM */}
      <td className="px-2.5 py-2.5 align-middle text-center">
        <button
          type="button"
          onClick={onOpenDetail}
          className="h-[34px] px-2.5 w-full inline-flex items-center justify-center rounded-lg border border-slate-300 dark:border-white/20 bg-slate-50 dark:bg-white/[0.05] text-xs font-black text-slate-900 dark:text-white hover:border-amber-500 hover:text-amber-700 transition shadow-xs"
        >
          Detay
        </button>
      </td>
    </tr>
  );
}

function MobileCandidateProcessCard({ item, currentUser, openCandidatePanel, setQuickEdit }) {
  const editable = canEditCandidate(currentUser, item);
  const agencyJoined = inferProcessStatus(item, "agency_join_status") === "evet";
  const agencyDisplay = agencyJoined && item.hidden_id
    ? `Katıldı • ${item.hidden_id}`
    : getProcessDisplayValue(item, "agency_join_note", "agency_join_status");

  const fields = [
    ["Aday Değerlendirmesi", getProcessDisplayValue(item, "suitability_note", "evaluation_status"), "suitability_note", "neutral"],
    ["Yayın İncelemesi", getProcessDisplayValue(item, "live_joined_note", "live_review_status"), "yayina_katildik", "neutral"],
    ["İletişim Durumu", getProcessDisplayValue(item, "contact_note", "contact_status"), "iletisim_kuruldu", "neutral"],
    ["Aday Profil Notu", getProcessDisplayValue(item, "publisher_about_note", "profile_note_status"), "publisher_about", "neutral"],
    ["Uygunluk Durumu", getSuitabilityLabel(item.suitability_status), "suitability_status", "neutral"],
    ["Olumsuzluk Gerekçesi", getProcessDisplayValue(item, "rejection_note", "rejection_status"), "reddetti", "red"],
    ["Ajans Katılımı", agencyDisplay, "ajansa_katildi", "green"],
  ];

  return (
    <article className={`rounded-xl border p-3 ${isPriorityCandidate(item) ? "border-yellow-400/25 bg-yellow-500/[0.055]" : "border-white/10 bg-white/[0.025]"}`}>
      <div className="flex items-start justify-between gap-3 border-b border-white/8 pb-3">
        <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
        <LeagueBadge league={item.candidate_league} />
      </div>

      <div className="mt-3 grid grid-cols-2 gap-2 text-[11px]">
        <div className="rounded-lg border border-white/8 bg-black/25 p-2.5">
          <div className="text-[9px] font-black uppercase tracking-[0.14em] text-white/30">Ekleyen</div>
          <div className="mt-1 font-semibold text-white/70">{item.owner_username || item.created_by_username || "-"}</div>
        </div>
        <button
          type="button"
          disabled={!editable}
          onClick={() => setQuickEdit(getQuickEditConfig(item, "suitability_status"))}
          className="rounded-lg border border-white/8 bg-black/25 p-2.5 text-left disabled:cursor-default"
        >
          <div className="text-[9px] font-black uppercase tracking-[0.14em] text-white/30">Uygunluk</div>
          <div className="mt-1"><NeutralStatusBadge label={getSuitabilityLabel(item.suitability_status)} /></div>
        </button>
      </div>

      <div className="mt-2 space-y-1.5">
        {fields.filter(([label]) => label !== "Uygunluk Durumu").map(([label, value, type, tone]) => (
          <button
            key={label}
            type="button"
            disabled={!editable}
            onClick={() => setQuickEdit(getQuickEditConfig(item, type))}
            className="flex w-full items-center justify-between gap-3 rounded-lg border border-white/8 bg-black/20 px-3 py-2 text-left disabled:cursor-default"
          >
            <span className="text-[10px] font-bold text-white/35">{label}</span>
            <MobileProcessValue value={value} tone={tone} />
          </button>
        ))}
        {item.phone && <div className="px-3 text-[10px] text-white/35">Telefon: {item.phone}</div>}
      </div>
    </article>
  );
}

function MobileProcessValue({ value, tone = "neutral" }) {
  if (!value || value === "-") return <span className="text-white/25">-</span>;
  const toneClass = tone === "green"
    ? "border-green-500/30 bg-green-500/10 text-green-300"
    : tone === "red"
    ? "border-red-500/30 bg-red-500/10 text-red-300"
    : "border-white/15 bg-white/[0.045] text-white/85";
  return <span className={`max-w-[58%] truncate rounded-full border px-2.5 py-1 text-[10px] font-bold ${toneClass}`}>{value}</span>;
}

function NeutralStatusBadge({ label, item }) {
  const key = item?.suitability_status || "beklemede";
  const verifiedBy = item?.suitability_verified_by;
  const verifiedAt = item?.suitability_verified_at;

  let toneClass = "border-white/15 bg-white/[0.04] text-white/70";
  if (key === "uygun") {
    toneClass = "border-green-500/40 bg-green-500/15 text-green-300 font-bold shadow-[0_0_12px_rgba(34,197,94,0.15)]";
  } else if (key === "baska_ajansa_bagli") {
    toneClass = "border-red-500/50 bg-red-500/20 text-red-300 font-black";
  } else if (key === "soguma_doneminde") {
    toneClass = "border-amber-500/40 bg-amber-500/15 text-amber-300 font-bold";
  } else if (key === "uygun_degil") {
    toneClass = "border-red-500/30 bg-red-500/10 text-red-400";
  }

  const tooltip = verifiedBy
    ? `🛡️ Teyit Eden: @${verifiedBy} (${formatDateTr(verifiedAt)})`
    : "TikTok Backstage teyidi yapmak için tıklayın";

  return (
    <span
      title={tooltip}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[10px] ${toneClass}`}
    >
      {key === "baska_ajansa_bagli" ? "⛔ BAŞKA AJANSTA" : getSuitabilityLabel(key)}
    </span>
  );
}

function ProcessValueCell({ editable, value, detail = "", onClick, tone = "neutral", strong = false }) {
  const hasValue = Boolean(value && value !== "-");
  const toneClass =
    tone === "green"
      ? "border-green-500/35 bg-green-500/10 text-green-300"
      : tone === "red"
      ? "border-red-500/30 bg-red-500/10 text-red-300"
      : "border-white/15 bg-white/[0.045] text-white/85";

  return (
    <td
      className={`max-w-[190px] px-3 py-2.5 ${editable ? "cursor-pointer hover:bg-white/[0.025]" : ""}`}
      onClick={(event) => {
        event.stopPropagation();
        if (!editable) return;
        onClick();
      }}
    >
      {hasValue ? (
        <div>
          <span
            title={value}
            className={`inline-flex max-w-[175px] truncate rounded-full border px-2.5 py-1 text-[10px] ${strong ? "font-black" : "font-bold"} ${toneClass}`}
          >
            {value}
          </span>
          {detail && <div className="mt-1 truncate text-[9px] text-white/35" title={detail}>{detail}</div>}
        </div>
      ) : (
        <span className="inline-flex min-w-[30px] justify-center text-xs font-bold text-white/25">-</span>
      )}
    </td>
  );
}


function CandidateQueryModal({ close, onSelectCandidate, rows = [] }) {
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");

  async function handleSearch(e) {
    if (e) e.preventDefault();
    const cleanUser = username.trim().replace(/^@/, "");
    if (!cleanUser) {
      setError("Lütfen bir TikTok kullanıcı adı girin.");
      return;
    }

    setLoading(true);
    setError("");
    setResult(null);
    setCopied(false);

    // 1. Yerel veritabanında var mı kontrol et
    const existingInDb = rows.find(
      (r) => (r.tiktok_username || "").replace(/^@/, "").toLowerCase() === cleanUser.toLowerCase()
    );

    // 2. TikTok'tan canlı profil çek
    let tiktokData = null;
    try {
      const res = await fetch(`/api/tiktok-profile-fetch.php?username=${encodeURIComponent(cleanUser)}`);
      const json = await res.json();
      if (json && json.data) {
        tiktokData = json.data;
      }
    } catch (err) {}

    setResult({
      cleanUser,
      existingInDb,
      tiktokData: tiktokData || {
        username: cleanUser,
        fullName: cleanUser,
        avatar: "",
        followerCount: 0
      }
    });

    setLoading(false);
  }

  function handleOpenBackstage(userToCopy) {
    const target = userToCopy || username.trim().replace(/^@/, "");
    if (target && navigator.clipboard) {
      navigator.clipboard.writeText(target).catch(() => {});
      setCopied(true);
      setTimeout(() => setCopied(false), 4000);
    }
    window.open("https://live-backstage.tiktok.com/portal/overview", "_blank");
  }

  function handleTransferToFastInput() {
    if (!result) return;
    const el = document.getElementById("scout-fast-username-input");
    if (el) {
      el.value = result.cleanUser;
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.focus();
    }
    if (typeof onSelectCandidate === "function") {
      onSelectCandidate(result);
    }
    close();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm px-3 py-6 sm:px-4">
      <div className="w-full max-w-[560px] rounded-2xl border border-yellow-500/30 bg-[#0d0d11] p-5 shadow-2xl sm:p-6 text-white">
        <div className="flex items-start justify-between gap-4 border-b border-white/10 pb-3">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.26em] text-yellow-400">SCOUT CANLI ADAY SORGULAMA</div>
            <h2 className="mt-1 text-xl font-black text-white sm:text-2xl">TikTok & Backstage Doğrulama</h2>
          </div>
          <button type="button" onClick={close} className="rounded-lg border border-white/10 bg-white/[0.05] px-3 py-1.5 text-xs font-bold text-white/70 hover:text-white transition">
            ✕ Kapat
          </button>
        </div>

        <form onSubmit={handleSearch} className="mt-4">
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/70">TikTok Kullanıcı Adı veya Profil Linki</span>
            <div className="flex items-center rounded-xl border border-white/20 bg-black/60 px-3 focus-within:border-yellow-400 transition">
              <span className="text-sm font-black text-amber-500 mr-1">@</span>
              <input
                autoFocus
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setError("");
                }}
                placeholder="kullanici_adi"
                className="min-w-0 flex-1 bg-transparent py-3 text-sm text-white font-bold outline-none placeholder:text-white/30"
              />
              <button
                type="submit"
                disabled={loading || !username.trim()}
                className="ml-2 rounded-lg bg-yellow-500 px-4 py-2 text-xs font-black text-black hover:bg-yellow-400 disabled:opacity-40 transition"
              >
                {loading ? "⏳ Sorgulanıyor..." : "🔍 Sorgula"}
              </button>
            </div>
          </label>
        </form>

        {error && (
          <div className="mt-3 rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-xs font-bold text-red-300">
            ⚠️ {error}
          </div>
        )}

        {copied && (
          <div className="mt-3 rounded-xl border border-green-500/30 bg-green-500/15 p-2.5 text-xs font-black text-green-300 flex items-center gap-2">
            <span>📋</span>
            <span>Kullanıcı adı panoya kopyalandı! Backstage sekmesinde arama kutusuna (Ctrl+V) yapıştırabilirsiniz.</span>
          </div>
        )}

        {result && (
          <div className="mt-4 space-y-3">
            {/* Sistem Durumu (Var mı yok mu) */}
            {result.existingInDb ? (
              <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3.5">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-black text-amber-400">⚠️ Bu Aday Zaten Sistemde Kayıtlı!</span>
                  <span className="rounded bg-amber-500/20 px-2 py-0.5 text-[10px] font-black text-amber-300">
                    Durum: {result.existingInDb.status || "Aktif"}
                  </span>
                </div>
                <div className="mt-1 text-xs text-white/80">
                  Ekleyen Scout: <strong className="text-white">@{result.existingInDb.owner_username || result.existingInDb.created_by_username || "Belirtilmemiş"}</strong>
                </div>
              </div>
            ) : (
              <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-3">
                <span className="text-xs font-black text-emerald-400">✅ Yeni Aday — Sistemde henüz kaydı bulunmuyor.</span>
              </div>
            )}

            {/* TikTok Profil Kartı */}
            <div className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/[0.04] p-3">
              {result.tiktokData.avatar ? (
                <img src={result.tiktokData.avatar} alt="" className="h-12 w-12 rounded-full object-cover border border-amber-400" />
              ) : (
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-zinc-800 text-sm font-black text-yellow-400 border border-white/20">
                  {result.cleanUser.slice(0, 2).toUpperCase()}
                </span>
              )}
              <div className="min-w-0 flex-1">
                <div className="text-sm font-black text-white truncate">{result.tiktokData.fullName || result.cleanUser}</div>
                <div className="text-xs font-bold text-amber-400">@{result.cleanUser}</div>
                <div className="text-[11px] text-white/60 font-medium">
                  {result.tiktokData.followerCount ? `${result.tiktokData.followerCount} Takipçi` : "TikTok Adayı"}
                </div>
              </div>
            </div>

            {/* Aksiyon Butonları */}
            <div className="grid grid-cols-2 gap-2 pt-2">
              <button
                type="button"
                onClick={() => handleOpenBackstage(result.cleanUser)}
                className="inline-flex items-center justify-center gap-1.5 rounded-xl border border-amber-500/50 bg-amber-500/20 py-2.5 text-xs font-black text-yellow-300 hover:bg-amber-500 hover:text-black transition"
              >
                <span>🎯 Backstage'de Aç</span>
              </button>
              <button
                type="button"
                onClick={handleTransferToFastInput}
                className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-yellow-500 py-2.5 text-xs font-black text-black hover:bg-yellow-400 transition"
              >
                <span>➕ Tabloya Aktar</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function QuickEditModal({ quickEdit, close, save }) {
  const [customText, setCustomText] = useState(quickEdit?.customText || "");
  const [selectedStatus, setSelectedStatus] = useState(quickEdit?.selectedStatus || "");
  const [phone, setPhone] = useState(quickEdit?.phone || "");
  const [hiddenId, setHiddenId] = useState(quickEdit?.hiddenId || "");
  const [suitabilityConfirmed, setSuitabilityConfirmed] = useState(false);
  const [error, setError] = useState("");

  if (!quickEdit) return null;

  const isSuitability = quickEdit.type === "suitability_status";
  const isContact = quickEdit.type === "iletisim_kuruldu";
  const isAgencyJoin = quickEdit.type === "ajansa_katildi";
  const options = isSuitability
    ? suitabilityOptions
    : processStatusOptions[quickEdit.statusField] || [];

  function handleSave() {
    if (isSuitability && selectedStatus === "uygun" && !suitabilityConfirmed) {
      setError("Adayı 'Uygun' olarak onaylamak için lütfen Backstage teyit kutucuğunu işaretleyiniz.");
      return;
    }
    if (isAgencyJoin && selectedStatus === "evet" && !/^\d{5,64}$/.test(hiddenId.trim())) {
      setError("Ajans katılımı Evet seçildiğinde 5-64 haneli Hidden ID zorunludur.");
      return;
    }
    setError("");
    save(quickEdit, {
      customText,
      selectedStatus,
      phone,
      hiddenId,
    });
  }

  const cleanUser = String(quickEdit.candidate?.tiktok_username || "").replace(/^@/, "");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 px-3 py-5 sm:px-4">
      <div className="max-h-[92vh] w-full max-w-[580px] overflow-y-auto rounded-2xl border border-yellow-500/25 bg-[#080808] p-4 shadow-[0_25px_90px_rgba(0,0,0,.75)] sm:p-5">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-yellow-300">
              {isSuitability ? "🛡️ TİKTOK BACKSTAGE UYGUNLUK TEYİT PANELİ" : quickEdit.title}
            </div>
            <h2 className="mt-2 text-xl font-black text-white sm:text-2xl">{quickEdit.candidate?.tiktok_username}</h2>
            <p className="mt-2 text-xs leading-5 text-white/40 sm:text-sm">
              {isSuitability
                ? "Ajans güvenliği için uygunluk durumu teyitli olarak kaydedilir."
                : "Özel açıklama yazılırsa tabloda seçim yerine yalnızca açıklama gösterilir."}
            </p>
          </div>

          <button type="button" onClick={close} className="rounded-lg border border-white/10 px-3 py-2 text-xs font-bold text-white/60 hover:text-white">Kapat</button>
        </div>

        {isSuitability && (
          <div className="mb-4 space-y-3 rounded-2xl border border-yellow-500/30 bg-gradient-to-b from-yellow-500/[0.08] to-transparent p-4">
            <div className="flex items-start gap-2.5 rounded-xl border border-red-500/30 bg-red-500/10 p-3 text-xs leading-5 text-red-200">
              <span className="text-base">⚠️</span>
              <div>
                <strong className="block text-red-300 font-black uppercase tracking-wider">KRİTİK AJANS GÜVENLİK KURALI:</strong>
                Başka bir ajansa bağlı yayıncıya teklif veya davet göndermek ajansımızın TikTok lisansını ve davet kotasını riske atar. Lütfen Backstage sorgusunu bizzat yapmadan onay vermeyiniz.
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-2 rounded-xl border border-white/10 bg-black/40 p-3">
              <div className="text-xs text-white/70">
                Aday: <span className="font-black text-yellow-300">@{cleanUser}</span>
              </div>
              <button
                type="button"
                onClick={() => {
                  if (navigator.clipboard) navigator.clipboard.writeText(cleanUser);
                  window.open("https://live-backstage.tiktok.com/", "_blank");
                }}
                className="inline-flex items-center gap-1.5 rounded-lg border border-yellow-500/40 bg-yellow-500/20 px-3 py-1.5 text-xs font-black text-yellow-200 hover:bg-yellow-500 hover:text-black transition"
              >
                <span>🎯 Kullanıcıyı Kopyala & Backstage'de Aç</span>
              </button>
            </div>

            <label className="block">
              <span className="mb-1.5 block text-xs font-bold text-white/80">TikTok Backstage Sorgu Sonucu *</span>
              <select
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  setError("");
                }}
                className="w-full rounded-xl border border-yellow-500/30 bg-black/60 px-3 py-3 text-sm font-bold text-white outline-none focus:border-yellow-400"
              >
                {options.map((item) => (
                  <option key={item.key} value={item.key}>{item.label}</option>
                ))}
              </select>
            </label>

            {selectedStatus === "uygun" && (
              <label className="flex items-start gap-3 rounded-xl border border-green-500/40 bg-green-500/10 p-3.5 cursor-pointer">
                <input
                  type="checkbox"
                  checked={suitabilityConfirmed}
                  onChange={(e) => {
                    setSuitabilityConfirmed(e.target.checked);
                    setError("");
                  }}
                  className="mt-0.5 h-4 w-4 rounded accent-green-500"
                />
                <span className="text-xs font-bold leading-5 text-green-200">
                  TikTok LIVE Backstage üzerinden adayın sorgusunu bizzat yaptım; adayın başka bir ajansa bağlı OLMADIĞINI ve davet edilebilir olduğunu teyit ediyorum.
                </span>
              </label>
            )}

            {selectedStatus === "baska_ajansa_bagli" && (
              <div className="rounded-xl border border-red-500/40 bg-red-500/15 p-3 text-xs leading-5 text-red-200">
                ⛔ <strong>GÜVENLİK KİLİDİ AKTİF:</strong> Bu aday sisteme <strong>"Başka Ajansa Bağlı"</strong> olarak işlenecek, otomatik kara listeye alınacak ve personelin yanlışlıkla WhatsApp daveti göndermesi kilitlenecektir.
              </div>
            )}
          </div>
        )}

        {!isSuitability && (
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">{quickEdit.noteLabel || "Özel Açıklama (öncelikli)"}</span>
            <textarea
              value={customText}
              onChange={(event) => setCustomText(event.target.value)}
              rows={3}
              className="w-full rounded-xl border border-white/10 bg-black/40 px-3 py-2.5 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35"
              placeholder="Bu alan doldurulursa tabloda sadece bu metin görünür..."
            />
          </label>
        )}

        {!isSuitability && (
          <label className="mt-4 block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Hazır Durum</span>
            <select
              value={selectedStatus}
              onChange={(event) => {
                setSelectedStatus(event.target.value);
                setError("");
              }}
              className="w-full rounded-xl border border-white/10 bg-black/40 px-3 py-2.5 text-sm text-white outline-none focus:border-yellow-500/35"
            >
              <option value="">Seçim yapılmadı</option>
              {options.map((item) => (
                <option key={item.key} value={item.key}>{item.label}</option>
              ))}
            </select>
          </label>
        )}

        {isContact && (
          <label className="mt-4 block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Telefon / WhatsApp</span>
            <input
              value={phone}
              onChange={(event) => setPhone(event.target.value)}
              className="w-full rounded-xl border border-white/10 bg-black/40 px-3 py-2.5 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35"
              placeholder="Telefon numarası giriniz..."
            />
          </label>
        )}

        {isAgencyJoin && selectedStatus === "evet" && (
          <label className="mt-4 block rounded-2xl border border-green-500/25 bg-green-500/[0.07] p-4">
            <span className="mb-1.5 block text-xs font-black uppercase tracking-[0.18em] text-green-300">Hidden ID *</span>
            <input
              value={hiddenId}
              onChange={(event) => {
                setHiddenId(event.target.value.replace(/\D/g, ""));
                setError("");
              }}
              inputMode="numeric"
              maxLength={64}
              className="w-full rounded-2xl border border-green-500/25 bg-black/50 px-4 py-3 text-sm font-bold text-green-200 outline-none placeholder:text-white/25 focus:border-green-400/50"
              placeholder="TikTok Hidden ID giriniz"
            />
            <div className="mt-2 text-[11px] text-green-200/55">Kaydedildiğinde tabloda olumlu renk tonuyla gösterilir.</div>
          </label>
        )}

        {error && (
          <div className="mt-4 rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-3 text-sm font-semibold text-red-200">{error}</div>
        )}

        <div className="mt-5 flex justify-end gap-3">
          <button type="button" onClick={close} className="rounded-xl border border-white/10 px-4 py-2.5 text-sm font-bold text-white/60">İptal</button>
          <button type="button" onClick={handleSave} className="rounded-xl bg-yellow-500 px-4 py-2.5 text-sm font-black text-black">
            {isSuitability ? "Doğrula ve Kaydet" : "Kaydet"}
          </button>
        </div>
      </div>
    </div>
  );
}

function StageBadge({ active, label, green = false }) {
  if (!active) {
    return (
      <span className="inline-flex rounded-full border border-white/10 bg-white/[0.035] px-3 py-1 text-[11px] font-black text-white/35">
        {label}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex rounded-full border px-3 py-1 text-[11px] font-black ${
        green
          ? "border-green-500/30 bg-green-500/12 text-green-300"
          : "border-yellow-400/35 bg-yellow-500/15 text-yellow-200"
      }`}
    >
      {label}
    </span>
  );
}

function LifecycleBadge({ candidate }) {
  const stage = getLifecycleStage(candidate);
  const follow = getFollowUpState(candidate);

  if (stage === "scout_asamasi") {
    return (
      <span className="inline-flex rounded-full border border-white/15 bg-white/[0.04] px-2.5 py-1 text-[10px] font-black text-white/70">
        Scout Aşaması
      </span>
    );
  }

  if (stage === "yeni_yayinci_takipte") {
    return (
      <span className="scout-status-warning inline-flex rounded-full border px-2.5 py-1 text-[10px] font-medium">
        Yeni Yayıncı • {follow.remainingDays} Gün Kaldı
      </span>
    );
  }

  if (stage === "yonetici_atama_bekliyor") {
    return (
      <span className="scout-status-purple inline-flex rounded-full border px-2.5 py-1 text-[10px] font-medium">
        Yönetici Atama Bekliyor
      </span>
    );
  }

  return (
    <span className="scout-status-success inline-flex rounded-full border px-2.5 py-1 text-[10px] font-medium">
      Yönetici Takibinde
    </span>
  );
}

function ScoutFollowUpView({ rows, currentUser, openCandidatePanel, openFollowUpModal }) {
  const adminView = canAssignManager(currentUser) || isAdminLike(currentUser);

  const followUpRows = rows
    .filter((item) => getLifecycleStage(item) === "yeni_yayinci_takipte")
    .filter((item) => {
      if (adminView) return true;
      return (
        String(item.owner_username || item.created_by_username || "") ===
        String(currentUser?.username || "")
      );
    })
    .sort((a, b) => Number(a.follow_up_state?.remainingDays ?? 99) - Number(b.follow_up_state?.remainingDays ?? 99));

  return (
    <section className="py-5">
      <PageTitle
        badge="SCOUT TAKİP"
        title="15 Günlük Yeni Yayıncı Takibi"
        desc="Ajansa katılan yayıncı, katılım tarihinden itibaren 15 gün boyunca onu sisteme ekleyen scout tarafından takip edilir."
      />

      <div className="mb-4 grid grid-cols-2 gap-2.5 md:grid-cols-4">
        <MetricCard title="Takipte" value={followUpRows.length} note="Yeni yayıncı" />
        <MetricCard
          title="5 Gün ve Altı"
          value={followUpRows.filter((item) => Number(item.follow_up_state?.remainingDays) <= 5).length}
          note="Devir yaklaşıyor"
        />
      </div>

      <div className="overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] shadow-sm">
        <div className="space-y-2 p-3 md:hidden">
          {followUpRows.length === 0 ? (
            <div className="px-3 py-6 text-center text-sm text-white/40">Takipte yayıncı bulunamadı.</div>
          ) : (
            followUpRows.map((item) => (
              <article key={item.id} className="rounded-xl border border-white/10 bg-black/25 p-3">
                <div className="flex items-start justify-between gap-3">
                  <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
                  <LifecycleBadge candidate={item} />
                </div>
                <div className="mt-3 grid grid-cols-2 gap-2">
                  <MobileInfoBox label="Ajansa Katılım" value={formatDateTr(item.joined_at)} />
                  <MobileInfoBox label="Takip Sorumlusu" value={item.owner_username || item.created_by_username || "-"} />
                </div>
                <button
                  type="button"
                  onClick={() => openFollowUpModal(item)}
                  className="mt-3 w-full rounded-lg bg-yellow-500 px-3 py-2.5 text-xs font-black text-black"
                >
                  Görüşme / Takip Kaydı Ekle
                </button>
              </article>
            ))
          )}
        </div>

        <div className="hidden overflow-x-auto md:block">
          <table className="w-full min-w-[1020px] text-left text-xs">
            <thead>
              <tr className="border-b border-white/10 text-[9px] font-black uppercase tracking-[0.16em] text-white/35">
                <th className="px-3 py-3">Yayıncı</th>
                <th className="px-3 py-3">Ajansa Katılım</th>
                <th className="px-3 py-3">15 Günlük Süre</th>
                <th className="px-3 py-3">Takip Sorumlusu</th>
                <th className="px-3 py-3">Son Görüşme</th>
                <th className="px-3 py-3">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {followUpRows.length === 0 ? (
                <tr>
                  <td colSpan="6" className="px-3 py-6 text-white/40">Takipte yayıncı bulunamadı.</td>
                </tr>
              ) : (
                followUpRows.map((item) => {
                  const logs = Array.isArray(item.follow_up_logs) ? item.follow_up_logs : [];
                  const lastLog = logs[0] || null;

                  return (
                    <tr key={item.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                      <td className="px-3 py-3">
                        <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
                      </td>
                      <td className="px-3 py-3 text-white/60">{formatDateTr(item.joined_at)}</td>
                      <td className="px-3 py-3"><LifecycleBadge candidate={item} /></td>
                      <td className="px-3 py-3 text-white/60">{item.owner_username || item.created_by_username || "-"}</td>
                      <td className="max-w-[260px] px-3 py-3 text-white/50">
                        {lastLog ? (
                          <div>
                            <div className="truncate font-bold text-white/70">{lastLog.title}</div>
                            <div className="mt-1 truncate text-[10px] text-white/35">{formatDateTr(lastLog.created_at)}</div>
                          </div>
                        ) : "Henüz kayıt yok"}
                      </td>
                      <td className="px-3 py-3">
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => openFollowUpModal(item)}
                            className="rounded-lg bg-yellow-500 px-3 py-2 text-[11px] font-black text-black"
                          >
                            Görüşme Ekle
                          </button>
                          <button
                            type="button"
                            onClick={() => openCandidatePanel(item)}
                            className="rounded-lg border border-white/10 bg-white/[0.035] px-3 py-2 text-[11px] font-bold text-white/65"
                          >
                            Detay
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function PublisherManagementView({
  rows,
  currentUser,
  openCandidatePanel,
  openAssignManagerModal,
  openFollowUpModal,
}) {
  const role = String(currentUser?.role || "").toLowerCase().trim();
  const managerOnly = role === "publisher_manager";

  const visibleRows = rows
    .filter((item) => {
      const stage = getLifecycleStage(item);
      if (managerOnly) {
        return (
          stage === "yonetici_takibinde" &&
          String(item.manager_username || "") === String(currentUser?.username || "")
        );
      }
      return ["yonetici_atama_bekliyor", "yonetici_takibinde"].includes(stage);
    })
    .sort((a, b) => String(b.manager_assigned_at || b.joined_at || "").localeCompare(String(a.manager_assigned_at || a.joined_at || "")));

  const waitingRows = visibleRows.filter((item) => getLifecycleStage(item) === "yonetici_atama_bekliyor");
  const assignedRows = visibleRows.filter((item) => getLifecycleStage(item) === "yonetici_takibinde");

  return (
    <section className="py-5">
      <PageTitle
        badge="YAYINCI YÖNETİMİ"
        title="Yayıncı Yönetim Paneli"
        desc="15 günlük scout takibi tamamlanan yayıncılar Scout Müdürü tarafından yayıncı yöneticisine atanır. Geçmiş kayıtlar yayıncıyla birlikte korunur."
      />

      <section className="mb-4 grid grid-cols-2 gap-2.5 md:grid-cols-4">
        {!managerOnly && <MetricCard title="Atama Bekleyen" value={waitingRows.length} note="Scout Müdürü atayacak" />}
        <MetricCard title="Yönetici Takibinde" value={assignedRows.length} note="Aktif yayıncı" />
      </section>

      <div className="overflow-hidden rounded-2xl border border-yellow-500/20 bg-white/[0.025]">
        <div className="space-y-2 p-3 md:hidden">
          {visibleRows.length === 0 ? (
            <div className="px-3 py-6 text-center text-sm text-white/40">Kayıt bulunamadı.</div>
          ) : (
            visibleRows.map((item) => {
              const stage = getLifecycleStage(item);
              const assignable = stage === "yonetici_atama_bekliyor" && canAssignManager(currentUser);
              return (
                <article key={item.id} className="rounded-xl border border-white/10 bg-black/25 p-3">
                  <div className="flex items-start justify-between gap-3">
                    <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
                    <LifecycleBadge candidate={item} />
                  </div>
                  <div className="mt-3 grid grid-cols-2 gap-2">
                    <MobileInfoBox label="Scout" value={item.owner_username || item.created_by_username || "-"} />
                    <MobileInfoBox label="Yönetici" value={item.manager_username || "Atanmadı"} />
                  </div>
                  {assignable && (
                    <button
                      type="button"
                      onClick={() => openAssignManagerModal(item)}
                      className="mt-3 w-full rounded-lg bg-yellow-500 px-3 py-2.5 text-xs font-black text-black"
                    >
                      Yayıncı Yöneticisi Ata
                    </button>
                  )}
                </article>
              );
            })
          )}
        </div>

        <div className="hidden overflow-x-auto md:block">
          <table className="w-full min-w-[1100px] text-left text-xs">
            <thead>
              <tr className="border-b border-white/10 text-[9px] font-black uppercase tracking-[0.16em] text-white/35">
                <th className="px-3 py-3">Yayıncı</th>
                <th className="px-3 py-3">Scout</th>
                <th className="px-3 py-3">Ajansa Katılım</th>
                <th className="px-3 py-3">Durum</th>
                <th className="px-3 py-3">Yayıncı Yöneticisi</th>
                <th className="px-3 py-3">Atama Tarihi</th>
                <th className="px-3 py-3">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.length === 0 ? (
                <tr><td colSpan="7" className="px-3 py-6 text-white/40">Kayıt bulunamadı.</td></tr>
              ) : (
                visibleRows.map((item) => {
                  const stage = getLifecycleStage(item);
                  const assignable = stage === "yonetici_atama_bekliyor" && canAssignManager(currentUser);

                  return (
                    <tr key={item.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                      <td className="px-3 py-3">
                        <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
                      </td>
                      <td className="px-3 py-3 text-white/60">{item.owner_username || item.created_by_username || "-"}</td>
                      <td className="px-3 py-3 text-white/60">{formatDateTr(item.joined_at)}</td>
                      <td className="px-3 py-3"><LifecycleBadge candidate={item} /></td>
                      <td className="px-3 py-3 text-white/60">{item.manager_username || "-"}</td>
                      <td className="px-3 py-3 text-white/45">{item.manager_assigned_at ? formatDateTr(item.manager_assigned_at) : "-"}</td>
                      <td className="px-3 py-3">
                        <div className="flex gap-2">
                          {assignable && (
                            <button
                              type="button"
                              onClick={() => openAssignManagerModal(item)}
                              className="rounded-lg bg-yellow-500 px-3 py-2 text-[11px] font-black text-black"
                            >
                              Yönetici Ata
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => openCandidatePanel(item)}
                            className="rounded-lg border border-white/10 bg-white/[0.035] px-3 py-2 text-[11px] font-bold text-white/65"
                          >
                            Geçmişi Gör
                          </button>
                          {stage === "yonetici_takibinde" && managerOnly && (
                            <button
                              type="button"
                              onClick={() => openFollowUpModal(item)}
                              className="rounded-lg border border-green-500/25 bg-green-500/10 px-3 py-2 text-[11px] font-bold text-green-300"
                            >
                              Not Ekle
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function FollowUpModal({ candidate, close, save, currentUser }) {
  const [logType, setLogType] = useState("gorusme_notu");
  const [title, setTitle] = useState("");
  const [note, setNote] = useState("");
  const [error, setError] = useState("");

  const logTypes = [
    { key: "gorusme_notu", label: "Görüşme Notu" },
    { key: "yayin_saatleri", label: "Yayın Saatleri" },
    { key: "yayin_icerigi", label: "Yayın İçeriği" },
    { key: "yayin_ihtiyaclari", label: "Yayıncılık İhtiyaçları" },
    { key: "teknik_ihtiyac", label: "Teknik İhtiyaç" },
    { key: "destek_notu", label: "Destek / Eğitim Notu" },
  ];

  function handleSave() {
    if (!title.trim() || !note.trim()) {
      setError("Başlık ve açıklama zorunludur.");
      return;
    }

    save({
      candidate_id: candidate.id,
      log_type: logType,
      title: title.trim(),
      note: note.trim(),
      created_at: new Date().toISOString().slice(0, 19).replace("T", " "),
      created_by_user_id: currentUser?.id || null,
      created_by_username: currentUser?.username || "",
    });
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 px-3 py-5 sm:px-4">
      <div className="w-full max-w-[650px] rounded-2xl border border-yellow-500/25 bg-[#080808] p-5 shadow-[0_25px_90px_rgba(0,0,0,.75)]">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.28em] text-yellow-300">YAYINCI TAKİP KAYDI</div>
            <h2 className="mt-2 text-2xl font-black text-white">{candidate?.tiktok_username}</h2>
            <p className="mt-2 text-sm text-white/45">Yayıncıyla yapılan görüşme ve takip bilgisini kalıcı geçmişe ekleyin.</p>
          </div>
          <button type="button" onClick={close} className="rounded-lg border border-white/10 px-3 py-2 text-xs font-bold text-white/60">Kapat</button>
        </div>

        <div className="grid gap-4">
          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Kayıt Türü</span>
            <select
              value={logType}
              onChange={(event) => setLogType(event.target.value)}
              className="w-full rounded-2xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white outline-none focus:border-yellow-500/35"
            >
              {logTypes.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}
            </select>
          </label>

          <Input
            label="Başlık"
            name="followup_title"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
              setError("");
            }}
            placeholder="Örn: İlk görüşme, yayın düzeni, destek ihtiyacı..."
          />

          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Açıklama</span>
            <textarea
              rows={5}
              value={note}
              onChange={(event) => {
                setNote(event.target.value);
                setError("");
              }}
              className="w-full rounded-2xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35"
              placeholder="Yayın saatleri, içerik, ihtiyaçlar veya görüşme notunu yazın..."
            />
          </label>

          {error && <div className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-3 text-sm font-semibold text-red-200">{error}</div>}

          <div className="flex justify-end gap-3">
            <button type="button" onClick={close} className="rounded-xl border border-white/10 px-4 py-2.5 text-sm font-bold text-white/60">İptal</button>
            <button type="button" onClick={handleSave} className="rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AssignManagerModal({ candidate, close, save }) {
  const [managerUsername, setManagerUsername] = useState("");
  const [managerUserId, setManagerUserId] = useState("");
  const [error, setError] = useState("");

  function handleSave() {
    if (!managerUsername.trim()) {
      setError("Yayıncı yöneticisi seçilmelidir.");
      return;
    }

    save({
      candidate_id: candidate.id,
      manager_user_id: managerUserId.trim(),
      manager_username: managerUsername.trim(),
      manager_assigned_at: new Date().toISOString().slice(0, 19).replace("T", " "),
    });
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 px-3 py-5 sm:px-4">
      <div className="w-full max-w-[560px] rounded-2xl border border-yellow-500/25 bg-[#080808] p-5 shadow-[0_25px_90px_rgba(0,0,0,.75)]">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.28em] text-yellow-300">YÖNETİCİ ATAMA</div>
            <h2 className="mt-2 text-2xl font-black text-white">{candidate?.tiktok_username}</h2>
            <p className="mt-2 text-sm text-white/45">15 günlük scout takibi tamamlanan yayıncıyı uygun yayıncı yöneticisine devredin.</p>
          </div>
          <button type="button" onClick={close} className="rounded-lg border border-white/10 px-3 py-2 text-xs font-bold text-white/60">Kapat</button>
        </div>

        <div className="grid gap-4">
          <Input
            label="Yayıncı Yöneticisi Kullanıcı Adı *"
            name="manager_username"
            value={managerUsername}
            onChange={(event) => {
              setManagerUsername(event.target.value);
              setError("");
            }}
            placeholder="Örn: caner.yilmaz"
          />

          <Input
            label="Yönetici Kullanıcı ID"
            name="manager_user_id"
            value={managerUserId}
            onChange={(event) => setManagerUserId(event.target.value)}
            placeholder="Opsiyonel"
          />

          {error && <div className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-3 text-sm font-semibold text-red-200">{error}</div>}

          <div className="flex justify-end gap-3">
            <button type="button" onClick={close} className="rounded-xl border border-white/10 px-4 py-2.5 text-sm font-bold text-white/60">İptal</button>
            <button type="button" onClick={handleSave} className="rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black">Yönetici Ata</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function CandidatePoolView({ rows, scoutStats, openCandidatePanel, openWhatsapp, currentUser }) {
  const [search, setSearch] = useState("");
  const [leagueFilter, setLeagueFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [suitabilityFilter, setSuitabilityFilter] = useState("all");
  const [scoutFilter, setScoutFilter] = useState("all");
  const [mineOnly, setMineOnly] = useState(false);

  const scoutNames = scoutStats.map((item) => item.scout);

  const filteredRows = rows.filter((item) => {
    const searchText = `${item.tiktok_username} ${item.category} ${item.owner_username} ${item.publisher_about_note} ${item.contact_note} ${item.rejection_note}`
      .toLowerCase()
      .includes(search.toLowerCase());
    const leagueOk = leagueFilter === "all" || item.candidate_league === leagueFilter;
    const statusOk = statusFilter === "all" || item.status === statusFilter;
    const suitabilityOk = suitabilityFilter === "all" || item.suitability_status === suitabilityFilter;
    const scoutOk = scoutFilter === "all" || item.owner_username === scoutFilter;
    const mineOk = !mineOnly ||
      String(item.owner_username || item.created_by_username || "") === String(currentUser?.username || "");

    return searchText && leagueOk && statusOk && suitabilityOk && scoutOk && mineOk;
  });

  return (
    <section className="py-5">
      <PageTitle
        badge="ADAY HAVUZU"
        title="Scout Aday Takip Havuzu"
        desc="Tüm scout ekibinin eklediği adayları görüntüleyin. Kullanıcı adına tıklayarak aday bilgi panelini açabilirsiniz."
      />

      <div className="mb-4 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-3 sm:p-4 shadow-sm">
        <div className="grid gap-2.5 sm:grid-cols-2 xl:grid-cols-[1.5fr_0.8fr_0.9fr_0.9fr_1fr_auto_auto]">
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Aday, kategori, scout veya not ara..."
            className="rounded-xl border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2.5 text-xs font-bold text-slate-900 dark:text-white outline-none placeholder:text-slate-400 dark:placeholder:text-white/30 focus:border-amber-500 sm:col-span-2 sm:text-sm xl:col-span-1 shadow-xs"
          />
          <select value={leagueFilter} onChange={(e) => setLeagueFilter(e.target.value)} className="rounded-xl border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2.5 text-xs font-bold text-slate-900 dark:text-white outline-none focus:border-amber-500 sm:text-sm shadow-xs">
            <option value="all">Tüm Ligler</option>
            {leagueOptions.map((item) => <option key={item} value={item}>{item} Ligi</option>)}
          </select>
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="rounded-xl border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2.5 text-xs font-bold text-slate-900 dark:text-white outline-none focus:border-amber-500 sm:text-sm shadow-xs">
            <option value="all">Tüm Durumlar</option>
            {statusOptions.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}
          </select>
          <select value={suitabilityFilter} onChange={(e) => setSuitabilityFilter(e.target.value)} className="rounded-xl border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2.5 text-xs font-bold text-slate-900 dark:text-white outline-none focus:border-amber-500 sm:text-sm shadow-xs">
            <option value="all">Tüm Uygunluk</option>
            {suitabilityOptions.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}
          </select>
          <select value={scoutFilter} onChange={(e) => setScoutFilter(e.target.value)} className="rounded-xl border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2.5 text-xs font-bold text-slate-900 dark:text-white outline-none focus:border-amber-500 sm:text-sm shadow-xs">
            <option value="all">Tüm Scoutlar</option>
            {scoutNames.map((name) => <option key={name} value={name}>{name}</option>)}
          </select>
          <button
            type="button"
            onClick={() => setMineOnly((prev) => !prev)}
            className={`rounded-xl px-4 py-2.5 text-xs font-black sm:text-sm ${
              mineOnly ? "bg-yellow-500 text-black" : "border border-yellow-500/25 bg-yellow-500/10 text-yellow-300"
            }`}
          >
            Benim Adaylarım
          </button>
          <button
            type="button"
            onClick={() => openCandidatePanel(null)}
            className="rounded-xl bg-yellow-500 px-4 py-2.5 text-xs font-black text-black sm:text-sm"
          >
            Yeni Aday
          </button>
        </div>
      </div>

      <CandidateTable
        rows={filteredRows}
        openCandidatePanel={openCandidatePanel}
        openWhatsapp={openWhatsapp}
        currentUser={currentUser}
      />
    </section>
  );
}

function CandidateTable({ rows, openCandidatePanel, openWhatsapp, currentUser }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-yellow-500/20 bg-white/[0.025]">
      <div className="space-y-2 p-3 md:hidden">
        {rows.length === 0 ? (
          <div className="px-3 py-6 text-center text-sm text-white/40">Kayıt bulunamadı.</div>
        ) : (
          rows.map((item) => {
            const editable = canEditCandidate(currentUser, item);
            return (
              <article key={item.id} className="rounded-xl border border-white/10 bg-black/25 p-3">
                <div className="flex items-start justify-between gap-3">
                  <CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact />
                  <LeagueBadge league={item.candidate_league} />
                </div>
                <div className="mt-3 grid grid-cols-2 gap-2 text-[11px]">
                  <MobileInfoBox label="Ekleyen" value={item.owner_username || item.created_by_username || "-"} />
                  <MobileInfoBox label="Uygunluk" value={getSuitabilityLabel(item.suitability_status)} />
                  <MobileInfoBox label="Son Durum" value={getStatusLabel(item.status)} />
                  <MobileInfoBox label="Telefon" value={item.phone || "-"} />
                </div>
                <div className="mt-2 rounded-lg border border-white/8 bg-black/20 p-2.5">
                  <div className="text-[9px] font-black uppercase tracking-[0.14em] text-white/30">Yayıncı Hakkında</div>
                  <div className="mt-1 line-clamp-2 text-xs leading-5 text-white/55">{item.publisher_about_note || item.contact_note || item.suitability_note || "-"}</div>
                </div>
                <div className="mt-3 grid grid-cols-2 gap-2">
                  <button
                    type="button"
                    onClick={() => openCandidatePanel(item)}
                    className={`rounded-lg px-3 py-2.5 text-xs font-black ${editable ? "bg-yellow-500 text-black" : "border border-white/10 bg-white/[0.035] text-white/55"}`}
                  >
                    {editable ? "Bilgi Paneli" : "Görüntüle"}
                  </button>
                  <button
                    type="button"
                    onClick={() => openWhatsapp(item)}
                    className="rounded-lg border border-green-500/25 bg-green-500/10 px-3 py-2.5 text-xs font-bold text-green-300"
                  >
                    WhatsApp
                  </button>
                </div>
              </article>
            );
          })
        )}
      </div>

      <div className="hidden overflow-x-auto md:block">
        <table className="w-full min-w-[1050px] text-left text-xs">
          <thead>
            <tr className="border-b border-white/10 text-[9px] font-black uppercase tracking-[0.16em] text-white/35">
              <th className="px-3 py-3">Aday</th>
              <th className="px-3 py-3">Lig</th>
              <th className="px-3 py-3">Ekleyen</th>
              <th className="px-3 py-3">Uygunluk</th>
              <th className="px-3 py-3">Son Durum</th>
              <th className="px-3 py-3">Telefon</th>
              <th className="px-3 py-3">Yayıncı Hakkında</th>
              <th className="px-3 py-3">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan="8" className="px-3 py-6 text-white/40">Kayıt bulunamadı.</td></tr>
            ) : (
              rows.map((item) => {
                const editable = canEditCandidate(currentUser, item);
                return (
                  <tr key={item.id} className="border-b border-white/5 hover:bg-white/[0.02]">
                    <td className="px-3 py-3"><CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} compact /></td>
                    <td className="px-3 py-3"><LeagueBadge league={item.candidate_league} /></td>
                    <td className="px-3 py-3 text-white/60">{item.owner_username || item.created_by_username || "-"}</td>
                    <td className="px-3 py-3"><SuitabilityBadge value={item.suitability_status} /></td>
                    <td className="px-3 py-3"><StatusBadge status={item.status} /></td>
                    <td className="px-3 py-3 text-white/55">{item.phone || "-"}</td>
                    <td className="max-w-[240px] truncate px-3 py-3 text-white/45">{item.publisher_about_note || item.contact_note || item.suitability_note || "-"}</td>
                    <td className="px-3 py-3">
                      <div className="flex gap-2">
                        <button
                          type="button"
                          onClick={() => openCandidatePanel(item)}
                          className={`rounded-lg px-3 py-2 text-[11px] font-black ${editable ? "bg-yellow-500 text-black" : "border border-white/10 bg-white/[0.035] text-white/55"}`}
                        >
                          {editable ? "Bilgi Paneli" : "Görüntüle"}
                        </button>
                        <button
                          type="button"
                          onClick={() => openWhatsapp(item)}
                          className="rounded-lg border border-green-500/25 bg-green-500/10 px-3 py-2 text-[11px] font-bold text-green-300"
                        >
                          WhatsApp
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function MobileInfoBox({ label, value }) {
  return (
    <div className="rounded-lg border border-white/8 bg-black/20 p-2.5">
      <div className="text-[9px] font-black uppercase tracking-[0.14em] text-white/30">{label}</div>
      <div className="mt-1 truncate font-semibold text-white/65">{value || "-"}</div>
    </div>
  );
}

function PriorityTable({ title, desc, rows, openCandidatePanel }) {
  return (
    <div className="scout-dashboard-panel min-h-[230px] rounded-[1.6rem] border border-yellow-400/30 p-5">
      <div className="mb-4 flex items-start justify-between gap-4">
        <div>
          <h2 className="text-xl font-black text-yellow-200">{title}</h2>
          <p className="mt-1 text-sm text-white/45">{desc}</p>
        </div>
        <span className="scout-count rounded-full border px-3 py-1 text-xs font-medium">
          {rows.length} aday
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[520px] text-left text-sm">
          <thead>
            <tr className="border-b border-yellow-500/20 text-xs font-black uppercase tracking-[0.2em] text-yellow-100/45">
              <th className="px-3 py-3">Aday</th>
              <th className="px-3 py-3">Lig</th>
              <th className="px-3 py-3">Ekleyen</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan="3" className="px-3 py-5 text-white/35">Yeni yayıncı adayı bulunmuyor.</td></tr>
            ) : (
              rows.map((item) => (
                <tr key={item.id} className="border-b border-white/5">
                  <td className="px-3 py-3"><CandidateIdentity candidate={item} onOpen={() => openCandidatePanel(item)} /></td>
                  <td className="px-3 py-3"><LeagueBadge league={item.candidate_league} /></td>
                  <td className="px-3 py-3 text-white/65">{item.owner_username || item.created_by_username || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function SmallTable({ title, desc, rows, columns, renderRow }) {
  return (
    <div className="scout-dashboard-panel rounded-[1.6rem] border border-yellow-500/20 p-5">
      <div className="mb-4">
        <h2 className="text-lg font-black text-yellow-300">{title}</h2>
        <p className="mt-1 text-sm text-white/45">{desc}</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[620px] text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-[#18181f] text-xs font-black uppercase tracking-[0.14em] text-slate-900 dark:text-white">
              {columns.map((column) => <th key={column} className="px-4 py-3">{column}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={columns.length} className="px-4 py-5 text-white/35">Kayıt bulunmuyor.</td></tr>
            ) : (
              rows.map((item) => <tr key={item.id} className="border-b border-white/5">{renderRow(item)}</tr>)
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ScoutGraphPanel({ scoutStats }) {
  const orderedStats = [...scoutStats].sort((a, b) => b.total - a.total);
  const maxValue = Math.max(...orderedStats.map((item) => item.total), 1);
  const totalCandidates = orderedStats.reduce((sum, item) => sum + Number(item.total || 0), 0);
  const totalJoined = orderedStats.reduce((sum, item) => sum + Number(item.joined || 0), 0);
  const averageRate = totalCandidates > 0 ? Math.round((totalJoined / totalCandidates) * 100) : 0;

  return (
    <div className="scout-dashboard-panel relative min-h-[310px] overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-4 sm:p-5 shadow-sm">
      <div className="scout-panel-glow pointer-events-none absolute -right-16 -top-20 h-52 w-52 rounded-full bg-yellow-500/10 blur-3xl" />

      <div className="relative">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.30em] text-yellow-300/80">
              Scout Analitik
            </div>
            <h2 className="mt-2 text-lg font-black tracking-tight text-white sm:text-xl">
              Scout Performans Grafiği
            </h2>
            <p className="mt-1 text-xs leading-5 text-white/42 sm:text-[13px]">
              Eklenen aday, ajans katılımı ve dönüşüm oranı birlikte gösterilir.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-2 sm:min-w-[300px]">
            <div className="rounded-xl border border-white/10 bg-black/30 px-3 py-2.5">
              <div className="text-[9px] font-bold uppercase tracking-[0.14em] text-white/35">Aday</div>
              <div className="mt-1 text-lg font-black text-white">{totalCandidates}</div>
            </div>
            <div className="rounded-xl border border-green-500/20 bg-green-500/[0.07] px-3 py-2.5">
              <div className="text-[9px] font-bold uppercase tracking-[0.14em] text-green-200/55">Katılım</div>
              <div className="mt-1 text-lg font-black text-green-300">{totalJoined}</div>
            </div>
            <div className="rounded-xl border border-yellow-500/20 bg-yellow-500/[0.08] px-3 py-2.5">
              <div className="text-[9px] font-bold uppercase tracking-[0.14em] text-yellow-200/55">Dönüşüm</div>
              <div className="mt-1 text-lg font-black text-yellow-300">%{averageRate}</div>
            </div>
          </div>
        </div>

        <div className="mt-5 max-h-[275px] space-y-3 overflow-y-auto pr-1 [scrollbar-color:rgba(234,179,8,.65)_rgba(255,255,255,.05)] [scrollbar-width:thin]">
          {orderedStats.length === 0 ? (
            <div className="rounded-xl border border-white/10 bg-black/25 p-4 text-sm text-white/40">
              Henüz scout verisi yok.
            </div>
          ) : (
            orderedStats.map((item, index) => {
              const width = Math.max(7, Math.round((item.total / maxValue) * 100));
              const joinedWidth = item.total > 0 ? Math.round((item.joined / item.total) * 100) : 0;

              return (
                <div
                  key={item.scout}
                  className="rounded-xl border border-white/[0.08] bg-black/25 px-3.5 py-3 transition hover:border-yellow-500/25 hover:bg-yellow-500/[0.035]"
                >
                  <div className="flex items-center gap-3">
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-yellow-500/25 bg-yellow-500/10 text-xs font-black text-yellow-300">
                      {index + 1}
                    </div>

                    <div className="min-w-0 flex-1">
                      <div className="flex items-center justify-between gap-3">
                        <div className="truncate text-sm font-black text-white">
                          {formatPersonName(item.scout || "Bilinmiyor")}
                        </div>
                        <div className="shrink-0 text-right text-[11px] text-white/42">
                          <span className="font-black text-white/75">{item.total}</span> aday
                          <span className="mx-1.5 text-white/20">•</span>
                          <span className="font-black text-green-300">{item.joined}</span> katılım
                          <span className="mx-1.5 text-white/20">•</span>
                          <span className="font-black text-yellow-300">%{item.rate}</span>
                        </div>
                      </div>

                      <div className="relative mt-2.5 h-2.5 overflow-hidden rounded-full bg-white/[0.07]">
                        <div
                          className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-yellow-700 via-yellow-500 to-yellow-300 shadow-[0_0_16px_rgba(234,179,8,.20)]"
                          style={{ width: `${width}%` }}
                        />
                        {joinedWidth > 0 && (
                          <div
                            className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-green-700 to-green-400 opacity-90"
                            style={{ width: `${Math.min(width, Math.max(3, (width * joinedWidth) / 100))}%` }}
                          />
                        )}
                      </div>

                      <div className="mt-1.5 flex items-center justify-between text-[9px] font-bold uppercase tracking-[0.12em] text-white/28">
                        <span>Aday hacmi</span>
                        <span>Katılım oranı %{item.rate}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

function MessagesView({ currentUser }) {
  const [templates, setTemplates] = useState(defaultMessageTemplates);
  const [activeCategory, setActiveCategory] = useState("pre_join");
  const [activeTemplateId, setActiveTemplateId] = useState("");
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [templateForm, setTemplateForm] = useState({
    id: "",
    category: "pre_join",
    title: "",
    body: "",
    sort_order: 100,
  });
  const [message, setMessage] = useState("");
  const canManageTemplates = isAdminLike(currentUser);

  useEffect(() => {
    loadTemplates();
  }, []);

  async function loadTemplates() {
    try {
      const res = await fetch(API_MESSAGE_TEMPLATES, { cache: "no-store" });
      const text = await res.text();

      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setTemplates(defaultMessageTemplates);
        return;
      }

      if (data.success && Array.isArray(data.templates) && data.templates.length > 0) {
        setTemplates(data.templates);
      } else {
        setTemplates(defaultMessageTemplates);
      }
    } catch {
      setTemplates(defaultMessageTemplates);
    }
  }

  function openTemplateModal(template = null, category = activeCategory) {
    if (!canManageTemplates) return;

    const next = template || {
      id: "",
      category,
      title: "",
      body: "",
      sort_order: 100,
    };

    setEditingTemplate(template || { id: "" });
    setTemplateForm({
      id: next.id || "",
      category: next.category || category,
      title: next.title || "",
      body: next.body || "",
      sort_order: Number(next.sort_order || 100),
    });
  }

  function closeTemplateModal() {
    setEditingTemplate(null);
    setTemplateForm({
      id: "",
      category: activeCategory,
      title: "",
      body: "",
      sort_order: 100,
    });
  }

  async function saveTemplate(e) {
    e.preventDefault();

    if (!templateForm.title.trim()) {
      setMessage("Şablon başlığı zorunludur.");
      return;
    }

    if (!templateForm.body.trim()) {
      setMessage("Şablon mesaj metni zorunludur.");
      return;
    }

    const payload = {
      action: "save",
      id: templateForm.id,
      category: templateForm.category,
      title: templateForm.title,
      body: templateForm.body,
      sort_order: Number(templateForm.sort_order || 100),
      created_by_user_id: currentUser?.id || null,
      created_by_username: currentUser?.username || "",
    };

    try {
      const res = await fetch(API_MESSAGE_TEMPLATES, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        setMessage("Şablon API JSON dönmedi: " + text.slice(0, 300));
        return;
      }

      if (!data.success) {
        setMessage(data.message || "Şablon kaydedilemedi.");
        return;
      }

      closeTemplateModal();
      setMessage("Şablon kaydedildi.");
      loadTemplates();
    } catch {
      setMessage("Şablon kaydedilirken bağlantı hatası oluştu.");
    }
  }

  async function deleteTemplate(template) {
    if (!canManageTemplates || !template?.id) return;

    if (String(template.id).startsWith("default-")) {
      setMessage("Varsayılan şablon silinemez. Düzenlemek için önce kaydedilmiş özel şablon oluşturun.");
      return;
    }

    const ok = window.confirm(`“${template.title}” şablonu silinsin mi?`);
    if (!ok) return;

    try {
      const res = await fetch(API_MESSAGE_TEMPLATES, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", id: template.id }),
      });

      const data = await res.json();
      if (!data.success) {
        setMessage(data.message || "Şablon silinemedi.");
        return;
      }

      setMessage("Şablon silindi.");
      loadTemplates();
    } catch {
      setMessage("Şablon silinirken bağlantı hatası oluştu.");
    }
  }

  function copyTemplate(template) {
    const text = template.body || "";
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
      setMessage("Mesaj panoya kopyalandı.");
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    setMessage("Mesaj panoya kopyalandı.");
  }

  const groupedTemplates = messageCategoryOptions.map((category) => ({
    ...category,
    templates: templates
      .filter((item) => item.category === category.key)
      .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0)),
  }));

  const currentCategory = groupedTemplates.find((item) => item.key === activeCategory) || groupedTemplates[0];
  const selectedTemplate =
    currentCategory.templates.find((item) => String(item.id) === String(activeTemplateId)) ||
    currentCategory.templates[0] ||
    null;

  return (
    <section className="py-8">
      <PageTitle
        badge="HAZIR MESAJLAR"
        title="Mesaj Şablon Merkezi"
        desc="Scout ve yönetici ekibinin adaylarla iletişimde kullanacağı profesyonel mesajları kategori ve konu bazlı yönetin."
      />

      {message && (
        <div className="mb-5 rounded-2xl border border-yellow-500/25 bg-yellow-500/10 px-5 py-3 text-sm font-semibold text-yellow-100">
          {message}
        </div>
      )}

      <div className="mb-5 rounded-[1.8rem] border border-yellow-500/20 bg-white/[0.025] p-4">
        <div className="mb-3 text-xs font-black uppercase tracking-[0.28em] text-yellow-300">
          Filtre Alanı
        </div>

        <div className="grid gap-3 lg:grid-cols-3">
          {groupedTemplates.map((category) => {
            const active = activeCategory === category.key;

            return (
              <button
                key={category.key}
                type="button"
                onClick={() => {
                  setActiveCategory(category.key);
                  setActiveTemplateId("");
                }}
                className={`scout-choice-card rounded-xl border p-4 text-left transition ${
                  active ? "is-active" : ""
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="scout-choice-title text-base font-semibold">{category.label}</div>
                    <p className="mt-1 line-clamp-2 text-xs leading-5 text-white/45">{category.desc}</p>
                  </div>
                  <span className="rounded-full border border-yellow-400/30 bg-yellow-500/15 px-3 py-1 text-xs font-black text-yellow-200">
                    {category.templates.length}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <div className="rounded-[1.8rem] border border-yellow-500/20 bg-white/[0.035] p-5">
        <div className="mb-5 flex flex-wrap items-start justify-between gap-4">
          <div>
            <div className="text-xs font-black uppercase tracking-[0.28em] text-yellow-300">
              {currentCategory.label}
            </div>
            <h2 className="mt-2 text-xl font-black text-white sm:text-2xl">Konu ve Mesaj Detayı</h2>
            <p className="mt-2 max-w-3xl text-sm leading-6 text-white/45">
              Soldan konu başlığını seç, sağ tarafta mesaj metnini hızlıca görüntüle. Değişken alanlar: <span className="text-yellow-200">{`{aday}`}</span>, <span className="text-yellow-200">{`{red_tarihi}`}</span>, <span className="text-yellow-200">{`{lig}`}</span>, <span className="text-yellow-200">{`{telefon}`}</span>.
            </p>
          </div>

          {canManageTemplates && (
            <button
              type="button"
              onClick={() => openTemplateModal(null, activeCategory)}
              className="rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black"
            >
              Yeni Şablon Ekle
            </button>
          )}
        </div>

        <div className="grid gap-4 xl:grid-cols-[390px_1fr]">
          <div className="rounded-[1.4rem] border border-white/10 bg-black/25 p-3">
            <div className="mb-3 px-2 text-xs font-black uppercase tracking-[0.22em] text-white/35">
              Konular
            </div>

            <div className="space-y-2">
              {currentCategory.templates.length === 0 ? (
                <div className="rounded-2xl border border-white/10 bg-white/[0.025] p-4 text-sm text-white/40">
                  Bu kategoride şablon bulunmuyor.
                </div>
              ) : (
                currentCategory.templates.map((template) => {
                  const active = selectedTemplate && String(selectedTemplate.id) === String(template.id);

                  return (
                    <button
                      key={template.id}
                      type="button"
                      onClick={() => setActiveTemplateId(template.id)}
                      className={`scout-template-card w-full rounded-xl border p-4 text-left transition ${
                        active ? "is-active" : ""
                      }`}
                    >
                      <div className="flex items-center justify-between gap-3">
                        <div className="scout-choice-title font-semibold">{template.title}</div>
                        <span className="scout-count rounded-full border px-2 py-1 text-[10px] font-medium">
                          Sıra {template.sort_order || 100}
                        </span>
                      </div>
                      <p className="mt-2 line-clamp-2 text-xs leading-5 text-white/45">
                        {template.body}
                      </p>
                    </button>
                  );
                })
              )}
            </div>
          </div>

          <div className="rounded-[1.4rem] border border-yellow-500/20 bg-black/30 p-5">
            {!selectedTemplate ? (
              <div className="rounded-2xl border border-white/10 bg-black/25 p-5 text-sm text-white/40">
                Görüntülenecek mesaj şablonu bulunmuyor.
              </div>
            ) : (
              <>
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <div className="text-xs font-black uppercase tracking-[0.24em] text-yellow-300">
                      Mesaj Detayı
                    </div>
                    <h3 className="mt-2 text-xl font-semibold text-yellow-200 sm:text-2xl">
                      {selectedTemplate.title}
                    </h3>
                    <div className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-white/30">
                      Sıra: {selectedTemplate.sort_order || 100} • {currentCategory.label}
                    </div>
                  </div>

                  <span className="rounded-full border border-white/10 bg-white/[0.035] px-3 py-1 text-[10px] font-black text-white/45">
                    {messageCategoryOptions.find((item) => item.key === selectedTemplate.category)?.label || selectedTemplate.category}
                  </span>
                </div>

                <div className="mt-5 min-h-[190px] rounded-2xl border border-white/10 bg-black/40 p-5">
                  <p className="whitespace-pre-wrap text-sm leading-7 text-white/70">
                    {selectedTemplate.body}
                  </p>
                </div>

                <div className="mt-5 flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => copyTemplate(selectedTemplate)}
                    className="rounded-xl border border-yellow-500/25 bg-yellow-500/10 px-4 py-2 text-xs font-black text-yellow-300"
                  >
                    Kopyala
                  </button>

                  {canManageTemplates && (
                    <>
                      <button
                        type="button"
                        onClick={() => openTemplateModal(selectedTemplate, selectedTemplate.category)}
                        className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-black text-white/65"
                      >
                        Düzenle
                      </button>

                      <button
                        type="button"
                        onClick={() => deleteTemplate(selectedTemplate)}
                        className="rounded-xl border border-red-500/25 bg-red-500/10 px-4 py-2 text-xs font-black text-red-300"
                      >
                        Sil
                      </button>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {editingTemplate !== null && (
        <MessageTemplateModal
          form={templateForm}
          setForm={setTemplateForm}
          save={saveTemplate}
          close={closeTemplateModal}
        />
      )}
    </section>
  );
}

function MessageTemplateModal({ form, setForm, save, close }) {
  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4">
      <div className="max-h-[90vh] w-full max-w-[760px] overflow-y-auto rounded-[2rem] border border-yellow-500/25 bg-[#080808] p-6 shadow-[0_25px_90px_rgba(0,0,0,.75)]">
        <div className="mb-5 flex items-start justify-between gap-4">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-yellow-300">
              Mesaj Şablonu
            </div>
            <h2 className="mt-2 text-2xl font-black text-white">
              {form.id ? "Şablonu Düzenle" : "Yeni Şablon Ekle"}
            </h2>
            <p className="mt-2 text-xs leading-5 text-white/45 sm:text-sm">
              Mesaj içinde {`{aday}`}, {`{red_tarihi}`}, {`{lig}`} gibi değişkenler kullanılabilir.
            </p>
          </div>

          <button
            type="button"
            onClick={close}
            className="rounded-xl border border-white/10 px-4 py-2 text-white/60 hover:text-white"
          >
            Kapat
          </button>
        </div>

        <form onSubmit={save} className="space-y-4">
          <div className="grid gap-4 md:grid-cols-[1fr_140px]">
            <SelectField
              label="Kategori"
              name="category"
              value={form.category}
              onChange={handleChange}
              options={messageCategoryOptions}
            />

            <Input
              label="Sıra"
              name="sort_order"
              value={form.sort_order}
              onChange={handleChange}
              type="number"
              placeholder="100"
            />
          </div>

          <Input
            label="Başlık"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Örn: İlk Davet Mesajı"
          />

          <label className="block">
            <span className="mb-1.5 block text-xs font-bold text-white/45">Mesaj Metni</span>
            <textarea
              name="body"
              value={form.body}
              onChange={handleChange}
              rows={8}
              className="w-full rounded-xl border border-white/10 bg-black/40 px-3 py-2.5 text-sm text-white outline-none placeholder:text-white/25 focus:border-yellow-500/35"
              placeholder="Mesaj metnini yazınız..."
            />
          </label>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={close}
              className="rounded-2xl border border-white/10 px-5 py-3 text-sm font-bold text-white/60"
            >
              İptal
            </button>
            <button
              type="submit"
              className="rounded-2xl bg-yellow-500 px-5 py-3 text-sm font-black text-black"
            >
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function BlacklistView({ rows = [], openWhatsapp }) {
  const rejectedRows = rows
    .filter((item) => item.status === "reddetti" || item.rejection_note || item.rejected_at)
    .sort((a, b) => String(b.rejected_at || b.updated_at || b.created_at || "").localeCompare(String(a.rejected_at || a.updated_at || a.created_at || "")));

  function copyMessage(candidate) {
    const message = buildRecoveryMessage(candidate);

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(message);
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = message;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }

  function openRecoveryWhatsapp(candidate) {
    const phone = String(candidate.phone || "").replace(/\D/g, "");
    if (!phone) return;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(buildRecoveryMessage(candidate))}`,
      "_blank",
      "noopener,noreferrer"
    );
  }

  return (
    <section className="py-8">
      <PageTitle
        badge="RED SÜREÇLERİ TAKİBİ"
        title="Reddeden / Reddedilen Adaylar"
        desc="Ajansa katılımı olumsuz sonuçlanan adayların red nedenlerini, geçmiş görüşmelerini ve yeniden değerlendirme süreçlerini takip edin."
      />

      <div className="rounded-[1.6rem] border border-yellow-500/20 bg-white/[0.035] p-5">
        <div className="mb-4 flex items-start justify-between gap-4">
          <div>
            <div className="text-lg font-semibold text-yellow-300">Reddeden / Reddedilen Adaylar</div>
            <p className="mt-1 text-sm leading-6 text-white/45">
              Red nedeni, görüşme geçmişi ve gerekiyorsa yeniden değerlendirme aksiyonları bu alanda izlenir.
            </p>
          </div>
          <span className="rounded-full border border-yellow-400/30 bg-yellow-500/15 px-3 py-1 text-xs font-black text-yellow-200">
            {rejectedRows.length} aday
          </span>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[1380px] text-left text-sm">
            <thead>
              <tr className="border-b border-white/10 text-xs font-black uppercase tracking-[0.18em] text-white/35">
                <th className="px-4 py-4">Aday</th>
                <th className="px-4 py-4">Lig</th>
                <th className="px-4 py-4">Ekleyen</th>
                <th className="px-4 py-4">Telefon</th>
                <th className="px-4 py-4">Uygunluk Durumu</th>
                <th className="px-4 py-4 text-red-300">Red Detayı</th>
                <th className="px-4 py-4">Hazır Mesaj</th>
                <th className="px-4 py-4">İşlem</th>
              </tr>
            </thead>

            <tbody>
              {rejectedRows.length === 0 ? (
                <tr>
                  <td colSpan="8" className="px-4 py-6 text-white/40">
                    Reddeden aday kaydı bulunmuyor.
                  </td>
                </tr>
              ) : (
                rejectedRows.map((item) => {
                  const message = buildRecoveryMessage(item);
                  const hasPhone = Boolean(String(item.phone || "").replace(/\D/g, ""));

                  return (
                    <tr key={item.id} className="border-b border-white/5 align-top hover:bg-yellow-500/[0.035]">
                      <td className="px-4 py-4">
                        <CandidateIdentity candidate={item} />
                        <div className="mt-1 text-[11px] font-bold text-white/35">
                          Red tarihi: {formatDateTr(item.rejected_at || item.updated_at || item.created_at)}
                        </div>
                      </td>

                      <td className="px-4 py-4"><LeagueBadge league={item.candidate_league} /></td>
                      <td className="px-4 py-4 text-white/60">{item.owner_username || item.created_by_username || "-"}</td>
                      <td className="px-4 py-4 text-white/55">{item.phone || "-"}</td>
                      <td className="px-4 py-4"><SuitabilityBadge value={item.suitability_status} /></td>
                      <td className="max-w-[260px] px-4 py-4 text-red-200/80">
                        <div className="line-clamp-3">{item.rejection_note || item.status_note || "Red detayı yok"}</div>
                      </td>
                      <td className="max-w-[420px] px-4 py-4 text-white/50">
                        <div className="rounded-2xl border border-white/10 bg-black/25 p-3 text-xs leading-5">
                          {message}
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex flex-col gap-2">
                          <button
                            type="button"
                            onClick={() => copyMessage(item)}
                            className="rounded-xl border border-yellow-500/25 bg-yellow-500/10 px-3 py-2 text-xs font-black text-yellow-300"
                          >
                            Mesajı Kopyala
                          </button>
                          <button
                            type="button"
                            disabled={!hasPhone}
                            onClick={() => openRecoveryWhatsapp(item)}
                            className="rounded-xl border border-green-500/25 bg-green-500/10 px-3 py-2 text-xs font-black text-green-300 disabled:cursor-not-allowed disabled:opacity-40"
                          >
                            WhatsApp Aç
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}

function ReportsView({ metrics, scoutStats }) {
  return (
    <section className="py-8">
      <PageTitle badge="RAPORLAR" title="Scout Operasyon Raporları" desc="Öncelikli adaylar, yeni eklenenler, beklemede olanlar ve scout dönüşüm oranları." />
      <section className="grid gap-4 md:grid-cols-5">
        <MetricCard title="Toplam" value={metrics.total} note="Aday" />
        <MetricCard title="Bugün" value={metrics.todayAdded} note="Eklenen" />
        <MetricCard title="Öncelikli" value={metrics.priorityNew} note="Öncelikli aday" />
        <MetricCard title="Beklemede" value={metrics.pending} note="Takip isteyen" />
        <MetricCard title="Dönüşüm" value={`%${metrics.joinRate}`} note="Ajansa katılım" />
      </section>
      <div className="mt-5"><ScoutGraphPanel scoutStats={scoutStats} /></div>
    </section>
  );
}

function ScoutSidebar({ activeSection, setActiveSection, onLogout, currentUser, usingDemoData }) {
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("wm-scout-sidebar-collapsed") === "true";
  });

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      if (typeof window !== "undefined") {
        localStorage.setItem("wm-scout-sidebar-collapsed", String(next));
      }
      return next;
    });
  };

  const menuItems = [
    {
      id: "dashboard",
      title: "Scout Takip Merkezi",
      badge: "Canlı",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/>
        </svg>
      )
    },
    {
      id: "pool",
      title: "Aday Havuzu",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )
    },
    {
      id: "scout_followup",
      title: "Scout Personelleri",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/><line x1="16" x2="16" y1="2" y2="6"/><line x1="8" x2="8" y1="2" y2="6"/><line x1="3" x2="21" y1="10" y2="10"/>
        </svg>
      )
    },
    {
      id: "publisher_management",
      title: "Yayıncı Yönetimi",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
        </svg>
      )
    },
    {
      id: "messages",
      title: "Hazır Mesajlar",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      )
    },
    {
      id: "blacklist",
      title: "Kara Liste & Red",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="4.93" x2="19.07" y1="4.93" y2="19.07"/>
        </svg>
      )
    },
    {
      id: "reports",
      title: "Raporlar",
      iconSvg: (
        <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3v18h18"/><path d="m19 9-5 5-4-4-3 3"/>
        </svg>
      )
    },
  ];

  return (
    <aside
      className={`sticky top-0 hidden h-screen shrink-0 border-r transition-all duration-300 ease-in-out backdrop-blur-xl lg:flex flex-col justify-between z-40 ${
        collapsed ? "w-[76px] p-2.5" : "w-[260px] p-4"
      } border-slate-200 dark:border-white/10 bg-white/95 dark:bg-black/85 shadow-sm`}
    >
      {/* 🚀 ÜST LOGO / BAŞLIK ALANI */}
      <div className="shrink-0 pb-3 border-b border-slate-200 dark:border-white/10">
        {collapsed ? (
          <button
            type="button"
            onClick={toggleCollapsed}
            title="Kenar çubuğunu genişlet"
            className="flex h-11 w-11 mx-auto items-center justify-center rounded-2xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.04] hover:bg-slate-100 dark:hover:bg-white/10 transition shadow-sm"
          >
            <img src="/wolf-head.png" alt="Wolf Media" className="h-8 w-8 object-contain" />
          </button>
        ) : (
          <div className="flex items-center justify-between px-1">
            <div className="flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.04] shadow-sm">
                <img src="/wolf-head.png" alt="Wolf Media" className="h-7 w-7 object-contain" />
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="font-black text-sm tracking-tight text-slate-900 dark:text-white">WOLF MEDIA</span>
                  <span className="rounded bg-yellow-500/20 border border-yellow-500/30 px-1 py-0.2 text-[9px] font-extrabold text-amber-700 dark:text-yellow-300">SCOUT</span>
                </div>
                <div className="text-[11px] font-semibold text-slate-500 dark:text-white/40 truncate">TikTok LIVE Backstage</div>
              </div>
            </div>
            <button
              type="button"
              onClick={toggleCollapsed}
              title="Kenar çubuğunu daralt"
              className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-white/[0.04] text-slate-600 dark:text-white/60 hover:bg-slate-200 dark:hover:bg-white/10 transition"
            >
              ◧
            </button>
          </div>
        )}
      </div>

      {/* 📋 MENÜ LİSTESİ */}
      <div className="my-3 flex-1 overflow-y-auto space-y-1.5 pr-0.5 custom-scrollbar">
        {menuItems.map((item) => {
          const active = activeSection === item.id;

          if (collapsed) {
            return (
              <div key={item.id} className="flex justify-center py-0.5">
                <button
                  type="button"
                  onClick={() => setActiveSection(item.id)}
                  title={item.title}
                  className={`flex h-11 w-11 items-center justify-center rounded-2xl transition ${
                    active
                      ? "bg-amber-500 text-black font-black shadow-md scale-105"
                      : "border border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.03] text-slate-700 dark:text-white/70 hover:border-yellow-500 hover:text-amber-600"
                  }`}
                >
                  {item.iconSvg}
                </button>
              </div>
            );
          }

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveSection(item.id)}
              className={`flex w-full items-center justify-between rounded-xl border px-3.5 py-2.5 text-left text-xs font-bold transition shadow-sm ${
                active
                  ? "border-yellow-500 bg-yellow-500 text-black font-black shadow-md"
                  : "border-slate-200 dark:border-white/10 bg-white dark:bg-white/[0.025] text-slate-800 dark:text-white/80 hover:border-yellow-500/40 hover:bg-slate-50 dark:hover:bg-white/[0.05]"
              }`}
            >
              <div className="flex items-center gap-2.5">
                <span className={active ? "text-black" : "text-slate-600 dark:text-white/70"}>{item.iconSvg}</span>
                <span>{item.title}</span>
              </div>
              {item.badge && (
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-black ${
                  active ? "bg-black/20 text-black" : "border border-yellow-500/30 bg-yellow-500/15 text-amber-700 dark:text-yellow-300"
                }`}>
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* 👤 ALT KULLANICI / ÇIKIŞ ALANI */}
      <div className="shrink-0 border-t border-slate-200 dark:border-white/10 pt-3">
        {!collapsed ? (
          <div className="flex items-center justify-between px-1">
            <div className="min-w-0">
              <div className="text-[10px] font-bold text-slate-500 dark:text-white/40">Giriş Yapıldı</div>
              <div className="truncate text-xs font-black text-slate-900 dark:text-white">
                {currentUser?.fullName || currentUser?.username || "Scout Personeli"}
              </div>
            </div>
            <button
              type="button"
              onClick={onLogout}
              title="Çıkış Yap"
              className="rounded-lg border border-red-200 dark:border-red-500/20 bg-red-50 dark:bg-red-500/10 px-2.5 py-1.5 text-[11px] font-black text-red-900 dark:text-red-300 hover:bg-red-500 hover:text-white transition"
            >
              Çıkış
            </button>
          </div>
        ) : (
          <div className="flex justify-center">
            <button
              type="button"
              onClick={onLogout}
              title="Çıkış Yap"
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-red-200 dark:border-red-500/20 bg-red-50 dark:bg-red-500/10 text-red-600 hover:bg-red-500 hover:text-white transition"
            >
              🚪
            </button>
          </div>
        )}
      </div>
    </aside>
  );
}

function ScoutMobileNav({ activeSection, setActiveSection, onLogout, currentUser }) {
  const [open, setOpen] = useState(false);
  const menuItems = [
    { id: "dashboard", title: "Scout Takip Merkezi" },
    { id: "pool", title: "Aday Havuzu" },
    { id: "scout_followup", title: "Scout Personelleri" },
    { id: "publisher_management", title: "Yayıncı Yönetimi" },
    { id: "messages", title: "Hazır Mesajlar" },
    { id: "blacklist", title: "Kara Liste & Red" },
    { id: "reports", title: "Raporlar" },
  ];
  const activeTitle = menuItems.find((item) => item.id === activeSection)?.title || "Scout Merkezi";

  return (
    <div className="sticky top-0 z-40 -mx-3 mb-3 border-b border-slate-200 dark:border-white/10 bg-white/95 dark:bg-black/90 px-3 py-2.5 backdrop-blur lg:hidden sm:-mx-4 sm:px-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2.5">
          <img src="/wolf-head.png" alt="Wolf Media" className="h-8 w-8 object-contain" />
          <div className="min-w-0">
            <div className="truncate text-xs font-black text-slate-900 dark:text-white">{activeTitle}</div>
            <div className="truncate text-[10px] text-slate-500 dark:text-white/40">{currentUser?.fullName || currentUser?.username || "Scout"}</div>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="rounded-lg border border-slate-200 dark:border-white/10 bg-slate-100 dark:bg-white/[0.04] px-3 py-1.5 text-xs font-black text-slate-800 dark:text-white"
        >
          {open ? "Kapat" : "Menü"}
        </button>
      </div>

      {open && (
        <div className="mt-2 grid grid-cols-2 gap-2 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-2 shadow-xl">
          {menuItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => {
                setActiveSection(item.id);
                setOpen(false);
              }}
              className={`rounded-lg px-2.5 py-2 text-left text-xs font-bold ${
                activeSection === item.id
                  ? "bg-amber-500 text-black font-black"
                  : "text-slate-800 dark:text-white/70 hover:bg-slate-100 dark:hover:bg-white/5"
              }`}
            >
              {item.title}
            </button>
          ))}
          <button
            type="button"
            onClick={onLogout}
            className="col-span-2 rounded-lg bg-red-500/10 text-red-600 dark:text-red-400 px-3 py-2 text-xs font-black text-center"
          >
            Çıkış Yap
          </button>
        </div>
      )}
    </div>
  );
}

// ============================================================================
// HELPER COMPONENTS & MODALS
// ============================================================================

function buildScoutStats(rows) {
  const map = new Map();
  rows.forEach((item) => {
    const scout = item.owner_username || item.created_by_username || "Bilinmiyor";
    if (!map.has(scout)) {
      map.set(scout, { scout, total: 0, aLeague: 0, bLeague: 0, suitable: 0, joined: 0 });
    }
    const current = map.get(scout);
    current.total += 1;
    const leagueGroup = String(item.candidate_league || "").charAt(0).toUpperCase();
    if (leagueGroup === "A") current.aLeague += 1;
    if (leagueGroup === "B") current.bLeague += 1;
    if (item.suitability_status === "uygun") current.suitable += 1;
    if (item.status === "ajansa_katildi") current.joined += 1;
  });
  return Array.from(map.values())
    .map((item) => ({ ...item, rate: item.total > 0 ? Math.round((item.joined / item.total) * 100) : 0 }))
    .sort((a, b) => b.total - a.total);
}

function CandidateIdentity({ candidate, onOpen, compact = false }) {
  const clean = String(candidate.tiktok_username || "").replace(/^@/, "");
  return (
    <button type="button" onClick={onOpen} className={`flex min-w-0 items-center text-left ${compact ? "gap-2" : "gap-2.5"}`}>
      <Avatar username={candidate.tiktok_username} imageUrl={candidate.profile_image_url} compact={compact} />
      <div className="min-w-0">
        <div className="truncate font-black text-xs text-slate-900 dark:text-white">
          @{clean || "-"}
        </div>
        <div className="truncate text-[10px] text-slate-500 dark:text-white/40">
          {candidate.display_name || clean} {candidate.follower_count ? `• ${candidate.follower_count}` : ""}
        </div>
      </div>
    </button>
  );
}

function LeagueBadge({ league }) {
  const value = league || "A3";
  return (
    <span className="inline-flex items-center rounded-lg border border-amber-400/40 bg-amber-50 dark:bg-amber-500/10 px-2 py-0.5 text-[11px] font-black text-amber-900 dark:text-yellow-300">
      {value} Ligi
    </span>
  );
}

function StatusBadge({ status }) {
  const isJoined = status === "ajansa_katildi";
  const isRejected = status === "reddetti" || status === "olumsuz";
  
  if (isJoined) {
    return (
      <span className="inline-flex items-center rounded-lg border border-emerald-400 bg-emerald-50 dark:bg-emerald-500/10 px-2 py-0.5 text-[11px] font-black text-emerald-950 dark:text-emerald-300">
        🏆 Ajansa Katıldı
      </span>
    );
  }
  if (isRejected) {
    return (
      <span className="inline-flex items-center rounded-lg border border-red-400 bg-red-50 dark:bg-red-500/10 px-2 py-0.5 text-[11px] font-black text-red-950 dark:text-red-300">
        ❌ Reddedildi
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-lg border border-amber-400 bg-amber-50 dark:bg-amber-500/10 px-2 py-0.5 text-[11px] font-black text-amber-950 dark:text-yellow-300">
      ⏳ Süreçte
    </span>
  );
}

function SuitabilityBadge({ value }) {
  const key = value || "beklemede";
  if (key === "uygun") {
    return (
      <span className="inline-flex items-center rounded-lg border border-emerald-400 bg-emerald-50 dark:bg-emerald-500/10 px-2 py-0.5 text-[11px] font-black text-emerald-950 dark:text-emerald-300">
        ✅ Uygun (Ajanssız)
      </span>
    );
  }
  if (key === "baska_ajansa_bagli") {
    return (
      <span className="inline-flex items-center rounded-lg border border-red-400 bg-red-50 dark:bg-red-500/10 px-2 py-0.5 text-[11px] font-black text-red-950 dark:text-red-300">
        ⛔ Başka Ajansa Bağlı
      </span>
    );
  }
  return (
    <span className="inline-flex items-center rounded-lg border border-slate-300 dark:border-white/20 bg-slate-50 dark:bg-white/[0.04] px-2 py-0.5 text-[11px] font-bold text-slate-800 dark:text-white/80">
      ⏳ Beklemede
    </span>
  );
}

function PageTitle({ badge, title, desc }) {
  return (
    <div className="mb-4">
      {badge && (
        <div className="mb-1 text-[10px] font-black uppercase tracking-[0.22em] text-amber-600 dark:text-yellow-400">
          {badge}
        </div>
      )}
      <h1 className="text-2xl font-black tracking-tight text-slate-900 dark:text-white">
        {title}
      </h1>
      {desc && <p className="mt-1 text-xs font-medium text-slate-600 dark:text-white/60">{desc}</p>}
    </div>
  );
}

function MetricCard({ title, value, note }) {
  return (
    <div className="rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-4 shadow-sm">
      <div className="text-xs font-bold text-slate-500 dark:text-white/50">{title}</div>
      <div className="mt-1.5 text-2xl font-black text-slate-900 dark:text-white">
        {typeof value === "string" ? value : value || 0}
      </div>
      {note && <div className="mt-1 text-[11px] font-semibold text-slate-400 dark:text-white/40">{note}</div>}
    </div>
  );
}

function Input({ label, name, value, onChange, type = "text", placeholder = "", disabled = false }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-bold text-slate-700 dark:text-white/70">{label}</span>
      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder || label}
        disabled={disabled}
        className="w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2 text-xs font-medium text-slate-900 dark:text-white outline-none focus:border-amber-500 disabled:opacity-60 shadow-xs"
      />
    </label>
  );
}

function TextArea({ label, name, value, onChange, placeholder = "" }) {
  return (
    <label className="block md:col-span-2">
      <span className="mb-1 block text-xs font-bold text-slate-700 dark:text-white/70">{label}</span>
      <textarea
        name={name}
        value={value || ""}
        onChange={onChange}
        rows={3}
        className="w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2 text-xs font-medium text-slate-900 dark:text-white outline-none focus:border-amber-500 shadow-xs resize-none"
        placeholder={placeholder || label}
      />
    </label>
  );
}

function SelectField({ label, name, value, onChange, options = [], empty = "" }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-bold text-slate-700 dark:text-white/70">{label}</span>
      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        className="w-full rounded-lg border border-slate-300 dark:border-white/20 bg-white dark:bg-[#18181b] px-3 py-2 text-xs font-bold text-slate-900 dark:text-white outline-none focus:border-amber-500 shadow-xs"
      >
        {empty && <option value="">{empty}</option>}
        {options.map((item) => (
          <option key={item.key || item} value={item.key || item}>{item.label || item}</option>
        ))}
      </select>
    </label>
  );
}

function CandidateFormModal({ isOpen, close, onSubmit, candidate, saving, form, setForm, currentUser }) {
  if (!isOpen) return null;

  const isEditing = Boolean(candidate);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-[#121215] p-5 shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-200 dark:border-white/10 pb-3">
          <div>
            <div className="text-[10px] font-black uppercase tracking-[0.2em] text-amber-600 dark:text-yellow-400">Scout Aday Formu</div>
            <h2 className="text-base font-black text-slate-900 dark:text-white">
              {isEditing ? "Aday Bilgilerini Düzenle" : "Yeni Yayıncı Adayı Ekle"}
            </h2>
          </div>
          <button type="button" onClick={close} className="rounded-lg p-1.5 text-slate-400 hover:text-black dark:hover:text-white">✕</button>
        </div>

        <form onSubmit={onSubmit} className="mt-4 space-y-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Input label="TikTok Kullanıcı Adı" name="tiktok_username" value={form.tiktok_username} onChange={handleChange} placeholder="@kullanici_adi" />
            <Input label="Görünen İsim" name="display_name" value={form.display_name} onChange={handleChange} placeholder="Ad Soyad veya Nick" />
            <Input label="Telefon" name="phone" value={form.phone} onChange={handleChange} placeholder="05..." />
            <SelectField label="Uygunluk Durumu" name="suitability_status" value={form.suitability_status} onChange={handleChange} options={[
              { key: "beklemede", label: "⏳ Beklemede" },
              { key: "uygun", label: "✅ Uygun (Ajanssız)" },
              { key: "baska_ajansa_bagli", label: "⛔ Başka Ajansa Bağlı" },
              { key: "uygun_degil", label: "❌ Kriter Dışı / Uygun Değil" }
            ]} />
            <SelectField label="Aday Ligi" name="candidate_league" value={form.candidate_league} onChange={handleChange} options={[
              { key: "A1", label: "A1 Ligi" },
              { key: "A2", label: "A2 Ligi" },
              { key: "A3", label: "A3 Ligi" },
              { key: "B1", label: "B1 Ligi" },
              { key: "B2", label: "B2 Ligi" },
              { key: "B3", label: "B3 Ligi" },
              { key: "B4", label: "B4 Ligi" },
              { key: "C1", label: "C1 Ligi" },
              { key: "C2", label: "C2 Ligi" },
              { key: "C3", label: "C3 Ligi" },
              { key: "C4", label: "C4 Ligi" }
            ]} />
            <SelectField label="Yayıncılık Deneyimi" name="publisher_experience" value={form.publisher_experience} onChange={handleChange} options={[
              { key: "yeni_yayinci", label: "Yeni Yayıncı (1-3 Ay)" },
              { key: "orta_yayinci", label: "Normal Yayıncı (3 Ay - 1 Yıl)" },
              { key: "eski_yayinci", label: "Tecrübeli Yayıncı (1+ Yıl)" }
            ]} />
            <TextArea label="Scout Değerlendirme Notu" name="suitability_note" value={form.suitability_note || form.first_note} onChange={handleChange} placeholder="Yayın kalitesi, kitle enerjisi, yeteneği hakkında not..." />
            <Input label="Hidden ID (Ajanstaki ID)" name="hidden_id" value={form.hidden_id} onChange={handleChange} placeholder="Opsiyonel Hidden ID" />
            <Input label="Randevu / Takip Tarihi" name="next_followup_at" type="datetime-local" value={form.next_followup_at} onChange={handleChange} />
          </div>

          <div className="mt-4 flex justify-end gap-2 border-t border-slate-200 dark:border-white/10 pt-3">
            <button type="button" onClick={close} className="rounded-xl border border-slate-300 dark:border-white/20 px-4 py-2 text-xs font-bold text-slate-700 dark:text-white/70">
              İptal
            </button>
            <button type="submit" disabled={saving} className="rounded-xl bg-amber-500 px-5 py-2 text-xs font-black text-black hover:bg-amber-400 disabled:opacity-50 transition shadow-sm">
              {saving ? "Kaydediliyor..." : isEditing ? "Güncelle" : "Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
